// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import {
  type CurrencyControllerVersionResponse,
  type AccountsControllerCreateData,
  type AccountsControllerCreateResponse,
  type AccountsControllerListAvailableAgentVersionsResponse,
  type AccountsControllerListAvailableServiceVersionsData,
  type AccountsControllerListAvailableServiceVersionsResponse,
  type AccountsControllerListMinimalData,
  type AccountsControllerListMinimalResponse,
  type AccountsControllerListSummariesData,
  type AccountsControllerListSummariesResponse,
  type AccountsControllerFindOneData,
  type AccountsControllerFindOneResponse,
  type AccountsControllerUpdateByIdData,
  type AccountsControllerUpdateByIdResponse,
  type AccountsControllerUpdateIsActiveBulkData,
  type AccountsControllerUpdateIsActiveBulkResponse,
  type AccountsControllerUpdateData,
  type AccountsControllerUpdateResponse,
  type AccountsControllerUpsertDefaultOperationalHoursData,
  type AccountsControllerUpsertDefaultOperationalHoursResponse,
  type AlertsControllerEmitTestAlertData,
  type AlertsControllerEmitTestAlertResponse,
  type AlertsControllerUpdateAccountAlertData,
  type AlertsControllerUpdateAccountAlertResponse,
  type AlertsControllerListAlertChannelsResponse,
  type AlertsControllerCreateAlertChannelData,
  type AlertsControllerCreateAlertChannelResponse,
  type AlertsControllerListAlertDeliveriesData,
  type AlertsControllerListAlertDeliveriesResponse,
  type AlertsControllerCreateGlobalAlertChannelData,
  type AlertsControllerCreateGlobalAlertChannelResponse,
  type AlertsControllerUpdateAlertChannelData,
  type AlertsControllerUpdateAlertChannelResponse,
  type AlertsControllerDeleteAlertChannelData,
  type AlertsControllerDeleteAlertChannelResponse,
  type AlertsControllerUpdateGlobalAlertChannelData,
  type AlertsControllerUpdateGlobalAlertChannelResponse,
  type AlertsControllerDeleteGlobalAlertChannelData,
  type AlertsControllerDeleteGlobalAlertChannelResponse,
  type AlertsControllerListManagedAlertsData,
  type AlertsControllerListManagedAlertsResponse,
  type AlertsControllerDownloadManagedAlertsData,
  type AlertsControllerDownloadManagedAlertsResponse,
  type AlertsControllerListManagedAlertsGroupedByEventData,
  type AlertsControllerListManagedAlertsGroupedByEventResponse,
  type AlertsControllerUpdateManagedAlertStatusData,
  type AlertsControllerUpdateManagedAlertStatusResponse,
  type AlertsControllerUpdateManagedAlertStatusBulkData,
  type AlertsControllerUpdateManagedAlertStatusBulkResponse,
  type AlertsControllerListAlertsData,
  type AlertsControllerListAlertsResponse,
  type AlertsControllerGetAlertByIdData,
  type AlertsControllerGetAlertByIdResponse,
  type AlertsControllerUpdateAlertData,
  type AlertsControllerUpdateAlertResponse,
  type AlertsControllerUpdateAlertSubscriptionsData,
  type AlertsControllerUpdateAlertSubscriptionsResponse,
  AlertsControllerGetAlertByIdResponseTransformer,
  type AuthControllerLoginData,
  type AuthControllerLoginResponse,
  type AuthControllerLogoutResponse,
  type AuthControllerMagicCallbackResponse,
  type AuthControllerCallbackResponse,
  type AuthControllerOidcCallbackResponse,
  type AuthControllerAccountSwitchData,
  type AuthControllerAccountSwitchResponse,
  type CameraCalibrationControllerCreateScheduleData,
  type CameraCalibrationControllerCreateScheduleResponse,
  type CameraCalibrationControllerListScheduledData,
  type CameraCalibrationControllerListScheduledResponse,
  type CameraCalibrationControllerGetScheduledJobData,
  type CameraCalibrationControllerGetScheduledJobResponse,
  type CameraCalibrationControllerUpdateScheduledJobData,
  type CameraCalibrationControllerUpdateScheduledJobResponse,
  type CameraCalibrationControllerDeleteScheduledJobData,
  type CameraCalibrationControllerDeleteScheduledJobResponse,
  type CameraCalibrationControllerCancelScheduledJobsBulkData,
  type CameraCalibrationControllerCancelScheduledJobsBulkResponse,
  type CameraCalibrationControllerStopScheduledJobsBulkData,
  type CameraCalibrationControllerStopScheduledJobsBulkResponse,
  type CameraCalibrationControllerResumeScheduledJobsBulkData,
  type CameraCalibrationControllerResumeScheduledJobsBulkResponse,
  type CameraCalibrationControllerDeleteScheduledJobsBulkData,
  type CameraCalibrationControllerDeleteScheduledJobsBulkResponse,
  type CameraCalibrationControllerStartScheduledJobData,
  type CameraCalibrationControllerStartScheduledJobResponse,
  type CameraCalibrationControllerCancelScheduledJobData,
  type CameraCalibrationControllerCancelScheduledJobResponse,
  type CameraCalibrationControllerStopScheduledJobData,
  type CameraCalibrationControllerStopScheduledJobResponse,
  type CameraCalibrationControllerResumeScheduledJobData,
  type CameraCalibrationControllerResumeScheduledJobResponse,
  type CameraCalibrationControllerStartJobData,
  type CameraCalibrationControllerStartJobResponse,
  type CameraCalibrationControllerListSummariesData,
  type CameraCalibrationControllerListSummariesResponse,
  type CameraCalibrationControllerGetJobData,
  type CameraCalibrationControllerGetJobResponse,
  type CameraCalibrationControllerDeleteJobData,
  type CameraCalibrationControllerDeleteJobResponse,
  type CameraCalibrationControllerUpdateJobData,
  type CameraCalibrationControllerUpdateJobResponse,
  type CameraCalibrationControllerCancelJobData,
  type CameraCalibrationControllerCancelJobResponse,
  type CameraCalibrationControllerStopJobData,
  type CameraCalibrationControllerStopJobResponse,
  type CameraCalibrationControllerCancelJobsBulkData,
  type CameraCalibrationControllerCancelJobsBulkResponse,
  type CameraCalibrationControllerDeleteJobsBulkData,
  type CameraCalibrationControllerDeleteJobsBulkResponse,
  CameraCalibrationControllerCreateScheduleResponseTransformer,
  CameraCalibrationControllerGetScheduledJobResponseTransformer,
  CameraCalibrationControllerUpdateScheduledJobResponseTransformer,
  CameraCalibrationControllerStartScheduledJobResponseTransformer,
  CameraCalibrationControllerResumeScheduledJobResponseTransformer,
  CameraCalibrationControllerStartJobResponseTransformer,
  CameraCalibrationControllerGetJobResponseTransformer,
  CameraCalibrationControllerUpdateJobResponseTransformer,
  type CapacityTaggingControllerPreCheckData,
  type CapacityTaggingControllerPreCheckResponse,
  type CapacityTaggingControllerCreateScheduleData,
  type CapacityTaggingControllerCreateScheduleResponse,
  type CapacityTaggingControllerListScheduledData,
  type CapacityTaggingControllerListScheduledResponse,
  type CapacityTaggingControllerGetScheduledJobData,
  type CapacityTaggingControllerGetScheduledJobResponse,
  type CapacityTaggingControllerUpdateScheduledJobData,
  type CapacityTaggingControllerUpdateScheduledJobResponse,
  type CapacityTaggingControllerDeleteScheduledJobData,
  type CapacityTaggingControllerDeleteScheduledJobResponse,
  type CapacityTaggingControllerCancelScheduledJobsBulkData,
  type CapacityTaggingControllerCancelScheduledJobsBulkResponse,
  type CapacityTaggingControllerStopScheduledJobsBulkData,
  type CapacityTaggingControllerStopScheduledJobsBulkResponse,
  type CapacityTaggingControllerResumeScheduledJobsBulkData,
  type CapacityTaggingControllerResumeScheduledJobsBulkResponse,
  type CapacityTaggingControllerDeleteScheduledJobsBulkData,
  type CapacityTaggingControllerDeleteScheduledJobsBulkResponse,
  type CapacityTaggingControllerStartScheduledJobData,
  type CapacityTaggingControllerStartScheduledJobResponse,
  type CapacityTaggingControllerCancelScheduledJobData,
  type CapacityTaggingControllerCancelScheduledJobResponse,
  type CapacityTaggingControllerStopScheduledJobData,
  type CapacityTaggingControllerStopScheduledJobResponse,
  type CapacityTaggingControllerResumeScheduledJobData,
  type CapacityTaggingControllerResumeScheduledJobResponse,
  type CapacityTaggingControllerStartJobData,
  type CapacityTaggingControllerStartJobResponse,
  type CapacityTaggingControllerListSummariesData,
  type CapacityTaggingControllerListSummariesResponse,
  type CapacityTaggingControllerGetJobData,
  type CapacityTaggingControllerGetJobResponse,
  type CapacityTaggingControllerDeleteJobData,
  type CapacityTaggingControllerDeleteJobResponse,
  type CapacityTaggingControllerUpdateJobData,
  type CapacityTaggingControllerUpdateJobResponse,
  type CapacityTaggingControllerCancelJobData,
  type CapacityTaggingControllerCancelJobResponse,
  type CapacityTaggingControllerStopJobData,
  type CapacityTaggingControllerStopJobResponse,
  type CapacityTaggingControllerCancelJobsBulkData,
  type CapacityTaggingControllerCancelJobsBulkResponse,
  type CapacityTaggingControllerDeleteJobsBulkData,
  type CapacityTaggingControllerDeleteJobsBulkResponse,
  CapacityTaggingControllerPreCheckResponseTransformer,
  CapacityTaggingControllerCreateScheduleResponseTransformer,
  CapacityTaggingControllerGetScheduledJobResponseTransformer,
  CapacityTaggingControllerUpdateScheduledJobResponseTransformer,
  CapacityTaggingControllerStartScheduledJobResponseTransformer,
  CapacityTaggingControllerResumeScheduledJobResponseTransformer,
  CapacityTaggingControllerStartJobResponseTransformer,
  CapacityTaggingControllerGetJobResponseTransformer,
  CapacityTaggingControllerUpdateJobResponseTransformer,
  type CatalogControllerListLabelsData,
  type CatalogControllerListLabelsResponse,
  type CatalogControllerListMinimalData,
  type CatalogControllerListMinimalResponse,
  type CatalogControllerListFamiliesData,
  type CatalogControllerListFamiliesResponse,
  type CatalogControllerListSummariesData,
  type CatalogControllerListSummariesResponse,
  type CatalogControllerDownloadCatalogData,
  type CatalogControllerDownloadCatalogResponse,
  type CatalogControllerFindData,
  type CatalogControllerFindResponse,
  type CatalogControllerUpdateTagsBulkData,
  type CatalogControllerUpdateTagsBulkResponse,
  type CatalogControllerUpdateOutOfScopeBulkData,
  type CatalogControllerUpdateOutOfScopeBulkResponse,
  type CatalogControllerDeleteBulkData,
  type CatalogControllerDeleteBulkResponse,
  type CatalogControllerGetDetailsData,
  type CatalogControllerGetDetailsResponse,
  type CatalogControllerCreateData,
  type CatalogControllerCreateResponse,
  type CatalogControllerUpdateData,
  type CatalogControllerUpdateResponse,
  type CatalogControllerDeleteData,
  type CatalogControllerDeleteResponse,
  type CatalogControllerGetSitePricesData,
  type CatalogControllerGetSitePricesResponse,
  type CatalogControllerGetLabelsData,
  type CatalogControllerGetLabelsResponse,
  type CatalogControllerUploadData,
  type CatalogControllerUploadResponse,
  CatalogControllerGetDetailsResponseTransformer,
  CatalogControllerCreateResponseTransformer,
  CatalogControllerUpdateResponseTransformer,
  type CatalogTaggingControllerListTagsData,
  type CatalogTaggingControllerListTagsResponse,
  type CatalogTaggingControllerCreateTagsData,
  type CatalogTaggingControllerCreateTagsResponse,
  type CatalogTaggingControllerAssignTagsData,
  type CatalogTaggingControllerAssignTagsResponse,
  type CatalogTaggingControllerUnassignTagsData,
  type CatalogTaggingControllerUnassignTagsResponse,
  type CatalogTaggingControllerGetDetailsData,
  type CatalogTaggingControllerGetDetailsResponse,
  type CatalogTaggingControllerUpdateTagData,
  type CatalogTaggingControllerUpdateTagResponse,
  type CatalogTaggingControllerDeleteTagData,
  type CatalogTaggingControllerDeleteTagResponse,
  type CatalogTaggingControllerMergeTagToData,
  type CatalogTaggingControllerMergeTagToResponse,
  type CatalogTaggingControllerListSummariesData,
  type CatalogTaggingControllerListSummariesResponse,
  CatalogTaggingControllerGetDetailsResponseTransformer,
  CatalogTaggingControllerUpdateTagResponseTransformer,
  type CatalogUploadJobControllerGetScheduledJobData,
  type CatalogUploadJobControllerGetScheduledJobResponse,
  type CatalogUploadJobControllerUpdateScheduledJobData,
  type CatalogUploadJobControllerUpdateScheduledJobResponse,
  type CatalogUploadJobControllerDeleteScheduledJobData,
  type CatalogUploadJobControllerDeleteScheduledJobResponse,
  type CatalogUploadJobControllerGetJobData,
  type CatalogUploadJobControllerGetJobResponse,
  type CatalogUploadJobControllerDeleteJobData,
  type CatalogUploadJobControllerDeleteJobResponse,
  type CatalogUploadJobControllerUpdateJobData,
  type CatalogUploadJobControllerUpdateJobResponse,
  type CatalogUploadJobControllerGetJobDevicesData,
  type CatalogUploadJobControllerGetJobDevicesResponse,
  type CatalogUploadJobControllerCreateScheduleData,
  type CatalogUploadJobControllerCreateScheduleResponse,
  type CatalogUploadJobControllerListScheduledData,
  type CatalogUploadJobControllerListScheduledResponse,
  type CatalogUploadJobControllerCancelScheduledJobsBulkData,
  type CatalogUploadJobControllerCancelScheduledJobsBulkResponse,
  type CatalogUploadJobControllerStopScheduledJobsBulkData,
  type CatalogUploadJobControllerStopScheduledJobsBulkResponse,
  type CatalogUploadJobControllerResumeScheduledJobsBulkData,
  type CatalogUploadJobControllerResumeScheduledJobsBulkResponse,
  type CatalogUploadJobControllerDeleteScheduledJobsBulkData,
  type CatalogUploadJobControllerDeleteScheduledJobsBulkResponse,
  type CatalogUploadJobControllerStartScheduledJobData,
  type CatalogUploadJobControllerStartScheduledJobResponse,
  type CatalogUploadJobControllerCancelScheduledJobData,
  type CatalogUploadJobControllerCancelScheduledJobResponse,
  type CatalogUploadJobControllerStopScheduledJobData,
  type CatalogUploadJobControllerStopScheduledJobResponse,
  type CatalogUploadJobControllerResumeScheduledJobData,
  type CatalogUploadJobControllerResumeScheduledJobResponse,
  type CatalogUploadJobControllerStartJobData,
  type CatalogUploadJobControllerStartJobResponse,
  type CatalogUploadJobControllerListSummariesData,
  type CatalogUploadJobControllerListSummariesResponse,
  type CatalogUploadJobControllerCancelJobData,
  type CatalogUploadJobControllerCancelJobResponse,
  type CatalogUploadJobControllerStopJobData,
  type CatalogUploadJobControllerStopJobResponse,
  type CatalogUploadJobControllerCancelJobsBulkData,
  type CatalogUploadJobControllerCancelJobsBulkResponse,
  type CatalogUploadJobControllerDeleteJobsBulkData,
  type CatalogUploadJobControllerDeleteJobsBulkResponse,
  CatalogUploadJobControllerUpdateScheduledJobResponseTransformer,
  CatalogUploadJobControllerUpdateJobResponseTransformer,
  CatalogUploadJobControllerCreateScheduleResponseTransformer,
  CatalogUploadJobControllerStartScheduledJobResponseTransformer,
  CatalogUploadJobControllerResumeScheduledJobResponseTransformer,
  CatalogUploadJobControllerStartJobResponseTransformer,
  type ClustersControllerDownloadData,
  type ClustersControllerDownloadResponse,
  type ClustersControllerCreateData,
  type ClustersControllerCreateResponse,
  type ClustersControllerListSummariesData,
  type ClustersControllerListSummariesResponse,
  type ClustersControllerListMinimalData,
  type ClustersControllerListMinimalResponse,
  type ClustersControllerDeployModelBulkData,
  type ClustersControllerDeployModelBulkResponse,
  type ClustersControllerDeployConfigBulkData,
  type ClustersControllerDeployConfigBulkResponse,
  type ClustersControllerUpdateTagsBulkData,
  type ClustersControllerUpdateTagsBulkResponse,
  type ClustersControllerUploadData,
  type ClustersControllerUploadResponse,
  type ClustersControllerGetDetailsData,
  type ClustersControllerGetDetailsResponse,
  type ClustersControllerUpdateData,
  type ClustersControllerUpdateResponse,
  type ClustersControllerDeleteData,
  type ClustersControllerDeleteResponse,
  type ClustersControllerAddDevicesData,
  type ClustersControllerAddDevicesResponse,
  type ClustersControllerRemoveDevicesData,
  type ClustersControllerRemoveDevicesResponse,
  ClustersControllerGetDetailsResponseTransformer,
  type ClustersTaggingControllerListTagsData,
  type ClustersTaggingControllerListTagsResponse,
  type ClustersTaggingControllerCreateTagsData,
  type ClustersTaggingControllerCreateTagsResponse,
  type ClustersTaggingControllerAssignTagsData,
  type ClustersTaggingControllerAssignTagsResponse,
  type ClustersTaggingControllerUnassignTagsData,
  type ClustersTaggingControllerUnassignTagsResponse,
  type ClustersTaggingControllerGetDetailsData,
  type ClustersTaggingControllerGetDetailsResponse,
  type ClustersTaggingControllerUpdateTagData,
  type ClustersTaggingControllerUpdateTagResponse,
  type ClustersTaggingControllerDeleteTagData,
  type ClustersTaggingControllerDeleteTagResponse,
  type ClustersTaggingControllerMergeTagToData,
  type ClustersTaggingControllerMergeTagToResponse,
  type ClustersTaggingControllerListSummariesData,
  type ClustersTaggingControllerListSummariesResponse,
  ClustersTaggingControllerGetDetailsResponseTransformer,
  ClustersTaggingControllerUpdateTagResponseTransformer,
  type DashboardAlertsControllerCreateAlertData,
  type DashboardAlertsControllerCreateAlertResponse,
  type DatasetsControllerCreateData,
  type DatasetsControllerCreateResponse,
  type DatasetsControllerListSummariesData,
  type DatasetsControllerListSummariesResponse,
  type DatasetsControllerGetDetailsData,
  type DatasetsControllerGetDetailsResponse,
  type DatasetsControllerUpdateData,
  type DatasetsControllerUpdateResponse,
  DatasetsControllerGetDetailsResponseTransformer,
  type DeleteSamplesJobControllerCreateScheduleData,
  type DeleteSamplesJobControllerCreateScheduleResponse,
  type DeleteSamplesJobControllerListScheduledData,
  type DeleteSamplesJobControllerListScheduledResponse,
  type DeleteSamplesJobControllerGetScheduledJobData,
  type DeleteSamplesJobControllerGetScheduledJobResponse,
  type DeleteSamplesJobControllerUpdateScheduledJobData,
  type DeleteSamplesJobControllerUpdateScheduledJobResponse,
  type DeleteSamplesJobControllerDeleteScheduledJobData,
  type DeleteSamplesJobControllerDeleteScheduledJobResponse,
  type DeleteSamplesJobControllerCancelScheduledJobsBulkData,
  type DeleteSamplesJobControllerCancelScheduledJobsBulkResponse,
  type DeleteSamplesJobControllerStopScheduledJobsBulkData,
  type DeleteSamplesJobControllerStopScheduledJobsBulkResponse,
  type DeleteSamplesJobControllerResumeScheduledJobsBulkData,
  type DeleteSamplesJobControllerResumeScheduledJobsBulkResponse,
  type DeleteSamplesJobControllerDeleteScheduledJobsBulkData,
  type DeleteSamplesJobControllerDeleteScheduledJobsBulkResponse,
  type DeleteSamplesJobControllerStartScheduledJobData,
  type DeleteSamplesJobControllerStartScheduledJobResponse,
  type DeleteSamplesJobControllerCancelScheduledJobData,
  type DeleteSamplesJobControllerCancelScheduledJobResponse,
  type DeleteSamplesJobControllerStopScheduledJobData,
  type DeleteSamplesJobControllerStopScheduledJobResponse,
  type DeleteSamplesJobControllerResumeScheduledJobData,
  type DeleteSamplesJobControllerResumeScheduledJobResponse,
  type DeleteSamplesJobControllerStartJobData,
  type DeleteSamplesJobControllerStartJobResponse,
  type DeleteSamplesJobControllerListSummariesData,
  type DeleteSamplesJobControllerListSummariesResponse,
  type DeleteSamplesJobControllerGetJobData,
  type DeleteSamplesJobControllerGetJobResponse,
  type DeleteSamplesJobControllerDeleteJobData,
  type DeleteSamplesJobControllerDeleteJobResponse,
  type DeleteSamplesJobControllerUpdateJobData,
  type DeleteSamplesJobControllerUpdateJobResponse,
  type DeleteSamplesJobControllerCancelJobData,
  type DeleteSamplesJobControllerCancelJobResponse,
  type DeleteSamplesJobControllerStopJobData,
  type DeleteSamplesJobControllerStopJobResponse,
  type DeleteSamplesJobControllerCancelJobsBulkData,
  type DeleteSamplesJobControllerCancelJobsBulkResponse,
  type DeleteSamplesJobControllerDeleteJobsBulkData,
  type DeleteSamplesJobControllerDeleteJobsBulkResponse,
  DeleteSamplesJobControllerCreateScheduleResponseTransformer,
  DeleteSamplesJobControllerGetScheduledJobResponseTransformer,
  DeleteSamplesJobControllerUpdateScheduledJobResponseTransformer,
  DeleteSamplesJobControllerStartScheduledJobResponseTransformer,
  DeleteSamplesJobControllerResumeScheduledJobResponseTransformer,
  DeleteSamplesJobControllerStartJobResponseTransformer,
  DeleteSamplesJobControllerGetJobResponseTransformer,
  DeleteSamplesJobControllerUpdateJobResponseTransformer,
  type DeleteVideosJobControllerCreateScheduleData,
  type DeleteVideosJobControllerCreateScheduleResponse,
  type DeleteVideosJobControllerListScheduledData,
  type DeleteVideosJobControllerListScheduledResponse,
  type DeleteVideosJobControllerGetScheduledJobData,
  type DeleteVideosJobControllerGetScheduledJobResponse,
  type DeleteVideosJobControllerUpdateScheduledJobData,
  type DeleteVideosJobControllerUpdateScheduledJobResponse,
  type DeleteVideosJobControllerDeleteScheduledJobData,
  type DeleteVideosJobControllerDeleteScheduledJobResponse,
  type DeleteVideosJobControllerCancelScheduledJobsBulkData,
  type DeleteVideosJobControllerCancelScheduledJobsBulkResponse,
  type DeleteVideosJobControllerStopScheduledJobsBulkData,
  type DeleteVideosJobControllerStopScheduledJobsBulkResponse,
  type DeleteVideosJobControllerResumeScheduledJobsBulkData,
  type DeleteVideosJobControllerResumeScheduledJobsBulkResponse,
  type DeleteVideosJobControllerDeleteScheduledJobsBulkData,
  type DeleteVideosJobControllerDeleteScheduledJobsBulkResponse,
  type DeleteVideosJobControllerStartScheduledJobData,
  type DeleteVideosJobControllerStartScheduledJobResponse,
  type DeleteVideosJobControllerCancelScheduledJobData,
  type DeleteVideosJobControllerCancelScheduledJobResponse,
  type DeleteVideosJobControllerStopScheduledJobData,
  type DeleteVideosJobControllerStopScheduledJobResponse,
  type DeleteVideosJobControllerResumeScheduledJobData,
  type DeleteVideosJobControllerResumeScheduledJobResponse,
  type DeleteVideosJobControllerStartJobData,
  type DeleteVideosJobControllerStartJobResponse,
  type DeleteVideosJobControllerListSummariesData,
  type DeleteVideosJobControllerListSummariesResponse,
  type DeleteVideosJobControllerGetJobData,
  type DeleteVideosJobControllerGetJobResponse,
  type DeleteVideosJobControllerDeleteJobData,
  type DeleteVideosJobControllerDeleteJobResponse,
  type DeleteVideosJobControllerUpdateJobData,
  type DeleteVideosJobControllerUpdateJobResponse,
  type DeleteVideosJobControllerCancelJobData,
  type DeleteVideosJobControllerCancelJobResponse,
  type DeleteVideosJobControllerStopJobData,
  type DeleteVideosJobControllerStopJobResponse,
  type DeleteVideosJobControllerCancelJobsBulkData,
  type DeleteVideosJobControllerCancelJobsBulkResponse,
  type DeleteVideosJobControllerDeleteJobsBulkData,
  type DeleteVideosJobControllerDeleteJobsBulkResponse,
  DeleteVideosJobControllerCreateScheduleResponseTransformer,
  DeleteVideosJobControllerGetScheduledJobResponseTransformer,
  DeleteVideosJobControllerUpdateScheduledJobResponseTransformer,
  DeleteVideosJobControllerStartScheduledJobResponseTransformer,
  DeleteVideosJobControllerResumeScheduledJobResponseTransformer,
  DeleteVideosJobControllerStartJobResponseTransformer,
  DeleteVideosJobControllerGetJobResponseTransformer,
  DeleteVideosJobControllerUpdateJobResponseTransformer,
  type DeployComponentsControllerCreateScheduleData,
  type DeployComponentsControllerCreateScheduleResponse,
  type DeployComponentsControllerListScheduledData,
  type DeployComponentsControllerListScheduledResponse,
  type DeployComponentsControllerGetScheduledJobData,
  type DeployComponentsControllerGetScheduledJobResponse,
  type DeployComponentsControllerUpdateScheduledJobData,
  type DeployComponentsControllerUpdateScheduledJobResponse,
  type DeployComponentsControllerDeleteScheduledJobData,
  type DeployComponentsControllerDeleteScheduledJobResponse,
  type DeployComponentsControllerCancelScheduledJobsBulkData,
  type DeployComponentsControllerCancelScheduledJobsBulkResponse,
  type DeployComponentsControllerStopScheduledJobsBulkData,
  type DeployComponentsControllerStopScheduledJobsBulkResponse,
  type DeployComponentsControllerResumeScheduledJobsBulkData,
  type DeployComponentsControllerResumeScheduledJobsBulkResponse,
  type DeployComponentsControllerDeleteScheduledJobsBulkData,
  type DeployComponentsControllerDeleteScheduledJobsBulkResponse,
  type DeployComponentsControllerStartScheduledJobData,
  type DeployComponentsControllerStartScheduledJobResponse,
  type DeployComponentsControllerCancelScheduledJobData,
  type DeployComponentsControllerCancelScheduledJobResponse,
  type DeployComponentsControllerStopScheduledJobData,
  type DeployComponentsControllerStopScheduledJobResponse,
  type DeployComponentsControllerResumeScheduledJobData,
  type DeployComponentsControllerResumeScheduledJobResponse,
  type DeployComponentsControllerStartJobData,
  type DeployComponentsControllerStartJobResponse,
  type DeployComponentsControllerListSummariesData,
  type DeployComponentsControllerListSummariesResponse,
  type DeployComponentsControllerGetJobData,
  type DeployComponentsControllerGetJobResponse,
  type DeployComponentsControllerDeleteJobData,
  type DeployComponentsControllerDeleteJobResponse,
  type DeployComponentsControllerUpdateJobData,
  type DeployComponentsControllerUpdateJobResponse,
  type DeployComponentsControllerCancelJobData,
  type DeployComponentsControllerCancelJobResponse,
  type DeployComponentsControllerStopJobData,
  type DeployComponentsControllerStopJobResponse,
  type DeployComponentsControllerCancelJobsBulkData,
  type DeployComponentsControllerCancelJobsBulkResponse,
  type DeployComponentsControllerDeleteJobsBulkData,
  type DeployComponentsControllerDeleteJobsBulkResponse,
  DeployComponentsControllerCreateScheduleResponseTransformer,
  DeployComponentsControllerGetScheduledJobResponseTransformer,
  DeployComponentsControllerUpdateScheduledJobResponseTransformer,
  DeployComponentsControllerStartScheduledJobResponseTransformer,
  DeployComponentsControllerResumeScheduledJobResponseTransformer,
  DeployComponentsControllerStartJobResponseTransformer,
  DeployComponentsControllerGetJobResponseTransformer,
  DeployComponentsControllerUpdateJobResponseTransformer,
  type DeviceRestartControllerCreateScheduleData,
  type DeviceRestartControllerCreateScheduleResponse,
  type DeviceRestartControllerListScheduledData,
  type DeviceRestartControllerListScheduledResponse,
  type DeviceRestartControllerGetScheduledJobData,
  type DeviceRestartControllerGetScheduledJobResponse,
  type DeviceRestartControllerUpdateScheduledJobData,
  type DeviceRestartControllerUpdateScheduledJobResponse,
  type DeviceRestartControllerDeleteScheduledJobData,
  type DeviceRestartControllerDeleteScheduledJobResponse,
  type DeviceRestartControllerCancelScheduledJobsBulkData,
  type DeviceRestartControllerCancelScheduledJobsBulkResponse,
  type DeviceRestartControllerStopScheduledJobsBulkData,
  type DeviceRestartControllerStopScheduledJobsBulkResponse,
  type DeviceRestartControllerResumeScheduledJobsBulkData,
  type DeviceRestartControllerResumeScheduledJobsBulkResponse,
  type DeviceRestartControllerDeleteScheduledJobsBulkData,
  type DeviceRestartControllerDeleteScheduledJobsBulkResponse,
  type DeviceRestartControllerStartScheduledJobData,
  type DeviceRestartControllerStartScheduledJobResponse,
  type DeviceRestartControllerCancelScheduledJobData,
  type DeviceRestartControllerCancelScheduledJobResponse,
  type DeviceRestartControllerStopScheduledJobData,
  type DeviceRestartControllerStopScheduledJobResponse,
  type DeviceRestartControllerResumeScheduledJobData,
  type DeviceRestartControllerResumeScheduledJobResponse,
  type DeviceRestartControllerStartJobData,
  type DeviceRestartControllerStartJobResponse,
  type DeviceRestartControllerListSummariesData,
  type DeviceRestartControllerListSummariesResponse,
  type DeviceRestartControllerGetJobData,
  type DeviceRestartControllerGetJobResponse,
  type DeviceRestartControllerDeleteJobData,
  type DeviceRestartControllerDeleteJobResponse,
  type DeviceRestartControllerUpdateJobData,
  type DeviceRestartControllerUpdateJobResponse,
  type DeviceRestartControllerCancelJobData,
  type DeviceRestartControllerCancelJobResponse,
  type DeviceRestartControllerStopJobData,
  type DeviceRestartControllerStopJobResponse,
  type DeviceRestartControllerCancelJobsBulkData,
  type DeviceRestartControllerCancelJobsBulkResponse,
  type DeviceRestartControllerDeleteJobsBulkData,
  type DeviceRestartControllerDeleteJobsBulkResponse,
  DeviceRestartControllerCreateScheduleResponseTransformer,
  DeviceRestartControllerGetScheduledJobResponseTransformer,
  DeviceRestartControllerUpdateScheduledJobResponseTransformer,
  DeviceRestartControllerStartScheduledJobResponseTransformer,
  DeviceRestartControllerResumeScheduledJobResponseTransformer,
  DeviceRestartControllerStartJobResponseTransformer,
  DeviceRestartControllerGetJobResponseTransformer,
  DeviceRestartControllerUpdateJobResponseTransformer,
  type DevicesControllerStateCountsResponse,
  type DevicesControllerListSummariesData,
  type DevicesControllerListSummariesResponse,
  type DevicesControllerDownloadData,
  type DevicesControllerDownloadResponse,
  type DevicesControllerListMinimalData,
  type DevicesControllerListMinimalResponse,
  type DevicesControllerCreateData,
  type DevicesControllerCreateResponse,
  type DevicesControllerUpdateActivationTimeData,
  type DevicesControllerUpdateActivationTimeResponse,
  type DevicesControllerUpdateTagsData,
  type DevicesControllerUpdateTagsResponse,
  type DevicesControllerUpdateTagsBulkData,
  type DevicesControllerUpdateTagsBulkResponse,
  type DevicesControllerDeployModelBulkData,
  type DevicesControllerDeployModelBulkResponse,
  type DevicesControllerUpdateConfigLockBulkData,
  type DevicesControllerUpdateConfigLockBulkResponse,
  type DevicesControllerDeployServiceVersionBulkData,
  type DevicesControllerDeployServiceVersionBulkResponse,
  type DevicesControllerDeployConfigBulkData,
  type DevicesControllerDeployConfigBulkResponse,
  type DevicesControllerRestartBulkData,
  type DevicesControllerRestartBulkResponse,
  type DevicesControllerCancelConfigData,
  type DevicesControllerCancelConfigResponse,
  type DevicesControllerListAvailableComponentVersionsData,
  type DevicesControllerListAvailableComponentVersionsResponse,
  type DevicesControllerUploadData,
  type DevicesControllerUploadResponse,
  type DevicesControllerGetDetailsData,
  type DevicesControllerGetDetailsResponse,
  type DevicesControllerUpdateData,
  type DevicesControllerUpdateResponse,
  type DevicesControllerListDeviceEventsData,
  type DevicesControllerListDeviceEventsResponse,
  type DevicesControllerGetConfigData,
  type DevicesControllerGetConfigResponse,
  type DevicesControllerSetConfigData,
  type DevicesControllerSetConfigResponse,
  type DevicesControllerRevertConfigData,
  type DevicesControllerRevertConfigResponse,
  type DevicesControllerGetPasswordData,
  type DevicesControllerGetPasswordResponse,
  type DevicesControllerSetPasswordData,
  type DevicesControllerSetPasswordResponse,
  type DevicesControllerGetConfigLockStateData,
  type DevicesControllerGetConfigLockStateResponse,
  type DevicesControllerRestartData,
  type DevicesControllerRestartResponse,
  type DevicesControllerGetSamplesData,
  type DevicesControllerGetSamplesResponse,
  type DevicesControllerAddSampleData,
  type DevicesControllerAddSampleResponse,
  type DevicesControllerSaveSampleData,
  type DevicesControllerSaveSampleResponse,
  type DevicesControllerDeleteSamplesData,
  type DevicesControllerDeleteSamplesResponse,
  type DevicesControllerGetSamplesSizeData,
  type DevicesControllerGetSamplesSizeResponse,
  type DevicesControllerGetSamplesStatsData,
  type DevicesControllerGetSamplesStatsResponse,
  type DevicesControllerStartRecordingData,
  type DevicesControllerStartRecordingResponse,
  type DevicesControllerStopRecordingData,
  type DevicesControllerStopRecordingResponse,
  type DevicesControllerStartVideoUploadData,
  type DevicesControllerStartVideoUploadResponse,
  type DevicesControllerStopVideoUploadData,
  type DevicesControllerStopVideoUploadResponse,
  type DevicesControllerGetVideoUploadStateData,
  type DevicesControllerGetVideoUploadStateResponse,
  type DevicesControllerStartSamplesUploadData,
  type DevicesControllerStartSamplesUploadResponse,
  type DevicesControllerStopSamplesUploadData,
  type DevicesControllerStopSamplesUploadResponse,
  type DevicesControllerGetSamplesUploadStateData,
  type DevicesControllerGetSamplesUploadStateResponse,
  type DevicesControllerListSamplesUploadsData,
  type DevicesControllerListSamplesUploadsResponse,
  type DevicesControllerGetSamplesUploadStateByNameData,
  type DevicesControllerGetSamplesUploadStateByNameResponse,
  type DevicesControllerListVideoUploadsData,
  type DevicesControllerListVideoUploadsResponse,
  type DevicesControllerGetVideoUploadStateByNameData,
  type DevicesControllerGetVideoUploadStateByNameResponse,
  type DevicesControllerStartHeadBlurVideosData,
  type DevicesControllerStartHeadBlurVideosResponse,
  type DevicesControllerStopHeadBlurVideosData,
  type DevicesControllerStopHeadBlurVideosResponse,
  type DevicesControllerGetHeadBlurVideosStateData,
  type DevicesControllerGetHeadBlurVideosStateResponse,
  type DevicesControllerGetHeadBlurVideoStateData,
  type DevicesControllerGetHeadBlurVideoStateResponse,
  type DevicesControllerListHeadBlurVideosData,
  type DevicesControllerListHeadBlurVideosResponse,
  type DevicesControllerGetHeadBlurVideosStateByNameData,
  type DevicesControllerGetHeadBlurVideosStateByNameResponse,
  type DevicesControllerStartHeadBlurImagesData,
  type DevicesControllerStartHeadBlurImagesResponse,
  type DevicesControllerStopHeadBlurImagesData,
  type DevicesControllerStopHeadBlurImagesResponse,
  type DevicesControllerGetHeadBlurImagesStateData,
  type DevicesControllerGetHeadBlurImagesStateResponse,
  type DevicesControllerListHeadBlurImagesData,
  type DevicesControllerListHeadBlurImagesResponse,
  type DevicesControllerHeadBlurImageData,
  type DevicesControllerHeadBlurImageResponse,
  type DevicesControllerGetHeadBlurImagesStateByNameData,
  type DevicesControllerGetHeadBlurImagesStateByNameResponse,
  type DevicesControllerCaptureData,
  type DevicesControllerCaptureResponse,
  type DevicesControllerCaptureAndPredictData,
  type DevicesControllerCaptureAndPredictResponse,
  type DevicesControllerPredictData,
  type DevicesControllerPredictResponse,
  type DevicesControllerGetSampleData,
  type DevicesControllerGetSampleResponse,
  type DevicesControllerGetSampleThumbnailData,
  type DevicesControllerGetSampleThumbnailResponse,
  type DevicesControllerSyncSamplesData,
  type DevicesControllerSyncSamplesResponse,
  type DevicesControllerUnlockSamplesData,
  type DevicesControllerUnlockSamplesResponse,
  type DevicesControllerUnlockSamplesByUuidsData,
  type DevicesControllerUnlockSamplesByUuidsResponse,
  type DevicesControllerUnlockAllSamplesData,
  type DevicesControllerUnlockAllSamplesResponse,
  type DevicesControllerLockSamplesData,
  type DevicesControllerLockSamplesResponse,
  type DevicesControllerLockAllSamplesData,
  type DevicesControllerLockAllSamplesResponse,
  type DevicesControllerGetSessionsData,
  type DevicesControllerGetSessionsResponse,
  type DevicesControllerGetSessionsSizeData,
  type DevicesControllerGetSessionsSizeResponse,
  type DevicesControllerSyncSessionsData,
  type DevicesControllerSyncSessionsResponse,
  type DevicesControllerDeleteSessionData,
  type DevicesControllerDeleteSessionResponse,
  type DevicesControllerUploadLogsData,
  type DevicesControllerUploadLogsResponse,
  type DevicesControllerUploadTrainerLogsData,
  type DevicesControllerUploadTrainerLogsResponse,
  type DevicesControllerDeployAgentVersionData,
  type DevicesControllerDeployAgentVersionResponse,
  type DevicesControllerGetAgentDeploymentsData,
  type DevicesControllerGetAgentDeploymentsResponse,
  type DevicesControllerDeployServiceData,
  type DevicesControllerDeployServiceResponse,
  type DevicesControllerGetServiceDeploymentsData,
  type DevicesControllerGetServiceDeploymentsResponse,
  type DevicesControllerGetAvailableServiceVersionsData,
  type DevicesControllerGetAvailableServiceVersionsResponse,
  type DevicesControllerTestAlertNonMatchData,
  type DevicesControllerTestAlertNonMatchResponse,
  type DevicesControllerTestAlertNonScanData,
  type DevicesControllerTestAlertNonScanResponse,
  type DevicesControllerTestAlertLeftInCartData,
  type DevicesControllerTestAlertLeftInCartResponse,
  type DevicesControllerListCamerasData,
  type DevicesControllerListCamerasResponse,
  type DevicesControllerListInternalCamerasData,
  type DevicesControllerListInternalCamerasResponse,
  type DevicesControllerListExternalCameraData,
  type DevicesControllerListExternalCameraResponse,
  type DevicesControllerGetCameraControlsData,
  type DevicesControllerGetCameraControlsResponse,
  type DevicesControllerSetCameraControlsData,
  type DevicesControllerSetCameraControlsResponse,
  type DevicesControllerListConfigDeploymentsData,
  type DevicesControllerListConfigDeploymentsResponse,
  type DevicesControllerDisableDeviceAlertsData,
  type DevicesControllerDisableDeviceAlertsResponse,
  type DevicesControllerEnableDeviceAlertsData,
  type DevicesControllerEnableDeviceAlertsResponse,
  type DevicesControllerGetDeviceAlertsStatusData,
  type DevicesControllerGetDeviceAlertsStatusResponse,
  type DevicesControllerSetDeviceAlertsData,
  type DevicesControllerSetDeviceAlertsResponse,
  type DevicesControllerTestConnectionData,
  type DevicesControllerTestConnectionResponse,
  type DevicesControllerGetConfigFileData,
  type DevicesControllerGetConfigFileResponse,
  type DevicesControllerSetConfigFileData,
  type DevicesControllerSetConfigFileResponse,
  type DevicesControllerDeleteConfigFileData,
  type DevicesControllerDeleteConfigFileResponse,
  type DevicesControllerGenerateCertificateData,
  type DevicesControllerGenerateCertificateResponse,
  type DevicesControllerGetCertValidityData,
  type DevicesControllerGetCertValidityResponse,
  DevicesControllerUploadResponseTransformer,
  DevicesControllerGetDetailsResponseTransformer,
  DevicesControllerGetSamplesResponseTransformer,
  DevicesControllerStartRecordingResponseTransformer,
  DevicesControllerStopRecordingResponseTransformer,
  DevicesControllerGetVideoUploadStateResponseTransformer,
  DevicesControllerGetSamplesUploadStateResponseTransformer,
  DevicesControllerListSamplesUploadsResponseTransformer,
  DevicesControllerGetSamplesUploadStateByNameResponseTransformer,
  DevicesControllerListVideoUploadsResponseTransformer,
  DevicesControllerGetVideoUploadStateByNameResponseTransformer,
  DevicesControllerGetHeadBlurVideosStateResponseTransformer,
  DevicesControllerGetHeadBlurVideoStateResponseTransformer,
  DevicesControllerListHeadBlurVideosResponseTransformer,
  DevicesControllerGetHeadBlurVideosStateByNameResponseTransformer,
  DevicesControllerGetHeadBlurImagesStateResponseTransformer,
  DevicesControllerListHeadBlurImagesResponseTransformer,
  DevicesControllerGetHeadBlurImagesStateByNameResponseTransformer,
  DevicesControllerCaptureAndPredictResponseTransformer,
  DevicesControllerPredictResponseTransformer,
  DevicesControllerGetSessionsResponseTransformer,
  type DevicesTaggingControllerListTagsData,
  type DevicesTaggingControllerListTagsResponse,
  type DevicesTaggingControllerCreateTagsData,
  type DevicesTaggingControllerCreateTagsResponse,
  type DevicesTaggingControllerAssignTagsData,
  type DevicesTaggingControllerAssignTagsResponse,
  type DevicesTaggingControllerUnassignTagsData,
  type DevicesTaggingControllerUnassignTagsResponse,
  type DevicesTaggingControllerGetDetailsData,
  type DevicesTaggingControllerGetDetailsResponse,
  type DevicesTaggingControllerUpdateTagData,
  type DevicesTaggingControllerUpdateTagResponse,
  type DevicesTaggingControllerDeleteTagData,
  type DevicesTaggingControllerDeleteTagResponse,
  type DevicesTaggingControllerMergeTagToData,
  type DevicesTaggingControllerMergeTagToResponse,
  type DevicesTaggingControllerListSummariesData,
  type DevicesTaggingControllerListSummariesResponse,
  DevicesTaggingControllerGetDetailsResponseTransformer,
  DevicesTaggingControllerUpdateTagResponseTransformer,
  type DomainAuthSettingsControllerCreateData,
  type DomainAuthSettingsControllerCreateResponse,
  type DomainAuthSettingsControllerListResponse,
  type DomainAuthSettingsControllerFindOneData,
  type DomainAuthSettingsControllerFindOneResponse,
  type DomainAuthSettingsControllerUpdateData,
  type DomainAuthSettingsControllerUpdateResponse,
  type DomainAuthSettingsControllerRemoveData,
  type DomainAuthSettingsControllerRemoveResponse,
  type EmailReportsControllerCreateScheduleData,
  type EmailReportsControllerCreateScheduleResponse,
  type EmailReportsControllerListScheduledData,
  type EmailReportsControllerListScheduledResponse,
  type EmailReportsControllerListSubscriptionsByReportData,
  type EmailReportsControllerListSubscriptionsByReportResponse,
  type EmailReportsControllerGetSubscriptionDetailData,
  type EmailReportsControllerGetSubscriptionDetailResponse,
  type EmailReportsControllerListApproverCandidateEmailsResponse,
  type EmailReportsControllerGetLastSentCopyData,
  type EmailReportsControllerGetLastSentCopyResponse,
  type EmailReportsControllerDownloadSubscriptionPdfData,
  type EmailReportsControllerDownloadSubscriptionPdfResponse,
  type EmailReportsControllerGetSubscriptionSendHistoryData,
  type EmailReportsControllerGetSubscriptionSendHistoryResponse,
  type EmailReportsControllerDownloadSubscriptionSendHistoryData,
  type EmailReportsControllerDownloadSubscriptionSendHistoryResponse,
  type EmailReportsControllerPreviewHistoricalSendData,
  type EmailReportsControllerPreviewHistoricalSendResponse,
  type EmailReportsControllerGetReportSendLogData,
  type EmailReportsControllerGetReportSendLogResponse,
  type EmailReportsControllerUpdateScheduledJobData,
  type EmailReportsControllerUpdateScheduledJobResponse,
  type EmailReportsControllerDeleteScheduledJobData,
  type EmailReportsControllerDeleteScheduledJobResponse,
  type EmailReportsControllerGetScheduledJobData,
  type EmailReportsControllerGetScheduledJobResponse,
  type EmailReportsControllerStartScheduledJobData,
  type EmailReportsControllerStartScheduledJobResponse,
  type EmailReportsControllerCancelScheduledJobData,
  type EmailReportsControllerCancelScheduledJobResponse,
  type EmailReportsControllerStopScheduledJobData,
  type EmailReportsControllerStopScheduledJobResponse,
  type EmailReportsControllerResumeScheduledJobData,
  type EmailReportsControllerResumeScheduledJobResponse,
  type EmailReportsControllerCancelScheduledJobsBulkData,
  type EmailReportsControllerCancelScheduledJobsBulkResponse,
  type EmailReportsControllerStopScheduledJobsBulkData,
  type EmailReportsControllerStopScheduledJobsBulkResponse,
  type EmailReportsControllerResumeScheduledJobsBulkData,
  type EmailReportsControllerResumeScheduledJobsBulkResponse,
  type EmailReportsControllerDeleteScheduledJobsBulkData,
  type EmailReportsControllerDeleteScheduledJobsBulkResponse,
  type EmailReportsControllerUnsubscribeData,
  type EmailReportsControllerUnsubscribeResponse,
  type EmailReportsControllerSendPendingReportData,
  type EmailReportsControllerSendPendingReportResponse,
  type EmailReportsControllerRejectPendingReportData,
  type EmailReportsControllerRejectPendingReportResponse,
  type EmailReportsControllerPreviewPendingReportData,
  type EmailReportsControllerPreviewPendingReportResponse,
  type EmailReportsControllerPreviewTemplateData,
  type EmailReportsControllerPreviewTemplateResponse,
  type EmailReportsControllerUpdateSummaryTextData,
  type EmailReportsControllerUpdateSummaryTextResponse,
  type EmailReportsControllerStartJobData,
  type EmailReportsControllerStartJobResponse,
  type EmailReportsControllerListSummariesData,
  type EmailReportsControllerListSummariesResponse,
  type EmailReportsControllerGetJobData,
  type EmailReportsControllerGetJobResponse,
  type EmailReportsControllerDeleteJobData,
  type EmailReportsControllerDeleteJobResponse,
  type EmailReportsControllerUpdateJobData,
  type EmailReportsControllerUpdateJobResponse,
  type EmailReportsControllerCancelJobData,
  type EmailReportsControllerCancelJobResponse,
  type EmailReportsControllerStopJobData,
  type EmailReportsControllerStopJobResponse,
  type EmailReportsControllerCancelJobsBulkData,
  type EmailReportsControllerCancelJobsBulkResponse,
  type EmailReportsControllerDeleteJobsBulkData,
  type EmailReportsControllerDeleteJobsBulkResponse,
  EmailReportsControllerCreateScheduleResponseTransformer,
  EmailReportsControllerGetSubscriptionDetailResponseTransformer,
  EmailReportsControllerGetReportSendLogResponseTransformer,
  EmailReportsControllerUpdateScheduledJobResponseTransformer,
  EmailReportsControllerGetScheduledJobResponseTransformer,
  EmailReportsControllerResumeScheduledJobResponseTransformer,
  EmailReportsControllerStartJobResponseTransformer,
  EmailReportsControllerGetJobResponseTransformer,
  EmailReportsControllerUpdateJobResponseTransformer,
  type FeedbackControllerCreateFeedbackData,
  type FeedbackControllerCreateFeedbackResponse,
  type HeadBlurImagesControllerCreateScheduleData,
  type HeadBlurImagesControllerCreateScheduleResponse,
  type HeadBlurImagesControllerListScheduledData,
  type HeadBlurImagesControllerListScheduledResponse,
  type HeadBlurImagesControllerGetScheduledJobData,
  type HeadBlurImagesControllerGetScheduledJobResponse,
  type HeadBlurImagesControllerUpdateScheduledJobData,
  type HeadBlurImagesControllerUpdateScheduledJobResponse,
  type HeadBlurImagesControllerDeleteScheduledJobData,
  type HeadBlurImagesControllerDeleteScheduledJobResponse,
  type HeadBlurImagesControllerCancelScheduledJobsBulkData,
  type HeadBlurImagesControllerCancelScheduledJobsBulkResponse,
  type HeadBlurImagesControllerStopScheduledJobsBulkData,
  type HeadBlurImagesControllerStopScheduledJobsBulkResponse,
  type HeadBlurImagesControllerResumeScheduledJobsBulkData,
  type HeadBlurImagesControllerResumeScheduledJobsBulkResponse,
  type HeadBlurImagesControllerDeleteScheduledJobsBulkData,
  type HeadBlurImagesControllerDeleteScheduledJobsBulkResponse,
  type HeadBlurImagesControllerStartScheduledJobData,
  type HeadBlurImagesControllerStartScheduledJobResponse,
  type HeadBlurImagesControllerCancelScheduledJobData,
  type HeadBlurImagesControllerCancelScheduledJobResponse,
  type HeadBlurImagesControllerStopScheduledJobData,
  type HeadBlurImagesControllerStopScheduledJobResponse,
  type HeadBlurImagesControllerResumeScheduledJobData,
  type HeadBlurImagesControllerResumeScheduledJobResponse,
  type HeadBlurImagesControllerStartJobData,
  type HeadBlurImagesControllerStartJobResponse,
  type HeadBlurImagesControllerListSummariesData,
  type HeadBlurImagesControllerListSummariesResponse,
  type HeadBlurImagesControllerGetJobData,
  type HeadBlurImagesControllerGetJobResponse,
  type HeadBlurImagesControllerDeleteJobData,
  type HeadBlurImagesControllerDeleteJobResponse,
  type HeadBlurImagesControllerUpdateJobData,
  type HeadBlurImagesControllerUpdateJobResponse,
  type HeadBlurImagesControllerCancelJobData,
  type HeadBlurImagesControllerCancelJobResponse,
  type HeadBlurImagesControllerStopJobData,
  type HeadBlurImagesControllerStopJobResponse,
  type HeadBlurImagesControllerCancelJobsBulkData,
  type HeadBlurImagesControllerCancelJobsBulkResponse,
  type HeadBlurImagesControllerDeleteJobsBulkData,
  type HeadBlurImagesControllerDeleteJobsBulkResponse,
  HeadBlurImagesControllerCreateScheduleResponseTransformer,
  HeadBlurImagesControllerGetScheduledJobResponseTransformer,
  HeadBlurImagesControllerUpdateScheduledJobResponseTransformer,
  HeadBlurImagesControllerStartScheduledJobResponseTransformer,
  HeadBlurImagesControllerResumeScheduledJobResponseTransformer,
  HeadBlurImagesControllerStartJobResponseTransformer,
  HeadBlurImagesControllerGetJobResponseTransformer,
  HeadBlurImagesControllerUpdateJobResponseTransformer,
  type HeadBlurVideosControllerCreateScheduleData,
  type HeadBlurVideosControllerCreateScheduleResponse,
  type HeadBlurVideosControllerListScheduledData,
  type HeadBlurVideosControllerListScheduledResponse,
  type HeadBlurVideosControllerGetScheduledJobData,
  type HeadBlurVideosControllerGetScheduledJobResponse,
  type HeadBlurVideosControllerUpdateScheduledJobData,
  type HeadBlurVideosControllerUpdateScheduledJobResponse,
  type HeadBlurVideosControllerDeleteScheduledJobData,
  type HeadBlurVideosControllerDeleteScheduledJobResponse,
  type HeadBlurVideosControllerCancelScheduledJobsBulkData,
  type HeadBlurVideosControllerCancelScheduledJobsBulkResponse,
  type HeadBlurVideosControllerStopScheduledJobsBulkData,
  type HeadBlurVideosControllerStopScheduledJobsBulkResponse,
  type HeadBlurVideosControllerResumeScheduledJobsBulkData,
  type HeadBlurVideosControllerResumeScheduledJobsBulkResponse,
  type HeadBlurVideosControllerDeleteScheduledJobsBulkData,
  type HeadBlurVideosControllerDeleteScheduledJobsBulkResponse,
  type HeadBlurVideosControllerStartScheduledJobData,
  type HeadBlurVideosControllerStartScheduledJobResponse,
  type HeadBlurVideosControllerCancelScheduledJobData,
  type HeadBlurVideosControllerCancelScheduledJobResponse,
  type HeadBlurVideosControllerStopScheduledJobData,
  type HeadBlurVideosControllerStopScheduledJobResponse,
  type HeadBlurVideosControllerResumeScheduledJobData,
  type HeadBlurVideosControllerResumeScheduledJobResponse,
  type HeadBlurVideosControllerStartJobData,
  type HeadBlurVideosControllerStartJobResponse,
  type HeadBlurVideosControllerListSummariesData,
  type HeadBlurVideosControllerListSummariesResponse,
  type HeadBlurVideosControllerGetJobData,
  type HeadBlurVideosControllerGetJobResponse,
  type HeadBlurVideosControllerDeleteJobData,
  type HeadBlurVideosControllerDeleteJobResponse,
  type HeadBlurVideosControllerUpdateJobData,
  type HeadBlurVideosControllerUpdateJobResponse,
  type HeadBlurVideosControllerCancelJobData,
  type HeadBlurVideosControllerCancelJobResponse,
  type HeadBlurVideosControllerStopJobData,
  type HeadBlurVideosControllerStopJobResponse,
  type HeadBlurVideosControllerCancelJobsBulkData,
  type HeadBlurVideosControllerCancelJobsBulkResponse,
  type HeadBlurVideosControllerDeleteJobsBulkData,
  type HeadBlurVideosControllerDeleteJobsBulkResponse,
  HeadBlurVideosControllerCreateScheduleResponseTransformer,
  HeadBlurVideosControllerGetScheduledJobResponseTransformer,
  HeadBlurVideosControllerUpdateScheduledJobResponseTransformer,
  HeadBlurVideosControllerStartScheduledJobResponseTransformer,
  HeadBlurVideosControllerResumeScheduledJobResponseTransformer,
  HeadBlurVideosControllerStartJobResponseTransformer,
  HeadBlurVideosControllerGetJobResponseTransformer,
  HeadBlurVideosControllerUpdateJobResponseTransformer,
  type JiraControllerGetIssueTypeData,
  type JiraControllerGetIssueTypeResponse,
  type JiraControllerGetProjectIssueTypesData,
  type JiraControllerGetProjectIssueTypesResponse,
  type JiraControllerGetStateData,
  type JiraControllerGetStateResponse,
  type LabelDistributionControllerListLabelDistributionData,
  type LabelDistributionControllerListLabelDistributionResponse,
  type LabelDistributionControllerLabelDistributionCountData,
  type LabelDistributionControllerLabelDistributionCountResponse,
  type LookupTableControllerCreateData,
  type LookupTableControllerCreateResponse,
  type LookupTableControllerListSummariesData,
  type LookupTableControllerListSummariesResponse,
  type LookupTableControllerUpdateData,
  type LookupTableControllerUpdateResponse,
  type LookupTableControllerGetDetailsData,
  type LookupTableControllerGetDetailsResponse,
  type LookupTableControllerDeleteData,
  type LookupTableControllerDeleteResponse,
  type LookupTableControllerDownloadCatalogData,
  type LookupTableControllerDownloadCatalogResponse,
  type MetricAlertsControllerCreateData,
  type MetricAlertsControllerCreateResponse,
  type MetricAlertsControllerListData,
  type MetricAlertsControllerListResponse,
  type MetricAlertsControllerGetByIdData,
  type MetricAlertsControllerGetByIdResponse,
  type MetricAlertsControllerUpdateData,
  type MetricAlertsControllerUpdateResponse,
  type MetricAlertsControllerRemoveData,
  type MetricAlertsControllerRemoveResponse,
  type MetricAlertsControllerPreviewData,
  type MetricAlertsControllerPreviewResponse,
  type MetricAlertsControllerTestData,
  type MetricAlertsControllerTestResponse,
  MetricAlertsControllerCreateResponseTransformer,
  MetricAlertsControllerGetByIdResponseTransformer,
  MetricAlertsControllerUpdateResponseTransformer,
  type ModelsControllerListSummariesData,
  type ModelsControllerListSummariesResponse,
  type ModelsControllerListMinimalData,
  type ModelsControllerListMinimalResponse,
  type ModelsControllerListModelRolesData,
  type ModelsControllerListModelRolesResponse,
  type ModelsControllerGetDetailsData,
  type ModelsControllerGetDetailsResponse,
  type ModelsControllerUpdateData,
  type ModelsControllerUpdateResponse,
  type ModelsControllerUploadModelData,
  type ModelsControllerUploadModelResponse,
  type ModelsControllerDownloadModelData,
  type ModelsControllerDownloadModelResponse,
  type ModelsControllerListDeploymentsData,
  type ModelsControllerListDeploymentsResponse,
  type ModelsControllerListClusterDeploymentsData,
  type ModelsControllerListClusterDeploymentsResponse,
  type ModelsControllerDeployModelData,
  type ModelsControllerDeployModelResponse,
  ModelsControllerGetDetailsResponseTransformer,
  type NotificationsControllerGetActiveResponse,
  type NotificationsControllerCreateData,
  type NotificationsControllerCreateResponse,
  type NotificationsControllerGetActivePublicResponse,
  type NotificationsControllerListSummariesData,
  type NotificationsControllerListSummariesResponse,
  type NotificationsControllerFindOneData,
  type NotificationsControllerFindOneResponse,
  type NotificationsControllerUpdateData,
  type NotificationsControllerUpdateResponse,
  type NotificationsControllerRemoveData,
  type NotificationsControllerRemoveResponse,
  NotificationsControllerGetActiveResponseTransformer,
  NotificationsControllerCreateResponseTransformer,
  NotificationsControllerFindOneResponseTransformer,
  NotificationsControllerUpdateResponseTransformer,
  type PageViewsControllerReportData,
  type PageViewsControllerReportResponse,
  type PendingControllerListSummariesData,
  type PendingControllerListSummariesResponse,
  type PendingControllerListUploadOperationsData,
  type PendingControllerListUploadOperationsResponse,
  type PendingControllerCancelOperationData,
  type PendingControllerCancelOperationResponse,
  type PendingControllerCancelSelectedData,
  type PendingControllerCancelSelectedResponse,
  type PermissionsControllerListSummariesData,
  type PermissionsControllerListSummariesResponse,
  type PermissionsControllerGetAllResponse,
  type PermissionsControllerGetPermissionsEndpointsResponse,
  type PermissionsControllerGetUserPermissionsResponse,
  type PermissionsControllerReloadResponse,
  type PermissionsControllerGetPermissionsTemplateResponse,
  type PredictionsControllerListPredictionsCountData,
  type PredictionsControllerListPredictionsCountResponse,
  type PredictionsControllerListPredictionsData,
  type PredictionsControllerListPredictionsResponse,
  type PredictionsControllerListModelPredictionsCountData,
  type PredictionsControllerListModelPredictionsCountResponse,
  type PredictionsControllerListModelPredictionsData,
  type PredictionsControllerListModelPredictionsResponse,
  type QueuesControllerGetSummaryResponse,
  type QueuesControllerListQueueFailuresData,
  type QueuesControllerListQueueFailuresResponse,
  type QueuesControllerResolveQueueFailuresData,
  type QueuesControllerResolveQueueFailuresResponse,
  type QueuesControllerDeleteQueueFailuresData,
  type QueuesControllerDeleteQueueFailuresResponse,
  type QueuesControllerPatchQueueFailureData,
  type QueuesControllerPatchQueueFailureResponse,
  type QueuesControllerDeleteQueueFailureData,
  type QueuesControllerDeleteQueueFailureResponse,
  type QueuesControllerResolveQueueFailureData,
  type QueuesControllerResolveQueueFailureResponse,
  type QueuesControllerListQueuePendingData,
  type QueuesControllerListQueuePendingResponse,
  type QueuesControllerPostQueuePendingData,
  type QueuesControllerPostQueuePendingResponse,
  type QueuesControllerDeleteQueuePendingData,
  type QueuesControllerDeleteQueuePendingResponse,
  type RecoveryEstimatesControllerPreCheckData,
  type RecoveryEstimatesControllerPreCheckResponse,
  type RecoveryEstimatesControllerCreateScheduleData,
  type RecoveryEstimatesControllerCreateScheduleResponse,
  type RecoveryEstimatesControllerListScheduledData,
  type RecoveryEstimatesControllerListScheduledResponse,
  type RecoveryEstimatesControllerGetScheduledJobData,
  type RecoveryEstimatesControllerGetScheduledJobResponse,
  type RecoveryEstimatesControllerUpdateScheduledJobData,
  type RecoveryEstimatesControllerUpdateScheduledJobResponse,
  type RecoveryEstimatesControllerDeleteScheduledJobData,
  type RecoveryEstimatesControllerDeleteScheduledJobResponse,
  type RecoveryEstimatesControllerCancelScheduledJobsBulkData,
  type RecoveryEstimatesControllerCancelScheduledJobsBulkResponse,
  type RecoveryEstimatesControllerStopScheduledJobsBulkData,
  type RecoveryEstimatesControllerStopScheduledJobsBulkResponse,
  type RecoveryEstimatesControllerResumeScheduledJobsBulkData,
  type RecoveryEstimatesControllerResumeScheduledJobsBulkResponse,
  type RecoveryEstimatesControllerDeleteScheduledJobsBulkData,
  type RecoveryEstimatesControllerDeleteScheduledJobsBulkResponse,
  type RecoveryEstimatesControllerStartScheduledJobData,
  type RecoveryEstimatesControllerStartScheduledJobResponse,
  type RecoveryEstimatesControllerCancelScheduledJobData,
  type RecoveryEstimatesControllerCancelScheduledJobResponse,
  type RecoveryEstimatesControllerStopScheduledJobData,
  type RecoveryEstimatesControllerStopScheduledJobResponse,
  type RecoveryEstimatesControllerResumeScheduledJobData,
  type RecoveryEstimatesControllerResumeScheduledJobResponse,
  type RecoveryEstimatesControllerStartJobData,
  type RecoveryEstimatesControllerStartJobResponse,
  type RecoveryEstimatesControllerListSummariesData,
  type RecoveryEstimatesControllerListSummariesResponse,
  type RecoveryEstimatesControllerGetJobData,
  type RecoveryEstimatesControllerGetJobResponse,
  type RecoveryEstimatesControllerDeleteJobData,
  type RecoveryEstimatesControllerDeleteJobResponse,
  type RecoveryEstimatesControllerUpdateJobData,
  type RecoveryEstimatesControllerUpdateJobResponse,
  type RecoveryEstimatesControllerCancelJobData,
  type RecoveryEstimatesControllerCancelJobResponse,
  type RecoveryEstimatesControllerStopJobData,
  type RecoveryEstimatesControllerStopJobResponse,
  type RecoveryEstimatesControllerCancelJobsBulkData,
  type RecoveryEstimatesControllerCancelJobsBulkResponse,
  type RecoveryEstimatesControllerDeleteJobsBulkData,
  type RecoveryEstimatesControllerDeleteJobsBulkResponse,
  RecoveryEstimatesControllerCreateScheduleResponseTransformer,
  RecoveryEstimatesControllerGetScheduledJobResponseTransformer,
  RecoveryEstimatesControllerUpdateScheduledJobResponseTransformer,
  RecoveryEstimatesControllerStartScheduledJobResponseTransformer,
  RecoveryEstimatesControllerResumeScheduledJobResponseTransformer,
  RecoveryEstimatesControllerStartJobResponseTransformer,
  RecoveryEstimatesControllerGetJobResponseTransformer,
  RecoveryEstimatesControllerUpdateJobResponseTransformer,
  type RegionsControllerListSummariesData,
  type RegionsControllerListSummariesResponse,
  type RegionsControllerListRegionOptionsData,
  type RegionsControllerListRegionOptionsResponse,
  type RegionsControllerListSubRegionOptionsData,
  type RegionsControllerListSubRegionOptionsResponse,
  type RegionsControllerCreateData,
  type RegionsControllerCreateResponse,
  type RegionsControllerMoveSubRegionsBulkData,
  type RegionsControllerMoveSubRegionsBulkResponse,
  type RegionsControllerUpdateSubRegionData,
  type RegionsControllerUpdateSubRegionResponse,
  type RegionsControllerInactivateBulkData,
  type RegionsControllerInactivateBulkResponse,
  type RegionsControllerUpdateRegionData,
  type RegionsControllerUpdateRegionResponse,
  type RegionsControllerUploadData,
  type RegionsControllerUploadResponse,
  type RegionsControllerDownloadData,
  type RegionsControllerDownloadResponse,
  type MetabaseControllerGetMetabaseUrlResponse,
  type MetabaseControllerGeneratePdfData,
  type MetabaseControllerGeneratePdfResponse,
  type MetabaseControllerListReportsData,
  type MetabaseControllerListReportsResponse,
  type MetabaseControllerCreateReportData,
  type MetabaseControllerCreateReportResponse,
  type MetabaseControllerGetReportDetailsData,
  type MetabaseControllerGetReportDetailsResponse,
  type MetabaseControllerUpdateReportData,
  type MetabaseControllerUpdateReportResponse,
  type MetabaseControllerDeleteReportData,
  type MetabaseControllerDeleteReportResponse,
  type MetabaseControllerUpdateReportConfigData,
  type MetabaseControllerUpdateReportConfigResponse,
  type MetabaseControllerUpdateReportUrlData,
  type MetabaseControllerUpdateReportUrlResponse,
  type MetabaseControllerSendTestReportData,
  type MetabaseControllerSendTestReportResponse,
  type MetabaseControllerContactUsData,
  type MetabaseControllerContactUsResponse,
  type MetabaseControllerFetchReportMetadataData,
  type MetabaseControllerFetchReportMetadataResponse,
  type MetabaseControllerPreviewCustomReportData,
  type MetabaseControllerPreviewCustomReportResponse,
  MetabaseControllerGetReportDetailsResponseTransformer,
  type ReportsCompanionControllerGetEligibilityResponse,
  type ReportsCompanionControllerChatData,
  type ReportsCompanionControllerChatResponse,
  type ReportsCompanionControllerListChatTurnsData,
  type ReportsCompanionControllerListChatTurnsResponse,
  type ReportsCompanionControllerGetChatConversationData,
  type ReportsCompanionControllerGetChatConversationResponse,
  ReportsCompanionControllerGetChatConversationResponseTransformer,
  type SamplesControllerListSamplesCountData,
  type SamplesControllerListSamplesCountResponse,
  type SamplesControllerGetUxSourceData,
  type SamplesControllerGetUxSourceResponse,
  type SamplesControllerListSamplesData,
  type SamplesControllerListSamplesResponse,
  type SamplesControllerGetQueryData,
  type SamplesControllerGetQueryResponse,
  type SamplesControllerGenerateShareUrlData,
  type SamplesControllerGenerateShareUrlResponse,
  type SamplesControllerSharedListSamplesData,
  type SamplesControllerSharedListSamplesResponse,
  type SamplesControllerUpdateGroupLossData,
  type SamplesControllerUpdateGroupLossResponse,
  type SamplesControllerRefreshLossBulkData,
  type SamplesControllerRefreshLossBulkResponse,
  type SamplesControllerRefreshLossData,
  type SamplesControllerRefreshLossResponse,
  type SamplesControllerSetRepresentativeImageBulkData,
  type SamplesControllerSetRepresentativeImageBulkResponse,
  type SamplesControllerGetSampleDetailsAndImageData,
  type SamplesControllerGetSampleDetailsAndImageResponse,
  type SamplesControllerUpdateSampleData,
  type SamplesControllerUpdateSampleResponse,
  type SamplesControllerDeleteSampleData,
  type SamplesControllerDeleteSampleResponse,
  type SamplesControllerGetSampleDetailsData,
  type SamplesControllerGetSampleDetailsResponse,
  type SamplesControllerUpdateBulkData,
  type SamplesControllerUpdateBulkResponse,
  type SamplesControllerDeleteBulkData,
  type SamplesControllerDeleteBulkResponse,
  type SamplesControllerUpdateSamplesMetadataBulkData,
  type SamplesControllerUpdateSamplesMetadataBulkResponse,
  type SamplesControllerUpdateTagsBulkData,
  type SamplesControllerUpdateTagsBulkResponse,
  type SamplesControllerUpdateSampleMetadataData,
  type SamplesControllerUpdateSampleMetadataResponse,
  type SamplesControllerUpdateLossData,
  type SamplesControllerUpdateLossResponse,
  type SamplesControllerUploadBulkData,
  type SamplesControllerUploadBulkResponse,
  type SamplesControllerUploadSampleData,
  type SamplesControllerUploadSampleResponse,
  type SamplesControllerGetSampleImageData,
  type SamplesControllerGetSampleImageResponse,
  type SamplesControllerGetSampleThumbnailData,
  type SamplesControllerGetSampleThumbnailResponse,
  type SamplesControllerGetSampleImageInDeviceData,
  type SamplesControllerGetSampleImageInDeviceResponse,
  SamplesControllerGetSampleDetailsAndImageResponseTransformer,
  SamplesControllerGetSampleDetailsResponseTransformer,
  type ScheduleConfigDeploymentsControllerCreateScheduleData,
  type ScheduleConfigDeploymentsControllerCreateScheduleResponse,
  type ScheduleConfigDeploymentsControllerListScheduledData,
  type ScheduleConfigDeploymentsControllerListScheduledResponse,
  type ScheduleConfigDeploymentsControllerGetScheduledJobData,
  type ScheduleConfigDeploymentsControllerGetScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerUpdateScheduledJobData,
  type ScheduleConfigDeploymentsControllerUpdateScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerDeleteScheduledJobData,
  type ScheduleConfigDeploymentsControllerDeleteScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkData,
  type ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkResponse,
  type ScheduleConfigDeploymentsControllerStopScheduledJobsBulkData,
  type ScheduleConfigDeploymentsControllerStopScheduledJobsBulkResponse,
  type ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkData,
  type ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkResponse,
  type ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkData,
  type ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkResponse,
  type ScheduleConfigDeploymentsControllerStartScheduledJobData,
  type ScheduleConfigDeploymentsControllerStartScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerCancelScheduledJobData,
  type ScheduleConfigDeploymentsControllerCancelScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerStopScheduledJobData,
  type ScheduleConfigDeploymentsControllerStopScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerResumeScheduledJobData,
  type ScheduleConfigDeploymentsControllerResumeScheduledJobResponse,
  type ScheduleConfigDeploymentsControllerStartJobData,
  type ScheduleConfigDeploymentsControllerStartJobResponse,
  type ScheduleConfigDeploymentsControllerListSummariesData,
  type ScheduleConfigDeploymentsControllerListSummariesResponse,
  type ScheduleConfigDeploymentsControllerGetJobData,
  type ScheduleConfigDeploymentsControllerGetJobResponse,
  type ScheduleConfigDeploymentsControllerDeleteJobData,
  type ScheduleConfigDeploymentsControllerDeleteJobResponse,
  type ScheduleConfigDeploymentsControllerUpdateJobData,
  type ScheduleConfigDeploymentsControllerUpdateJobResponse,
  type ScheduleConfigDeploymentsControllerCancelJobData,
  type ScheduleConfigDeploymentsControllerCancelJobResponse,
  type ScheduleConfigDeploymentsControllerStopJobData,
  type ScheduleConfigDeploymentsControllerStopJobResponse,
  type ScheduleConfigDeploymentsControllerCancelJobsBulkData,
  type ScheduleConfigDeploymentsControllerCancelJobsBulkResponse,
  type ScheduleConfigDeploymentsControllerDeleteJobsBulkData,
  type ScheduleConfigDeploymentsControllerDeleteJobsBulkResponse,
  ScheduleConfigDeploymentsControllerCreateScheduleResponseTransformer,
  ScheduleConfigDeploymentsControllerGetScheduledJobResponseTransformer,
  ScheduleConfigDeploymentsControllerUpdateScheduledJobResponseTransformer,
  ScheduleConfigDeploymentsControllerStartScheduledJobResponseTransformer,
  ScheduleConfigDeploymentsControllerResumeScheduledJobResponseTransformer,
  ScheduleConfigDeploymentsControllerStartJobResponseTransformer,
  ScheduleConfigDeploymentsControllerGetJobResponseTransformer,
  ScheduleConfigDeploymentsControllerUpdateJobResponseTransformer,
  type ScheduledTrainingsControllerListSummariesData,
  type ScheduledTrainingsControllerListSummariesResponse,
  type ScheduledTrainingsControllerGetDetailsData,
  type ScheduledTrainingsControllerGetDetailsResponse,
  type ScheduledTrainingsControllerUpdateData,
  type ScheduledTrainingsControllerUpdateResponse,
  type ScheduledTrainingsControllerDeleteData,
  type ScheduledTrainingsControllerDeleteResponse,
  type ScheduledTrainingsControllerCreateScheduledTrainingData,
  type ScheduledTrainingsControllerCreateScheduledTrainingResponse,
  type ScheduledTrainingsControllerDeleteBulkData,
  type ScheduledTrainingsControllerDeleteBulkResponse,
  type ScheduledTrainingsControllerStartData,
  type ScheduledTrainingsControllerStartResponse,
  ScheduledTrainingsControllerGetDetailsResponseTransformer,
  type ScheduleModelDeploymentsControllerCreateScheduleData,
  type ScheduleModelDeploymentsControllerCreateScheduleResponse,
  type ScheduleModelDeploymentsControllerListScheduledData,
  type ScheduleModelDeploymentsControllerListScheduledResponse,
  type ScheduleModelDeploymentsControllerGetScheduledJobData,
  type ScheduleModelDeploymentsControllerGetScheduledJobResponse,
  type ScheduleModelDeploymentsControllerUpdateScheduledJobData,
  type ScheduleModelDeploymentsControllerUpdateScheduledJobResponse,
  type ScheduleModelDeploymentsControllerDeleteScheduledJobData,
  type ScheduleModelDeploymentsControllerDeleteScheduledJobResponse,
  type ScheduleModelDeploymentsControllerCancelScheduledJobsBulkData,
  type ScheduleModelDeploymentsControllerCancelScheduledJobsBulkResponse,
  type ScheduleModelDeploymentsControllerStopScheduledJobsBulkData,
  type ScheduleModelDeploymentsControllerStopScheduledJobsBulkResponse,
  type ScheduleModelDeploymentsControllerResumeScheduledJobsBulkData,
  type ScheduleModelDeploymentsControllerResumeScheduledJobsBulkResponse,
  type ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkData,
  type ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkResponse,
  type ScheduleModelDeploymentsControllerStartScheduledJobData,
  type ScheduleModelDeploymentsControllerStartScheduledJobResponse,
  type ScheduleModelDeploymentsControllerCancelScheduledJobData,
  type ScheduleModelDeploymentsControllerCancelScheduledJobResponse,
  type ScheduleModelDeploymentsControllerStopScheduledJobData,
  type ScheduleModelDeploymentsControllerStopScheduledJobResponse,
  type ScheduleModelDeploymentsControllerResumeScheduledJobData,
  type ScheduleModelDeploymentsControllerResumeScheduledJobResponse,
  type ScheduleModelDeploymentsControllerStartJobData,
  type ScheduleModelDeploymentsControllerStartJobResponse,
  type ScheduleModelDeploymentsControllerListSummariesData,
  type ScheduleModelDeploymentsControllerListSummariesResponse,
  type ScheduleModelDeploymentsControllerGetJobData,
  type ScheduleModelDeploymentsControllerGetJobResponse,
  type ScheduleModelDeploymentsControllerDeleteJobData,
  type ScheduleModelDeploymentsControllerDeleteJobResponse,
  type ScheduleModelDeploymentsControllerUpdateJobData,
  type ScheduleModelDeploymentsControllerUpdateJobResponse,
  type ScheduleModelDeploymentsControllerCancelJobData,
  type ScheduleModelDeploymentsControllerCancelJobResponse,
  type ScheduleModelDeploymentsControllerStopJobData,
  type ScheduleModelDeploymentsControllerStopJobResponse,
  type ScheduleModelDeploymentsControllerCancelJobsBulkData,
  type ScheduleModelDeploymentsControllerCancelJobsBulkResponse,
  type ScheduleModelDeploymentsControllerDeleteJobsBulkData,
  type ScheduleModelDeploymentsControllerDeleteJobsBulkResponse,
  ScheduleModelDeploymentsControllerCreateScheduleResponseTransformer,
  ScheduleModelDeploymentsControllerGetScheduledJobResponseTransformer,
  ScheduleModelDeploymentsControllerUpdateScheduledJobResponseTransformer,
  ScheduleModelDeploymentsControllerStartScheduledJobResponseTransformer,
  ScheduleModelDeploymentsControllerResumeScheduledJobResponseTransformer,
  ScheduleModelDeploymentsControllerStartJobResponseTransformer,
  ScheduleModelDeploymentsControllerGetJobResponseTransformer,
  ScheduleModelDeploymentsControllerUpdateJobResponseTransformer,
  type ServiceHealthChecksControllerTestData,
  type ServiceHealthChecksControllerTestResponse,
  type ServiceHealthChecksControllerCreateScheduleData,
  type ServiceHealthChecksControllerCreateScheduleResponse,
  type ServiceHealthChecksControllerListScheduledData,
  type ServiceHealthChecksControllerListScheduledResponse,
  type ServiceHealthChecksControllerGetScheduledJobData,
  type ServiceHealthChecksControllerGetScheduledJobResponse,
  type ServiceHealthChecksControllerUpdateScheduledJobData,
  type ServiceHealthChecksControllerUpdateScheduledJobResponse,
  type ServiceHealthChecksControllerDeleteScheduledJobData,
  type ServiceHealthChecksControllerDeleteScheduledJobResponse,
  type ServiceHealthChecksControllerCancelScheduledJobsBulkData,
  type ServiceHealthChecksControllerCancelScheduledJobsBulkResponse,
  type ServiceHealthChecksControllerStopScheduledJobsBulkData,
  type ServiceHealthChecksControllerStopScheduledJobsBulkResponse,
  type ServiceHealthChecksControllerResumeScheduledJobsBulkData,
  type ServiceHealthChecksControllerResumeScheduledJobsBulkResponse,
  type ServiceHealthChecksControllerDeleteScheduledJobsBulkData,
  type ServiceHealthChecksControllerDeleteScheduledJobsBulkResponse,
  type ServiceHealthChecksControllerStartScheduledJobData,
  type ServiceHealthChecksControllerStartScheduledJobResponse,
  type ServiceHealthChecksControllerCancelScheduledJobData,
  type ServiceHealthChecksControllerCancelScheduledJobResponse,
  type ServiceHealthChecksControllerStopScheduledJobData,
  type ServiceHealthChecksControllerStopScheduledJobResponse,
  type ServiceHealthChecksControllerResumeScheduledJobData,
  type ServiceHealthChecksControllerResumeScheduledJobResponse,
  type ServiceHealthChecksControllerStartJobData,
  type ServiceHealthChecksControllerStartJobResponse,
  type ServiceHealthChecksControllerListSummariesData,
  type ServiceHealthChecksControllerListSummariesResponse,
  type ServiceHealthChecksControllerGetJobData,
  type ServiceHealthChecksControllerGetJobResponse,
  type ServiceHealthChecksControllerDeleteJobData,
  type ServiceHealthChecksControllerDeleteJobResponse,
  type ServiceHealthChecksControllerUpdateJobData,
  type ServiceHealthChecksControllerUpdateJobResponse,
  type ServiceHealthChecksControllerCancelJobData,
  type ServiceHealthChecksControllerCancelJobResponse,
  type ServiceHealthChecksControllerStopJobData,
  type ServiceHealthChecksControllerStopJobResponse,
  type ServiceHealthChecksControllerCancelJobsBulkData,
  type ServiceHealthChecksControllerCancelJobsBulkResponse,
  type ServiceHealthChecksControllerDeleteJobsBulkData,
  type ServiceHealthChecksControllerDeleteJobsBulkResponse,
  ServiceHealthChecksControllerCreateScheduleResponseTransformer,
  ServiceHealthChecksControllerGetScheduledJobResponseTransformer,
  ServiceHealthChecksControllerUpdateScheduledJobResponseTransformer,
  ServiceHealthChecksControllerStartScheduledJobResponseTransformer,
  ServiceHealthChecksControllerResumeScheduledJobResponseTransformer,
  ServiceHealthChecksControllerStartJobResponseTransformer,
  ServiceHealthChecksControllerGetJobResponseTransformer,
  ServiceHealthChecksControllerUpdateJobResponseTransformer,
  type SessionsControllerListSessionsCountData,
  type SessionsControllerListSessionsCountResponse,
  type SessionsControllerListSessionsAlertsData,
  type SessionsControllerListSessionsAlertsResponse,
  type SessionsControllerGetSessionData,
  type SessionsControllerGetSessionResponse,
  type SessionsControllerListSessionsData,
  type SessionsControllerListSessionsResponse,
  type SessionsControllerDownloadSessionVideoData,
  type SessionsControllerDownloadSessionVideoResponse,
  type SessionsControllerDownloadSessionVisualizationData,
  type SessionsControllerDownloadSessionVisualizationResponse,
  type SessionsControllerStreamSessionData,
  type SessionsControllerStreamSessionResponse,
  type SessionsControllerUpdateTagsBulkData,
  type SessionsControllerUpdateTagsBulkResponse,
  type SessionsControllerUpdateAssigneeBulkData,
  type SessionsControllerUpdateAssigneeBulkResponse,
  SessionsControllerGetSessionResponseTransformer,
  type SessionsTaggingControllerListTagsData,
  type SessionsTaggingControllerListTagsResponse,
  type SessionsTaggingControllerCreateTagsData,
  type SessionsTaggingControllerCreateTagsResponse,
  type SessionsTaggingControllerAssignTagsData,
  type SessionsTaggingControllerAssignTagsResponse,
  type SessionsTaggingControllerUnassignTagsData,
  type SessionsTaggingControllerUnassignTagsResponse,
  type SessionsTaggingControllerGetDetailsData,
  type SessionsTaggingControllerGetDetailsResponse,
  type SessionsTaggingControllerUpdateTagData,
  type SessionsTaggingControllerUpdateTagResponse,
  type SessionsTaggingControllerDeleteTagData,
  type SessionsTaggingControllerDeleteTagResponse,
  type SessionsTaggingControllerMergeTagToData,
  type SessionsTaggingControllerMergeTagToResponse,
  type SessionsTaggingControllerListSummariesData,
  type SessionsTaggingControllerListSummariesResponse,
  SessionsTaggingControllerGetDetailsResponseTransformer,
  SessionsTaggingControllerUpdateTagResponseTransformer,
  type SiteGroupsControllerUpsertOperationalHoursBulkData,
  type SiteGroupsControllerUpsertOperationalHoursBulkResponse,
  type SiteGroupsControllerListSummariesData,
  type SiteGroupsControllerListSummariesResponse,
  type SiteGroupsControllerDetailsData,
  type SiteGroupsControllerDetailsResponse,
  type SiteGroupsControllerUpdateData,
  type SiteGroupsControllerUpdateResponse,
  type SiteGroupsControllerDeleteData,
  type SiteGroupsControllerDeleteResponse,
  type SiteGroupsControllerCreateData,
  type SiteGroupsControllerCreateResponse,
  type SiteGroupsControllerUpsertOperationalHoursData,
  type SiteGroupsControllerUpsertOperationalHoursResponse,
  type SiteGroupsControllerAddSitesData,
  type SiteGroupsControllerAddSitesResponse,
  type SiteGroupsControllerRemoveSitesData,
  type SiteGroupsControllerRemoveSitesResponse,
  type SiteGroupsControllerGetLabelsData,
  type SiteGroupsControllerGetLabelsResponse,
  type SiteGroupsControllerDownloadLabelsData,
  type SiteGroupsControllerDownloadLabelsResponse,
  type SiteGroupsControllerBulkUpdateLabelsData,
  type SiteGroupsControllerBulkUpdateLabelsResponse,
  type SiteGroupsControllerCheckDuplicateLabelData,
  type SiteGroupsControllerCheckDuplicateLabelResponse,
  SiteGroupsControllerDetailsResponseTransformer,
  SiteGroupsControllerGetLabelsResponseTransformer,
  type SitesControllerDownloadData,
  type SitesControllerDownloadResponse,
  type SitesControllerCreateData,
  type SitesControllerCreateResponse,
  type SitesControllerListSummariesData,
  type SitesControllerListSummariesResponse,
  type SitesControllerListMinimalData,
  type SitesControllerListMinimalResponse,
  type SitesControllerGetRegionsData,
  type SitesControllerGetRegionsResponse,
  type SitesControllerUpdateRegionsData,
  type SitesControllerUpdateRegionsResponse,
  type SitesControllerGetSubRegionsData,
  type SitesControllerGetSubRegionsResponse,
  type SitesControllerUpdateTagsBulkData,
  type SitesControllerUpdateTagsBulkResponse,
  type SitesControllerDeployModelBulkData,
  type SitesControllerDeployModelBulkResponse,
  type SitesControllerUpdateActivationTimeData,
  type SitesControllerUpdateActivationTimeResponse,
  type SitesControllerUpdateSiteGroupBulkData,
  type SitesControllerUpdateSiteGroupBulkResponse,
  type SitesControllerDeployServiceVersionBulkData,
  type SitesControllerDeployServiceVersionBulkResponse,
  type SitesControllerDeployConfigBulkData,
  type SitesControllerDeployConfigBulkResponse,
  type SitesControllerUpsertOperationalHoursBulkData,
  type SitesControllerUpsertOperationalHoursBulkResponse,
  type SitesControllerListAvailableComponentVersionsData,
  type SitesControllerListAvailableComponentVersionsResponse,
  type SitesControllerUploadData,
  type SitesControllerUploadResponse,
  type SitesControllerGetDetailsData,
  type SitesControllerGetDetailsResponse,
  type SitesControllerUpdateData,
  type SitesControllerUpdateResponse,
  type SitesControllerDeployVersionData,
  type SitesControllerDeployVersionResponse,
  type SitesControllerGetVersionHistoryData,
  type SitesControllerGetVersionHistoryResponse,
  type SitesControllerDeployServiceData,
  type SitesControllerDeployServiceResponse,
  type SitesControllerGetServiceDeploymentsData,
  type SitesControllerGetServiceDeploymentsResponse,
  type SitesControllerGetAvailableServiceVersionsData,
  type SitesControllerGetAvailableServiceVersionsResponse,
  type SitesControllerGetLatestSiteDeviceDeploymentData,
  type SitesControllerGetLatestSiteDeviceDeploymentResponse,
  type SitesControllerAddDevicesData,
  type SitesControllerAddDevicesResponse,
  type SitesControllerRemoveDevicesData,
  type SitesControllerRemoveDevicesResponse,
  type SitesControllerDeleteData,
  type SitesControllerDeleteResponse,
  type SitesControllerUpsertOperationalHoursData,
  type SitesControllerUpsertOperationalHoursResponse,
  SitesControllerUploadResponseTransformer,
  SitesControllerGetDetailsResponseTransformer,
  type SitesTaggingControllerListTagsData,
  type SitesTaggingControllerListTagsResponse,
  type SitesTaggingControllerCreateTagsData,
  type SitesTaggingControllerCreateTagsResponse,
  type SitesTaggingControllerAssignTagsData,
  type SitesTaggingControllerAssignTagsResponse,
  type SitesTaggingControllerUnassignTagsData,
  type SitesTaggingControllerUnassignTagsResponse,
  type SitesTaggingControllerGetDetailsData,
  type SitesTaggingControllerGetDetailsResponse,
  type SitesTaggingControllerUpdateTagData,
  type SitesTaggingControllerUpdateTagResponse,
  type SitesTaggingControllerDeleteTagData,
  type SitesTaggingControllerDeleteTagResponse,
  type SitesTaggingControllerMergeTagToData,
  type SitesTaggingControllerMergeTagToResponse,
  type SitesTaggingControllerListSummariesData,
  type SitesTaggingControllerListSummariesResponse,
  SitesTaggingControllerGetDetailsResponseTransformer,
  SitesTaggingControllerUpdateTagResponseTransformer,
  type SlackControllerCallbackData,
  type SlackControllerCallbackResponse,
  type SlackControllerGetSlackAuthUrlData,
  type SlackControllerGetSlackAuthUrlResponse,
  type SlackControllerGetGlobalSlackAuthUrlData,
  type SlackControllerGetGlobalSlackAuthUrlResponse,
  type SlackControllerTestRecurrenceNotificationData,
  type SlackControllerTestRecurrenceNotificationResponse,
  type SlackControllerTestPartialResolveNotificationData,
  type SlackControllerTestPartialResolveNotificationResponse,
  type SlackControllerTestCreateAlertData,
  type SlackControllerTestCreateAlertResponse,
  type SlackControllerTestResolveAlertData,
  type SlackControllerTestResolveAlertResponse,
  type StaticDatasetsControllerListData,
  type StaticDatasetsControllerListResponse,
  type StaticDatasetsControllerListMinimalResponse,
  type StaticDatasetsControllerGetDetailsData,
  type StaticDatasetsControllerGetDetailsResponse,
  type StaticDatasetsControllerDeleteData,
  type StaticDatasetsControllerDeleteResponse,
  type StaticDatasetsControllerCountSamplesData,
  type StaticDatasetsControllerCountSamplesResponse,
  type StaticDatasetsControllerAnalyzeData,
  type StaticDatasetsControllerAnalyzeResponse,
  type StaticDatasetsControllerCreateData,
  type StaticDatasetsControllerCreateResponse,
  type StaticDatasetsControllerUploadData,
  type StaticDatasetsControllerUploadResponse,
  type StaticDatasetsControllerStartData,
  type StaticDatasetsControllerStartResponse,
  type StaticDatasetsControllerCreateEmptyData,
  type StaticDatasetsControllerCreateEmptyResponse,
  type StaticDatasetsControllerAddSamplesFromFilterData,
  type StaticDatasetsControllerAddSamplesFromFilterResponse,
  type StaticDatasetsControllerRetryMissingSamplesData,
  type StaticDatasetsControllerRetryMissingSamplesResponse,
  type StaticDatasetsControllerRecalculateAnalyticsData,
  type StaticDatasetsControllerRecalculateAnalyticsResponse,
  type StaticDatasetsControllerResumeFromSamplesData,
  type StaticDatasetsControllerResumeFromSamplesResponse,
  type StaticDatasetsControllerAddSessionsFromFilterData,
  type StaticDatasetsControllerAddSessionsFromFilterResponse,
  type StaticDatasetsControllerRetryMissingSessionsData,
  type StaticDatasetsControllerRetryMissingSessionsResponse,
  type StaticDatasetsControllerResumeFromSessionsData,
  type StaticDatasetsControllerResumeFromSessionsResponse,
  StaticDatasetsControllerGetDetailsResponseTransformer,
  type SyncGroundTruthsControllerCreateScheduleData,
  type SyncGroundTruthsControllerCreateScheduleResponse,
  type SyncGroundTruthsControllerListScheduledData,
  type SyncGroundTruthsControllerListScheduledResponse,
  type SyncGroundTruthsControllerGetScheduledJobData,
  type SyncGroundTruthsControllerGetScheduledJobResponse,
  type SyncGroundTruthsControllerUpdateScheduledJobData,
  type SyncGroundTruthsControllerUpdateScheduledJobResponse,
  type SyncGroundTruthsControllerDeleteScheduledJobData,
  type SyncGroundTruthsControllerDeleteScheduledJobResponse,
  type SyncGroundTruthsControllerCancelScheduledJobsBulkData,
  type SyncGroundTruthsControllerCancelScheduledJobsBulkResponse,
  type SyncGroundTruthsControllerStopScheduledJobsBulkData,
  type SyncGroundTruthsControllerStopScheduledJobsBulkResponse,
  type SyncGroundTruthsControllerResumeScheduledJobsBulkData,
  type SyncGroundTruthsControllerResumeScheduledJobsBulkResponse,
  type SyncGroundTruthsControllerDeleteScheduledJobsBulkData,
  type SyncGroundTruthsControllerDeleteScheduledJobsBulkResponse,
  type SyncGroundTruthsControllerStartScheduledJobData,
  type SyncGroundTruthsControllerStartScheduledJobResponse,
  type SyncGroundTruthsControllerCancelScheduledJobData,
  type SyncGroundTruthsControllerCancelScheduledJobResponse,
  type SyncGroundTruthsControllerStopScheduledJobData,
  type SyncGroundTruthsControllerStopScheduledJobResponse,
  type SyncGroundTruthsControllerResumeScheduledJobData,
  type SyncGroundTruthsControllerResumeScheduledJobResponse,
  type SyncGroundTruthsControllerStartJobData,
  type SyncGroundTruthsControllerStartJobResponse,
  type SyncGroundTruthsControllerListSummariesData,
  type SyncGroundTruthsControllerListSummariesResponse,
  type SyncGroundTruthsControllerGetJobData,
  type SyncGroundTruthsControllerGetJobResponse,
  type SyncGroundTruthsControllerDeleteJobData,
  type SyncGroundTruthsControllerDeleteJobResponse,
  type SyncGroundTruthsControllerUpdateJobData,
  type SyncGroundTruthsControllerUpdateJobResponse,
  type SyncGroundTruthsControllerCancelJobData,
  type SyncGroundTruthsControllerCancelJobResponse,
  type SyncGroundTruthsControllerStopJobData,
  type SyncGroundTruthsControllerStopJobResponse,
  type SyncGroundTruthsControllerCancelJobsBulkData,
  type SyncGroundTruthsControllerCancelJobsBulkResponse,
  type SyncGroundTruthsControllerDeleteJobsBulkData,
  type SyncGroundTruthsControllerDeleteJobsBulkResponse,
  SyncGroundTruthsControllerCreateScheduleResponseTransformer,
  SyncGroundTruthsControllerGetScheduledJobResponseTransformer,
  SyncGroundTruthsControllerUpdateScheduledJobResponseTransformer,
  SyncGroundTruthsControllerStartScheduledJobResponseTransformer,
  SyncGroundTruthsControllerResumeScheduledJobResponseTransformer,
  SyncGroundTruthsControllerStartJobResponseTransformer,
  SyncGroundTruthsControllerGetJobResponseTransformer,
  SyncGroundTruthsControllerUpdateJobResponseTransformer,
  type TagsControllerListTagsData,
  type TagsControllerListTagsResponse,
  type TagsControllerCreateData,
  type TagsControllerCreateResponse,
  type TagsControllerSetTagsData,
  type TagsControllerSetTagsResponse,
  type TagsControllerDeleteData,
  type TagsControllerDeleteResponse,
  type TagsControllerUpdateData,
  type TagsControllerUpdateResponse,
  type TagsControllerGetDetailsData,
  type TagsControllerGetDetailsResponse,
  type TagsControllerMergeTagToData,
  type TagsControllerMergeTagToResponse,
  type TagsControllerAssignTagsData,
  type TagsControllerAssignTagsResponse,
  type TagsControllerSetGroupTagsData,
  type TagsControllerSetGroupTagsResponse,
  type TagsControllerUpdateGroupTagsData,
  type TagsControllerUpdateGroupTagsResponse,
  type TagsControllerAssignGroupTagsData,
  type TagsControllerAssignGroupTagsResponse,
  type TagsControllerUnassignGroupTagsData,
  type TagsControllerUnassignGroupTagsResponse,
  type TagsControllerUnassignTagsData,
  type TagsControllerUnassignTagsResponse,
  TagsControllerUpdateResponseTransformer,
  TagsControllerGetDetailsResponseTransformer,
  type TrainingsControllerListSummariesData,
  type TrainingsControllerListSummariesResponse,
  type TrainingsControllerGetDefaultsResponse,
  type TrainingsControllerUpdateDefaultsData,
  type TrainingsControllerUpdateDefaultsResponse,
  type TrainingsControllerClearDefaultsResponse,
  type TrainingsControllerGetDetailsData,
  type TrainingsControllerGetDetailsResponse,
  type TrainingsControllerUpdateData,
  type TrainingsControllerUpdateResponse,
  type TrainingsControllerGetTrainingExecutionDetailsData,
  type TrainingsControllerGetTrainingExecutionDetailsResponse,
  type TrainingsControllerGetParticipationsData,
  type TrainingsControllerGetParticipationsResponse,
  type TrainingsControllerGetSampleStatsData,
  type TrainingsControllerGetSampleStatsResponse,
  type TrainingsControllerDeleteTrainingsBulkData,
  type TrainingsControllerDeleteTrainingsBulkResponse,
  type TrainingsControllerCancelTrainingsBulkData,
  type TrainingsControllerCancelTrainingsBulkResponse,
  type TrainingsControllerCreateTrainingData,
  type TrainingsControllerCreateTrainingResponse,
  type TrainingsControllerCancelTrainingData,
  type TrainingsControllerCancelTrainingResponse,
  type TrainingsControllerCreateModelData,
  type TrainingsControllerCreateModelResponse,
  TrainingsControllerGetDefaultsResponseTransformer,
  TrainingsControllerUpdateDefaultsResponseTransformer,
  TrainingsControllerClearDefaultsResponseTransformer,
  TrainingsControllerGetDetailsResponseTransformer,
  TrainingsControllerGetTrainingExecutionDetailsResponseTransformer,
  TrainingsControllerGetSampleStatsResponseTransformer,
  type UploadSamplesControllerCreateScheduleData,
  type UploadSamplesControllerCreateScheduleResponse,
  type UploadSamplesControllerListScheduledData,
  type UploadSamplesControllerListScheduledResponse,
  type UploadSamplesControllerGetScheduledJobData,
  type UploadSamplesControllerGetScheduledJobResponse,
  type UploadSamplesControllerUpdateScheduledJobData,
  type UploadSamplesControllerUpdateScheduledJobResponse,
  type UploadSamplesControllerDeleteScheduledJobData,
  type UploadSamplesControllerDeleteScheduledJobResponse,
  type UploadSamplesControllerCancelScheduledJobsBulkData,
  type UploadSamplesControllerCancelScheduledJobsBulkResponse,
  type UploadSamplesControllerStopScheduledJobsBulkData,
  type UploadSamplesControllerStopScheduledJobsBulkResponse,
  type UploadSamplesControllerResumeScheduledJobsBulkData,
  type UploadSamplesControllerResumeScheduledJobsBulkResponse,
  type UploadSamplesControllerDeleteScheduledJobsBulkData,
  type UploadSamplesControllerDeleteScheduledJobsBulkResponse,
  type UploadSamplesControllerStartScheduledJobData,
  type UploadSamplesControllerStartScheduledJobResponse,
  type UploadSamplesControllerCancelScheduledJobData,
  type UploadSamplesControllerCancelScheduledJobResponse,
  type UploadSamplesControllerStopScheduledJobData,
  type UploadSamplesControllerStopScheduledJobResponse,
  type UploadSamplesControllerResumeScheduledJobData,
  type UploadSamplesControllerResumeScheduledJobResponse,
  type UploadSamplesControllerStartJobData,
  type UploadSamplesControllerStartJobResponse,
  type UploadSamplesControllerListSummariesData,
  type UploadSamplesControllerListSummariesResponse,
  type UploadSamplesControllerGetJobData,
  type UploadSamplesControllerGetJobResponse,
  type UploadSamplesControllerDeleteJobData,
  type UploadSamplesControllerDeleteJobResponse,
  type UploadSamplesControllerUpdateJobData,
  type UploadSamplesControllerUpdateJobResponse,
  type UploadSamplesControllerCancelJobData,
  type UploadSamplesControllerCancelJobResponse,
  type UploadSamplesControllerStopJobData,
  type UploadSamplesControllerStopJobResponse,
  type UploadSamplesControllerCancelJobsBulkData,
  type UploadSamplesControllerCancelJobsBulkResponse,
  type UploadSamplesControllerDeleteJobsBulkData,
  type UploadSamplesControllerDeleteJobsBulkResponse,
  UploadSamplesControllerCreateScheduleResponseTransformer,
  UploadSamplesControllerGetScheduledJobResponseTransformer,
  UploadSamplesControllerUpdateScheduledJobResponseTransformer,
  UploadSamplesControllerStartScheduledJobResponseTransformer,
  UploadSamplesControllerResumeScheduledJobResponseTransformer,
  UploadSamplesControllerStartJobResponseTransformer,
  UploadSamplesControllerGetJobResponseTransformer,
  UploadSamplesControllerUpdateJobResponseTransformer,
  type UploadVideosControllerGetStorageUriResponse,
  type UploadVideosControllerCreateScheduleData,
  type UploadVideosControllerCreateScheduleResponse,
  type UploadVideosControllerListScheduledData,
  type UploadVideosControllerListScheduledResponse,
  type UploadVideosControllerGetScheduledJobData,
  type UploadVideosControllerGetScheduledJobResponse,
  type UploadVideosControllerUpdateScheduledJobData,
  type UploadVideosControllerUpdateScheduledJobResponse,
  type UploadVideosControllerDeleteScheduledJobData,
  type UploadVideosControllerDeleteScheduledJobResponse,
  type UploadVideosControllerCancelScheduledJobsBulkData,
  type UploadVideosControllerCancelScheduledJobsBulkResponse,
  type UploadVideosControllerStopScheduledJobsBulkData,
  type UploadVideosControllerStopScheduledJobsBulkResponse,
  type UploadVideosControllerResumeScheduledJobsBulkData,
  type UploadVideosControllerResumeScheduledJobsBulkResponse,
  type UploadVideosControllerDeleteScheduledJobsBulkData,
  type UploadVideosControllerDeleteScheduledJobsBulkResponse,
  type UploadVideosControllerStartScheduledJobData,
  type UploadVideosControllerStartScheduledJobResponse,
  type UploadVideosControllerCancelScheduledJobData,
  type UploadVideosControllerCancelScheduledJobResponse,
  type UploadVideosControllerStopScheduledJobData,
  type UploadVideosControllerStopScheduledJobResponse,
  type UploadVideosControllerResumeScheduledJobData,
  type UploadVideosControllerResumeScheduledJobResponse,
  type UploadVideosControllerStartJobData,
  type UploadVideosControllerStartJobResponse,
  type UploadVideosControllerListSummariesData,
  type UploadVideosControllerListSummariesResponse,
  type UploadVideosControllerGetJobData,
  type UploadVideosControllerGetJobResponse,
  type UploadVideosControllerDeleteJobData,
  type UploadVideosControllerDeleteJobResponse,
  type UploadVideosControllerUpdateJobData,
  type UploadVideosControllerUpdateJobResponse,
  type UploadVideosControllerCancelJobData,
  type UploadVideosControllerCancelJobResponse,
  type UploadVideosControllerStopJobData,
  type UploadVideosControllerStopJobResponse,
  type UploadVideosControllerCancelJobsBulkData,
  type UploadVideosControllerCancelJobsBulkResponse,
  type UploadVideosControllerDeleteJobsBulkData,
  type UploadVideosControllerDeleteJobsBulkResponse,
  UploadVideosControllerCreateScheduleResponseTransformer,
  UploadVideosControllerGetScheduledJobResponseTransformer,
  UploadVideosControllerUpdateScheduledJobResponseTransformer,
  UploadVideosControllerStartScheduledJobResponseTransformer,
  UploadVideosControllerResumeScheduledJobResponseTransformer,
  UploadVideosControllerStartJobResponseTransformer,
  UploadVideosControllerGetJobResponseTransformer,
  UploadVideosControllerUpdateJobResponseTransformer,
  type UsersControllerAssignSitesData,
  type UsersControllerAssignSitesResponse,
  type UsersControllerMeResponse,
  type UsersControllerListEmailsData,
  type UsersControllerListEmailsResponse,
  type UsersControllerRelatedAccountsResponse,
  type UsersControllerCheckUserData,
  type UsersControllerCheckUserResponse,
  type UsersControllerInviteUserToAccountData,
  type UsersControllerInviteUserToAccountResponse,
  type UsersControllerCreateData,
  type UsersControllerCreateResponse,
  type UsersControllerFindAllData,
  type UsersControllerFindAllResponse,
  type UsersControllerListMinimalData,
  type UsersControllerListMinimalResponse,
  type UsersControllerDownloadData,
  type UsersControllerDownloadResponse,
  type UsersControllerGetRoleCreatePermissionResponse,
  type UsersControllerFindOneData,
  type UsersControllerFindOneResponse,
  type UsersControllerRemoveData,
  type UsersControllerRemoveResponse,
  type UsersControllerUpdateData,
  type UsersControllerUpdateResponse,
  type UsersControllerUpdateTableSettingsData,
  type UsersControllerUpdateTableSettingsResponse,
  type UsersControllerDeleteTableSettingsData,
  type UsersControllerDeleteTableSettingsResponse,
  type UsersControllerAdminUpdateData,
  type UsersControllerAdminUpdateResponse,
  type UsersControllerDeleteUsersBulkData,
  type UsersControllerDeleteUsersBulkResponse,
  type UsersControllerInviteUsersToReportData,
  type UsersControllerInviteUsersToReportResponse,
  UsersControllerMeResponseTransformer,
  type WorkerJobControllerGetJobInputData,
  type WorkerJobControllerGetJobInputResponse,
  type WorkerJobControllerGetTokenData,
  type WorkerJobControllerGetTokenResponse,
  type WorkerJobControllerCreateScheduleData,
  type WorkerJobControllerCreateScheduleResponse,
  type WorkerJobControllerListScheduledData,
  type WorkerJobControllerListScheduledResponse,
  type WorkerJobControllerGetScheduledJobData,
  type WorkerJobControllerGetScheduledJobResponse,
  type WorkerJobControllerUpdateScheduledJobData,
  type WorkerJobControllerUpdateScheduledJobResponse,
  type WorkerJobControllerDeleteScheduledJobData,
  type WorkerJobControllerDeleteScheduledJobResponse,
  type WorkerJobControllerCancelScheduledJobsBulkData,
  type WorkerJobControllerCancelScheduledJobsBulkResponse,
  type WorkerJobControllerStopScheduledJobsBulkData,
  type WorkerJobControllerStopScheduledJobsBulkResponse,
  type WorkerJobControllerResumeScheduledJobsBulkData,
  type WorkerJobControllerResumeScheduledJobsBulkResponse,
  type WorkerJobControllerDeleteScheduledJobsBulkData,
  type WorkerJobControllerDeleteScheduledJobsBulkResponse,
  type WorkerJobControllerStartScheduledJobData,
  type WorkerJobControllerStartScheduledJobResponse,
  type WorkerJobControllerCancelScheduledJobData,
  type WorkerJobControllerCancelScheduledJobResponse,
  type WorkerJobControllerStopScheduledJobData,
  type WorkerJobControllerStopScheduledJobResponse,
  type WorkerJobControllerResumeScheduledJobData,
  type WorkerJobControllerResumeScheduledJobResponse,
  type WorkerJobControllerStartJobData,
  type WorkerJobControllerStartJobResponse,
  type WorkerJobControllerListSummariesData,
  type WorkerJobControllerListSummariesResponse,
  type WorkerJobControllerGetJobData,
  type WorkerJobControllerGetJobResponse,
  type WorkerJobControllerDeleteJobData,
  type WorkerJobControllerDeleteJobResponse,
  type WorkerJobControllerUpdateJobData,
  type WorkerJobControllerUpdateJobResponse,
  type WorkerJobControllerCancelJobData,
  type WorkerJobControllerCancelJobResponse,
  type WorkerJobControllerStopJobData,
  type WorkerJobControllerStopJobResponse,
  type WorkerJobControllerCancelJobsBulkData,
  type WorkerJobControllerCancelJobsBulkResponse,
  type WorkerJobControllerDeleteJobsBulkData,
  type WorkerJobControllerDeleteJobsBulkResponse,
  WorkerJobControllerCreateScheduleResponseTransformer,
  WorkerJobControllerGetScheduledJobResponseTransformer,
  WorkerJobControllerUpdateScheduledJobResponseTransformer,
  WorkerJobControllerStartScheduledJobResponseTransformer,
  WorkerJobControllerResumeScheduledJobResponseTransformer,
  WorkerJobControllerStartJobResponseTransformer,
  WorkerJobControllerGetJobResponseTransformer,
  WorkerJobControllerUpdateJobResponseTransformer,
  type DeviceControllerDownloadModel0Data,
  type DeviceControllerDownloadModel0Response,
  type DeviceControllerDownloadModel1Data,
  type DeviceControllerDownloadModel1Response,
  type DeviceControllerGetCurrentTime0Response,
  type DeviceControllerGetCurrentTime1Response,
  type DeviceControllerSavePredictions0Response,
  type DeviceControllerSavePredictions1Response,
  type DeviceControllerSaveGroundTruths0Response,
  type DeviceControllerSaveGroundTruths1Response,
  type DeviceControllerSaveEvents0Response,
  type DeviceControllerSaveEvents1Response,
  type DeviceControllerSaveDataStream0Response,
  type DeviceControllerSaveDataStream1Response,
  type DeviceControllerGetClusterInfo0Response,
  type DeviceControllerGetClusterInfo1Response,
  type DeviceControllerGetLookupTable0Response,
  type DeviceControllerGetLookupTable1Response,
  type DeviceControllerSaveVideo0Data,
  type DeviceControllerSaveVideo0Response,
  type DeviceControllerSaveVideo1Data,
  type DeviceControllerSaveVideo1Response,
  type DeviceControllerSaveImage0Data,
  type DeviceControllerSaveImage0Response,
  type DeviceControllerSaveImage1Data,
  type DeviceControllerSaveImage1Response,
  type DeviceControllerSaveLog0Response,
  type DeviceControllerSaveLog1Response,
  type DeviceControllerDownloadAgent0Data,
  type DeviceControllerDownloadAgent0Response,
  type DeviceControllerDownloadAgent1Data,
  type DeviceControllerDownloadAgent1Response,
  type DeviceJobsControllerUpdateStatusData,
  type DeviceJobsControllerUpdateStatusResponse,
  type DeviceRegistrationControllerRegisterDevice0Data,
  type DeviceRegistrationControllerRegisterDevice0Response,
  type DeviceRegistrationControllerRegisterDevice1Data,
  type DeviceRegistrationControllerRegisterDevice1Response,
  type TrainingControllerGetDetailsResponse,
  type TrainingControllerUpdateTrainingDeviceStateData,
  type TrainingControllerUpdateTrainingDeviceStateResponse,
  type TrainingControllerCreateMetricResponse,
  type TrainingControllerGetMetricData,
  type TrainingControllerGetMetricResponse,
  type TrainingControllerGetPreTrainedModelMetricData,
  type TrainingControllerGetPreTrainedModelMetricResponse,
  type TrainingControllerCreateCheckpointData,
  type TrainingControllerCreateCheckpointResponse,
  type TrainingControllerDownloadCheckpointResponse,
  type TrainingControllerDownloadPreTrainedModelResponse,
  type EventsControllerListEventsCountData,
  type EventsControllerListEventsCountResponse,
  type EventsControllerListEventsData,
  type EventsControllerListEventsResponse,
  type EventsControllerCreateData,
  type EventsControllerCreateResponse,
  type EventsControllerListEventNamesData,
  type EventsControllerListEventNamesResponse,
  type HealthControllerDetailedCheckResponse,
  type HealthControllerCheckResponse,
  type McpToolsControllerGetOverviewResponse,
  type McpToolsControllerGetModelsResponse,
  type McpToolsControllerGetModelByIdData,
  type McpToolsControllerGetModelByIdResponse,
  type McpToolsControllerGetDevicesResponse,
  type McpToolsControllerGetDeviceStateCountsResponse,
  type McpToolsControllerGetClustersResponse,
  type McpToolsControllerGetDatasetsResponse,
  type McpToolsControllerGetTrainingsResponse,
  type McpToolsControllerGetTrainingByIdData,
  type McpToolsControllerGetTrainingByIdResponse,
  type McpToolsControllerGetLabelDistributionResponse,
  type McpToolsControllerGetSamplesResponse,
  type McpToolsControllerGetSamplesCountResponse,
  type McpToolsControllerGetSampleByUuidData,
  type McpToolsControllerGetSampleByUuidResponse,
  type McpToolsControllerGetSamplesByEpcData,
  type McpToolsControllerGetSamplesByEpcResponse,
  type McpToolsControllerGetSampleByIdData,
  type McpToolsControllerGetSampleByIdResponse,
  type McpToolsControllerGetPredictionsCountResponse,
  type McpToolsControllerGetAlertsResponse,
  type McpToolsControllerGetSampleTagsResponse,
  type McpToolsControllerGetSessionTagsResponse,
  type McpToolsControllerGetDeviceTagsResponse,
  type McpToolsControllerGetSiteTagsResponse,
  type McpToolsControllerGetSessionsResponse,
  type McpToolsControllerGetAccountsResponse,
  type McpToolsControllerGetAccountContextResponse,
  type McpToolsControllerGetSiteGroupsResponse,
  type McpToolsControllerGetSitesResponse,
  type McpToolsControllerGetSiteGroupContextData,
  type McpToolsControllerGetSiteGroupContextResponse,
  type McpToolsControllerGetSiteContextData,
  type McpToolsControllerGetSiteContextResponse,
  type McpToolsControllerGetDeviceContextData,
  type McpToolsControllerGetDeviceContextResponse,
  type McpPingControllerPingData,
  type McpPingControllerPingResponse,
  type DgTransactionControllerTrimTransactionData,
  type DgTransactionControllerTrimTransactionResponse,
  type VersionControllerVersionResponse,
} from "./types.gen";

export class CurrencyService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static currencyControllerVersion(): CancelablePromise<CurrencyControllerVersionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/currency",
    });
  }
}

export class DashboardAccountsService {
  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns number
   * @throws ApiError
   */
  public static accountsControllerCreate(
    data: AccountsControllerCreateData,
  ): CancelablePromise<AccountsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/accounts",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static accountsControllerListAvailableAgentVersions(): CancelablePromise<AccountsControllerListAvailableAgentVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/accounts/available-agent-versions",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.serviceName
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerListAvailableServiceVersions(
    data: AccountsControllerListAvailableServiceVersionsData,
  ): CancelablePromise<AccountsControllerListAvailableServiceVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/accounts/available-service-versions/{serviceName}",
      path: {
        serviceName: data.serviceName,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.groupId
   * @param data.accountId
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerListMinimal(
    data: AccountsControllerListMinimalData,
  ): CancelablePromise<AccountsControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/accounts/minimal",
      query: {
        groupId: data.groupId,
        accountId: data.accountId,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.accountIds
   * @param data.name
   * @param data.isActive Filter by active status. Defaults to true when omitted.
   * @param data.sortBy Sort by multiple fields and directions. Default direction for name is ascending.
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerListSummaries(
    data: AccountsControllerListSummariesData,
  ): CancelablePromise<AccountsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/accounts/summaries",
      query: {
        accountIds: data.accountIds,
        name: data.name,
        isActive: data.isActive,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns AccountDetailsDto
   * @throws ApiError
   */
  public static accountsControllerFindOne(
    data: AccountsControllerFindOneData,
  ): CancelablePromise<AccountsControllerFindOneResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/accounts/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerUpdateById(
    data: AccountsControllerUpdateByIdData,
  ): CancelablePromise<AccountsControllerUpdateByIdResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/accounts/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerUpdateIsActiveBulk(
    data: AccountsControllerUpdateIsActiveBulkData,
  ): CancelablePromise<AccountsControllerUpdateIsActiveBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/accounts/isActiveBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static accountsControllerUpdate(
    data: AccountsControllerUpdateData,
  ): CancelablePromise<AccountsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/accounts/update",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns OperationalHoursResponseDto
   * @throws ApiError
   */
  public static accountsControllerUpsertDefaultOperationalHours(
    data: AccountsControllerUpsertDefaultOperationalHoursData,
  ): CancelablePromise<AccountsControllerUpsertDefaultOperationalHoursResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/accounts/{id}/default-operational-hours",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardAlertsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerEmitTestAlert(
    data: AlertsControllerEmitTestAlertData,
  ): CancelablePromise<AlertsControllerEmitTestAlertResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/alerts/emit-test-alert",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerUpdateAccountAlert(
    data: AlertsControllerUpdateAccountAlertData,
  ): CancelablePromise<AlertsControllerUpdateAccountAlertResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/alerts/update-account-alert",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns AlertChannelsResponseDto
   * @throws ApiError
   */
  public static alertsControllerListAlertChannels(): CancelablePromise<AlertsControllerListAlertChannelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts/alert-channels",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static alertsControllerCreateAlertChannel(
    data: AlertsControllerCreateAlertChannelData,
  ): CancelablePromise<AlertsControllerCreateAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/alerts/alert-channels",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerListAlertDeliveries(
    data: AlertsControllerListAlertDeliveriesData,
  ): CancelablePromise<AlertsControllerListAlertDeliveriesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts/alert-channels/{id}/deliveries",
      path: {
        id: data.id,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static alertsControllerCreateGlobalAlertChannel(
    data: AlertsControllerCreateGlobalAlertChannelData,
  ): CancelablePromise<AlertsControllerCreateGlobalAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/alerts/alert-channels-global",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerUpdateAlertChannel(
    data: AlertsControllerUpdateAlertChannelData,
  ): CancelablePromise<AlertsControllerUpdateAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/alert-channels/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerDeleteAlertChannel(
    data: AlertsControllerDeleteAlertChannelData,
  ): CancelablePromise<AlertsControllerDeleteAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/alerts/alert-channels/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerUpdateGlobalAlertChannel(
    data: AlertsControllerUpdateGlobalAlertChannelData,
  ): CancelablePromise<AlertsControllerUpdateGlobalAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/alert-channels-global/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerDeleteGlobalAlertChannel(
    data: AlertsControllerDeleteGlobalAlertChannelData,
  ): CancelablePromise<AlertsControllerDeleteGlobalAlertChannelResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/alerts/alert-channels-global/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.priority
   * @param data.severity
   * @param data.sortBy
   * @param data.eventIds
   * @param data.status
   * @param data.deviceIds
   * @param data.alertTypes
   * @param data.name
   * @param data.alertKey
   * @param data.fromDate
   * @param data.toDate
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerListManagedAlerts(
    data: AlertsControllerListManagedAlertsData,
  ): CancelablePromise<AlertsControllerListManagedAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts/managed-alerts",
      query: {
        priority: data.priority,
        severity: data.severity,
        sortBy: data.sortBy,
        eventIds: data.eventIds,
        status: data.status,
        deviceIds: data.deviceIds,
        alertTypes: data.alertTypes,
        name: data.name,
        alertKey: data.alertKey,
        fromDate: data.fromDate,
        toDate: data.toDate,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static alertsControllerDownloadManagedAlerts(
    data: AlertsControllerDownloadManagedAlertsData,
  ): CancelablePromise<AlertsControllerDownloadManagedAlertsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/alerts/managed-alerts/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.priority
   * @param data.severity
   * @param data.sortBy
   * @param data.eventIds
   * @param data.status
   * @param data.deviceIds
   * @param data.alertTypes
   * @param data.name
   * @param data.alertKey
   * @param data.fromDate
   * @param data.toDate
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerListManagedAlertsGroupedByEvent(
    data: AlertsControllerListManagedAlertsGroupedByEventData,
  ): CancelablePromise<AlertsControllerListManagedAlertsGroupedByEventResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts/managed-alerts-grouped",
      query: {
        priority: data.priority,
        severity: data.severity,
        sortBy: data.sortBy,
        eventIds: data.eventIds,
        status: data.status,
        deviceIds: data.deviceIds,
        alertTypes: data.alertTypes,
        name: data.name,
        alertKey: data.alertKey,
        fromDate: data.fromDate,
        toDate: data.toDate,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static alertsControllerUpdateManagedAlertStatus(
    data: AlertsControllerUpdateManagedAlertStatusData,
  ): CancelablePromise<AlertsControllerUpdateManagedAlertStatusResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/managed-alerts/{id}/status",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerUpdateManagedAlertStatusBulk(
    data: AlertsControllerUpdateManagedAlertStatusBulkData,
  ): CancelablePromise<AlertsControllerUpdateManagedAlertStatusBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/managed-alerts/statusBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.priority
   * @param data.severity
   * @param data.name
   * @param data.description
   * @param data.enabled
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerListAlerts(
    data: AlertsControllerListAlertsData,
  ): CancelablePromise<AlertsControllerListAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts",
      query: {
        sortBy: data.sortBy,
        priority: data.priority,
        severity: data.severity,
        name: data.name,
        description: data.description,
        enabled: data.enabled,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns AlertDetailsDto
   * @throws ApiError
   */
  public static alertsControllerGetAlertById(
    data: AlertsControllerGetAlertByIdData,
  ): CancelablePromise<AlertsControllerGetAlertByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/alerts/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: AlertsControllerGetAlertByIdResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static alertsControllerUpdateAlert(
    data: AlertsControllerUpdateAlertData,
  ): CancelablePromise<AlertsControllerUpdateAlertResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static alertsControllerUpdateAlertSubscriptions(
    data: AlertsControllerUpdateAlertSubscriptionsData,
  ): CancelablePromise<AlertsControllerUpdateAlertSubscriptionsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/alerts/{id}/subscriptions",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardAuthService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoginResponseDto
   * @throws ApiError
   */
  public static authControllerLogin(
    data: AuthControllerLoginData,
  ): CancelablePromise<AuthControllerLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/auth/login",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static authControllerLogout(): CancelablePromise<AuthControllerLogoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/auth/logout",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static authControllerMagicCallback(): CancelablePromise<AuthControllerMagicCallbackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/auth/magic-callback",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static authControllerCallback(): CancelablePromise<AuthControllerCallbackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/auth/callback/{key}",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static authControllerOidcCallback(): CancelablePromise<AuthControllerOidcCallbackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/auth/oidc/callback",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static authControllerAccountSwitch(
    data: AuthControllerAccountSwitchData,
  ): CancelablePromise<AuthControllerAccountSwitchResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/auth/switch-account",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardCameraCalibrationService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CameraCalibrationScheduledJobSummaryDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerCreateSchedule(
    data: CameraCalibrationControllerCreateScheduleData,
  ): CancelablePromise<CameraCalibrationControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CameraCalibrationControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static cameraCalibrationControllerListScheduled(
    data: CameraCalibrationControllerListScheduledData,
  ): CancelablePromise<CameraCalibrationControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/camera-calibration/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CameraCalibrationScheduledJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerGetScheduledJob(
    data: CameraCalibrationControllerGetScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        CameraCalibrationControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns CameraCalibrationScheduledJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerUpdateScheduledJob(
    data: CameraCalibrationControllerUpdateScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CameraCalibrationControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static cameraCalibrationControllerDeleteScheduledJob(
    data: CameraCalibrationControllerDeleteScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static cameraCalibrationControllerCancelScheduledJobsBulk(
    data: CameraCalibrationControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static cameraCalibrationControllerStopScheduledJobsBulk(
    data: CameraCalibrationControllerStopScheduledJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static cameraCalibrationControllerResumeScheduledJobsBulk(
    data: CameraCalibrationControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static cameraCalibrationControllerDeleteScheduledJobsBulk(
    data: CameraCalibrationControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CameraCalibrationJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerStartScheduledJob(
    data: CameraCalibrationControllerStartScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        CameraCalibrationControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static cameraCalibrationControllerCancelScheduledJob(
    data: CameraCalibrationControllerCancelScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerStopScheduledJob(
    data: CameraCalibrationControllerStopScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CameraCalibrationScheduledJobSummaryDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerResumeScheduledJob(
    data: CameraCalibrationControllerResumeScheduledJobData,
  ): CancelablePromise<CameraCalibrationControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        CameraCalibrationControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CameraCalibrationJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerStartJob(
    data: CameraCalibrationControllerStartJobData,
  ): CancelablePromise<CameraCalibrationControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CameraCalibrationControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static cameraCalibrationControllerListSummaries(
    data: CameraCalibrationControllerListSummariesData,
  ): CancelablePromise<CameraCalibrationControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/camera-calibration/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CameraCalibrationJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerGetJob(
    data: CameraCalibrationControllerGetJobData,
  ): CancelablePromise<CameraCalibrationControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/camera-calibration/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: CameraCalibrationControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static cameraCalibrationControllerDeleteJob(
    data: CameraCalibrationControllerDeleteJobData,
  ): CancelablePromise<CameraCalibrationControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/camera-calibration/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns CameraCalibrationJobDto
   * @throws ApiError
   */
  public static cameraCalibrationControllerUpdateJob(
    data: CameraCalibrationControllerUpdateJobData,
  ): CancelablePromise<CameraCalibrationControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/camera-calibration/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CameraCalibrationControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static cameraCalibrationControllerCancelJob(
    data: CameraCalibrationControllerCancelJobData,
  ): CancelablePromise<CameraCalibrationControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static cameraCalibrationControllerStopJob(
    data: CameraCalibrationControllerStopJobData,
  ): CancelablePromise<CameraCalibrationControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static cameraCalibrationControllerCancelJobsBulk(
    data: CameraCalibrationControllerCancelJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static cameraCalibrationControllerDeleteJobsBulk(
    data: CameraCalibrationControllerDeleteJobsBulkData,
  ): CancelablePromise<CameraCalibrationControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/camera-calibration/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardCapacityTaggingService {
  /**
   * Manual-run pre-check (PRD): resolves the window live and reports how many sessions the run
   * would process plus per-store data-completeness, so the wizard can show
   * "will run N sessions, continue?" before the job is created.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CapacityTaggingPreCheckResponseDto
   * @throws ApiError
   */
  public static capacityTaggingControllerPreCheck(
    data: CapacityTaggingControllerPreCheckData,
  ): CancelablePromise<CapacityTaggingControllerPreCheckResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/pre-check",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: CapacityTaggingControllerPreCheckResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CapacityTaggingScheduledJobSummaryDto
   * @throws ApiError
   */
  public static capacityTaggingControllerCreateSchedule(
    data: CapacityTaggingControllerCreateScheduleData,
  ): CancelablePromise<CapacityTaggingControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CapacityTaggingControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static capacityTaggingControllerListScheduled(
    data: CapacityTaggingControllerListScheduledData,
  ): CancelablePromise<CapacityTaggingControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/capacity-tagging/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CapacityTaggingScheduledJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerGetScheduledJob(
    data: CapacityTaggingControllerGetScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        CapacityTaggingControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns CapacityTaggingScheduledJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerUpdateScheduledJob(
    data: CapacityTaggingControllerUpdateScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CapacityTaggingControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static capacityTaggingControllerDeleteScheduledJob(
    data: CapacityTaggingControllerDeleteScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static capacityTaggingControllerCancelScheduledJobsBulk(
    data: CapacityTaggingControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static capacityTaggingControllerStopScheduledJobsBulk(
    data: CapacityTaggingControllerStopScheduledJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static capacityTaggingControllerResumeScheduledJobsBulk(
    data: CapacityTaggingControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static capacityTaggingControllerDeleteScheduledJobsBulk(
    data: CapacityTaggingControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CapacityTaggingJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerStartScheduledJob(
    data: CapacityTaggingControllerStartScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        CapacityTaggingControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static capacityTaggingControllerCancelScheduledJob(
    data: CapacityTaggingControllerCancelScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static capacityTaggingControllerStopScheduledJob(
    data: CapacityTaggingControllerStopScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CapacityTaggingScheduledJobSummaryDto
   * @throws ApiError
   */
  public static capacityTaggingControllerResumeScheduledJob(
    data: CapacityTaggingControllerResumeScheduledJobData,
  ): CancelablePromise<CapacityTaggingControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        CapacityTaggingControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CapacityTaggingJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerStartJob(
    data: CapacityTaggingControllerStartJobData,
  ): CancelablePromise<CapacityTaggingControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: CapacityTaggingControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static capacityTaggingControllerListSummaries(
    data: CapacityTaggingControllerListSummariesData,
  ): CancelablePromise<CapacityTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/capacity-tagging/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CapacityTaggingJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerGetJob(
    data: CapacityTaggingControllerGetJobData,
  ): CancelablePromise<CapacityTaggingControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/capacity-tagging/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: CapacityTaggingControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static capacityTaggingControllerDeleteJob(
    data: CapacityTaggingControllerDeleteJobData,
  ): CancelablePromise<CapacityTaggingControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/capacity-tagging/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns CapacityTaggingJobDto
   * @throws ApiError
   */
  public static capacityTaggingControllerUpdateJob(
    data: CapacityTaggingControllerUpdateJobData,
  ): CancelablePromise<CapacityTaggingControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/capacity-tagging/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CapacityTaggingControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static capacityTaggingControllerCancelJob(
    data: CapacityTaggingControllerCancelJobData,
  ): CancelablePromise<CapacityTaggingControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static capacityTaggingControllerStopJob(
    data: CapacityTaggingControllerStopJobData,
  ): CancelablePromise<CapacityTaggingControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static capacityTaggingControllerCancelJobsBulk(
    data: CapacityTaggingControllerCancelJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static capacityTaggingControllerDeleteJobsBulk(
    data: CapacityTaggingControllerDeleteJobsBulkData,
  ): CancelablePromise<CapacityTaggingControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/capacity-tagging/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardCatalogService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.siteId
   * @param data.plu
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerListLabels(
    data: CatalogControllerListLabelsData,
  ): CancelablePromise<CatalogControllerListLabelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/labels",
      query: {
        siteId: data.siteId,
        plu: data.plu,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.search
   * @param data.page
   * @param data.limit
   * @param data.notInGroup Site group ID to exclude items that already have labels in this group
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerListMinimal(
    data: CatalogControllerListMinimalData = {},
  ): CancelablePromise<CatalogControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/minimal",
      query: {
        search: data.search,
        page: data.page,
        limit: data.limit,
        notInGroup: data.notInGroup,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.siteId
   * @param data.familyName Case-insensitive partial match on family name
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerListFamilies(
    data: CatalogControllerListFamiliesData,
  ): CancelablePromise<CatalogControllerListFamiliesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/families",
      query: {
        familyName: data.familyName,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
        siteId: data.siteId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.plus
   * @param data.itemIds
   * @param data.priceBy
   * @param data.price
   * @param data.families
   * @param data.sortBy
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.siteId
   * @param data.groupId
   * @param data.search
   * @param data.exact
   * @param data.plu
   * @param data.name
   * @param data.englishName
   * @param data.outOfScope
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerListSummaries(
    data: CatalogControllerListSummariesData,
  ): CancelablePromise<CatalogControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/summaries",
      query: {
        plus: data.plus,
        itemIds: data.itemIds,
        priceBy: data.priceBy,
        price: data.price,
        families: data.families,
        sortBy: data.sortBy,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        siteId: data.siteId,
        groupId: data.groupId,
        search: data.search,
        exact: data.exact,
        plu: data.plu,
        name: data.name,
        englishName: data.englishName,
        outOfScope: data.outOfScope,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static catalogControllerDownloadCatalog(
    data: CatalogControllerDownloadCatalogData,
  ): CancelablePromise<CatalogControllerDownloadCatalogResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.siteId
   * @returns LookupTableDto
   * @throws ApiError
   */
  public static catalogControllerFind(
    data: CatalogControllerFindData,
  ): CancelablePromise<CatalogControllerFindResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/find",
      query: {
        siteId: data.siteId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerUpdateTagsBulk(
    data: CatalogControllerUpdateTagsBulkData,
  ): CancelablePromise<CatalogControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerUpdateOutOfScopeBulk(
    data: CatalogControllerUpdateOutOfScopeBulkData,
  ): CancelablePromise<CatalogControllerUpdateOutOfScopeBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/outOfScopeBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerDeleteBulk(
    data: CatalogControllerDeleteBulkData,
  ): CancelablePromise<CatalogControllerDeleteBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/deleteBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @param data.siteId
   * @param data.groupId
   * @returns CatalogItemDetailsDto
   * @throws ApiError
   */
  public static catalogControllerGetDetails(
    data: CatalogControllerGetDetailsData,
  ): CancelablePromise<CatalogControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/{label}",
      path: {
        label: data.label,
      },
      query: {
        siteId: data.siteId,
        groupId: data.groupId,
      },
      responseTransformer: CatalogControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @param data.requestBody
   * @returns CreatedCatalogItemDto
   * @throws ApiError
   */
  public static catalogControllerCreate(
    data: CatalogControllerCreateData,
  ): CancelablePromise<CatalogControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/catalog/{label}",
      path: {
        label: data.label,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: CatalogControllerCreateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @param data.requestBody
   * @param data.siteId
   * @param data.groupId
   * @returns UpdatedCatalogItemDto
   * @throws ApiError
   */
  public static catalogControllerUpdate(
    data: CatalogControllerUpdateData,
  ): CancelablePromise<CatalogControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/{label}",
      path: {
        label: data.label,
      },
      query: {
        siteId: data.siteId,
        groupId: data.groupId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: CatalogControllerUpdateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @param data.siteId
   * @param data.groupId
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerDelete(
    data: CatalogControllerDeleteData,
  ): CancelablePromise<CatalogControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/catalog/{label}",
      path: {
        label: data.label,
      },
      query: {
        siteId: data.siteId,
        groupId: data.groupId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @returns CatalogItemSitePricesDto
   * @throws ApiError
   */
  public static catalogControllerGetSitePrices(
    data: CatalogControllerGetSitePricesData,
  ): CancelablePromise<CatalogControllerGetSitePricesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/{label}/site-prices",
      path: {
        label: data.label,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.label
   * @returns CatalogItemLabelsDto
   * @throws ApiError
   */
  public static catalogControllerGetLabels(
    data: CatalogControllerGetLabelsData,
  ): CancelablePromise<CatalogControllerGetLabelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/{label}/labels",
      path: {
        label: data.label,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static catalogControllerUpload(
    data: CatalogControllerUploadData,
  ): CancelablePromise<CatalogControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}

export class DashboardCatalogTaggingService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static catalogTaggingControllerListTags(
    data: CatalogTaggingControllerListTagsData,
  ): CancelablePromise<CatalogTaggingControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/catalog-tagging/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static catalogTaggingControllerCreateTags(
    data: CatalogTaggingControllerCreateTagsData,
  ): CancelablePromise<CatalogTaggingControllerCreateTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog/catalog-tagging/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignTagsResponseDto
   * @throws ApiError
   */
  public static catalogTaggingControllerAssignTags(
    data: CatalogTaggingControllerAssignTagsData,
  ): CancelablePromise<CatalogTaggingControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog/catalog-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignTagsResponseDto
   * @throws ApiError
   */
  public static catalogTaggingControllerUnassignTags(
    data: CatalogTaggingControllerUnassignTagsData,
  ): CancelablePromise<CatalogTaggingControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/catalog/catalog-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static catalogTaggingControllerGetDetails(
    data: CatalogTaggingControllerGetDetailsData,
  ): CancelablePromise<CatalogTaggingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/catalog-tagging/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        CatalogTaggingControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static catalogTaggingControllerUpdateTag(
    data: CatalogTaggingControllerUpdateTagData,
  ): CancelablePromise<CatalogTaggingControllerUpdateTagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/catalog-tagging/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: CatalogTaggingControllerUpdateTagResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static catalogTaggingControllerDeleteTag(
    data: CatalogTaggingControllerDeleteTagData,
  ): CancelablePromise<CatalogTaggingControllerDeleteTagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/catalog/catalog-tagging/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static catalogTaggingControllerMergeTagTo(
    data: CatalogTaggingControllerMergeTagToData,
  ): CancelablePromise<CatalogTaggingControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog/catalog-tagging/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static catalogTaggingControllerListSummaries(
    data: CatalogTaggingControllerListSummariesData,
  ): CancelablePromise<CatalogTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog/catalog-tagging/summaries",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class DashboardCatalogUploadJobsService {
  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static catalogUploadJobControllerGetScheduledJob(
    data: CatalogUploadJobControllerGetScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns CatalogUploadScheduledJobDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerUpdateScheduledJob(
    data: CatalogUploadJobControllerUpdateScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CatalogUploadJobControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static catalogUploadJobControllerDeleteScheduledJob(
    data: CatalogUploadJobControllerDeleteScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static catalogUploadJobControllerGetJob(
    data: CatalogUploadJobControllerGetJobData,
  ): CancelablePromise<CatalogUploadJobControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static catalogUploadJobControllerDeleteJob(
    data: CatalogUploadJobControllerDeleteJobData,
  ): CancelablePromise<CatalogUploadJobControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns CatalogUploadJobDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerUpdateJob(
    data: CatalogUploadJobControllerUpdateJobData,
  ): CancelablePromise<CatalogUploadJobControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CatalogUploadJobControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.name Filter by device name (case-insensitive substring)
   * @param data.state
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static catalogUploadJobControllerGetJobDevices(
    data: CatalogUploadJobControllerGetJobDevicesData,
  ): CancelablePromise<CatalogUploadJobControllerGetJobDevicesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}/devices",
      path: {
        id: data.id,
      },
      query: {
        name: data.name,
        state: data.state,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CatalogUploadScheduledJobSummaryDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerCreateSchedule(
    data: CatalogUploadJobControllerCreateScheduleData,
  ): CancelablePromise<CatalogUploadJobControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CatalogUploadJobControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.siteGroupIds
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static catalogUploadJobControllerListScheduled(
    data: CatalogUploadJobControllerListScheduledData,
  ): CancelablePromise<CatalogUploadJobControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule",
      query: {
        sortBy: data.sortBy,
        siteGroupIds: data.siteGroupIds,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static catalogUploadJobControllerCancelScheduledJobsBulk(
    data: CatalogUploadJobControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static catalogUploadJobControllerStopScheduledJobsBulk(
    data: CatalogUploadJobControllerStopScheduledJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static catalogUploadJobControllerResumeScheduledJobsBulk(
    data: CatalogUploadJobControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static catalogUploadJobControllerDeleteScheduledJobsBulk(
    data: CatalogUploadJobControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CatalogUploadJobDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerStartScheduledJob(
    data: CatalogUploadJobControllerStartScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        CatalogUploadJobControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static catalogUploadJobControllerCancelScheduledJob(
    data: CatalogUploadJobControllerCancelScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerStopScheduledJob(
    data: CatalogUploadJobControllerStopScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns CatalogUploadScheduledJobSummaryDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerResumeScheduledJob(
    data: CatalogUploadJobControllerResumeScheduledJobData,
  ): CancelablePromise<CatalogUploadJobControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        CatalogUploadJobControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CatalogUploadJobDto
   * @throws ApiError
   */
  public static catalogUploadJobControllerStartJob(
    data: CatalogUploadJobControllerStartJobData,
  ): CancelablePromise<CatalogUploadJobControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        CatalogUploadJobControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static catalogUploadJobControllerListSummaries(
    data: CatalogUploadJobControllerListSummariesData,
  ): CancelablePromise<CatalogUploadJobControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static catalogUploadJobControllerCancelJob(
    data: CatalogUploadJobControllerCancelJobData,
  ): CancelablePromise<CatalogUploadJobControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static catalogUploadJobControllerStopJob(
    data: CatalogUploadJobControllerStopJobData,
  ): CancelablePromise<CatalogUploadJobControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static catalogUploadJobControllerCancelJobsBulk(
    data: CatalogUploadJobControllerCancelJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static catalogUploadJobControllerDeleteJobsBulk(
    data: CatalogUploadJobControllerDeleteJobsBulkData,
  ): CancelablePromise<CatalogUploadJobControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/catalog-upload-jobs/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardClustersService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static clustersControllerDownload(
    data: ClustersControllerDownloadData,
  ): CancelablePromise<ClustersControllerDownloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/clusters/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static clustersControllerCreate(
    data: ClustersControllerCreateData,
  ): CancelablePromise<ClustersControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/clusters",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.clusterIds
   * @param data.sortBy
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerListSummaries(
    data: ClustersControllerListSummariesData,
  ): CancelablePromise<ClustersControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/summaries",
      query: {
        clusterIds: data.clusterIds,
        sortBy: data.sortBy,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.groupId
   * @param data.accountId
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerListMinimal(
    data: ClustersControllerListMinimalData,
  ): CancelablePromise<ClustersControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/minimal",
      query: {
        groupId: data.groupId,
        accountId: data.accountId,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerDeployModelBulk(
    data: ClustersControllerDeployModelBulkData,
  ): CancelablePromise<ClustersControllerDeployModelBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/modelBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerDeployConfigBulk(
    data: ClustersControllerDeployConfigBulkData,
  ): CancelablePromise<ClustersControllerDeployConfigBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/deployConfigBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerUpdateTagsBulk(
    data: ClustersControllerUpdateTagsBulkData,
  ): CancelablePromise<ClustersControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns ClusterUploadResponseDto
   * @throws ApiError
   */
  public static clustersControllerUpload(
    data: ClustersControllerUploadData,
  ): CancelablePromise<ClustersControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/clusters/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.withLabelDistribution Whether to include labels distribution in the response
   * @returns ClusterDetailsDto
   * @throws ApiError
   */
  public static clustersControllerGetDetails(
    data: ClustersControllerGetDetailsData,
  ): CancelablePromise<ClustersControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/{id}",
      path: {
        id: data.id,
      },
      query: {
        withLabelDistribution: data.withLabelDistribution,
      },
      responseTransformer: ClustersControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerUpdate(
    data: ClustersControllerUpdateData,
  ): CancelablePromise<ClustersControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static clustersControllerDelete(
    data: ClustersControllerDeleteData,
  ): CancelablePromise<ClustersControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/clusters/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static clustersControllerAddDevices(
    data: ClustersControllerAddDevicesData,
  ): CancelablePromise<ClustersControllerAddDevicesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/{id}/devices/add",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static clustersControllerRemoveDevices(
    data: ClustersControllerRemoveDevicesData,
  ): CancelablePromise<ClustersControllerRemoveDevicesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/{id}/devices/remove",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardClustersTaggingService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static clustersTaggingControllerListTags(
    data: ClustersTaggingControllerListTagsData,
  ): CancelablePromise<ClustersTaggingControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/clusters-tagging/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static clustersTaggingControllerCreateTags(
    data: ClustersTaggingControllerCreateTagsData,
  ): CancelablePromise<ClustersTaggingControllerCreateTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/clusters/clusters-tagging/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignTagsResponseDto
   * @throws ApiError
   */
  public static clustersTaggingControllerAssignTags(
    data: ClustersTaggingControllerAssignTagsData,
  ): CancelablePromise<ClustersTaggingControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/clusters/clusters-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignTagsResponseDto
   * @throws ApiError
   */
  public static clustersTaggingControllerUnassignTags(
    data: ClustersTaggingControllerUnassignTagsData,
  ): CancelablePromise<ClustersTaggingControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/clusters/clusters-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static clustersTaggingControllerGetDetails(
    data: ClustersTaggingControllerGetDetailsData,
  ): CancelablePromise<ClustersTaggingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/clusters-tagging/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ClustersTaggingControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static clustersTaggingControllerUpdateTag(
    data: ClustersTaggingControllerUpdateTagData,
  ): CancelablePromise<ClustersTaggingControllerUpdateTagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/clusters-tagging/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ClustersTaggingControllerUpdateTagResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static clustersTaggingControllerDeleteTag(
    data: ClustersTaggingControllerDeleteTagData,
  ): CancelablePromise<ClustersTaggingControllerDeleteTagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/clusters/clusters-tagging/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static clustersTaggingControllerMergeTagTo(
    data: ClustersTaggingControllerMergeTagToData,
  ): CancelablePromise<ClustersTaggingControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/clusters/clusters-tagging/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static clustersTaggingControllerListSummaries(
    data: ClustersTaggingControllerListSummariesData,
  ): CancelablePromise<ClustersTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/clusters/clusters-tagging/summaries",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class DashboardDashboardAlertsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static dashboardAlertsControllerCreateAlert(
    data: DashboardAlertsControllerCreateAlertData,
  ): CancelablePromise<DashboardAlertsControllerCreateAlertResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/dashboard-alerts",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDatasetsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static datasetsControllerCreate(
    data: DatasetsControllerCreateData,
  ): CancelablePromise<DatasetsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/datasets",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.id
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static datasetsControllerListSummaries(
    data: DatasetsControllerListSummariesData,
  ): CancelablePromise<DatasetsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/datasets/summaries",
      query: {
        limit: data.limit,
        page: data.page,
        id: data.id,
        name: data.name,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DatasetDetailsDto
   * @throws ApiError
   */
  public static datasetsControllerGetDetails(
    data: DatasetsControllerGetDetailsData,
  ): CancelablePromise<DatasetsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/datasets/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: DatasetsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static datasetsControllerUpdate(
    data: DatasetsControllerUpdateData,
  ): CancelablePromise<DatasetsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/datasets/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDeleteSamplesService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeleteSamplesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerCreateSchedule(
    data: DeleteSamplesJobControllerCreateScheduleData,
  ): CancelablePromise<DeleteSamplesJobControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteSamplesJobControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deleteSamplesJobControllerListScheduled(
    data: DeleteSamplesJobControllerListScheduledData,
  ): CancelablePromise<DeleteSamplesJobControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-samples/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteSamplesScheduledJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerGetScheduledJob(
    data: DeleteSamplesJobControllerGetScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteSamplesJobControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns DeleteSamplesScheduledJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerUpdateScheduledJob(
    data: DeleteSamplesJobControllerUpdateScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteSamplesJobControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteSamplesJobControllerDeleteScheduledJob(
    data: DeleteSamplesJobControllerDeleteScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static deleteSamplesJobControllerCancelScheduledJobsBulk(
    data: DeleteSamplesJobControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static deleteSamplesJobControllerStopScheduledJobsBulk(
    data: DeleteSamplesJobControllerStopScheduledJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static deleteSamplesJobControllerResumeScheduledJobsBulk(
    data: DeleteSamplesJobControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static deleteSamplesJobControllerDeleteScheduledJobsBulk(
    data: DeleteSamplesJobControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteSamplesJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerStartScheduledJob(
    data: DeleteSamplesJobControllerStartScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteSamplesJobControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteSamplesJobControllerCancelScheduledJob(
    data: DeleteSamplesJobControllerCancelScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerStopScheduledJob(
    data: DeleteSamplesJobControllerStopScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteSamplesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerResumeScheduledJob(
    data: DeleteSamplesJobControllerResumeScheduledJobData,
  ): CancelablePromise<DeleteSamplesJobControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteSamplesJobControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeleteSamplesJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerStartJob(
    data: DeleteSamplesJobControllerStartJobData,
  ): CancelablePromise<DeleteSamplesJobControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteSamplesJobControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deleteSamplesJobControllerListSummaries(
    data: DeleteSamplesJobControllerListSummariesData,
  ): CancelablePromise<DeleteSamplesJobControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-samples/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteSamplesJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerGetJob(
    data: DeleteSamplesJobControllerGetJobData,
  ): CancelablePromise<DeleteSamplesJobControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-samples/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: DeleteSamplesJobControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteSamplesJobControllerDeleteJob(
    data: DeleteSamplesJobControllerDeleteJobData,
  ): CancelablePromise<DeleteSamplesJobControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/delete-samples/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeleteSamplesJobDto
   * @throws ApiError
   */
  public static deleteSamplesJobControllerUpdateJob(
    data: DeleteSamplesJobControllerUpdateJobData,
  ): CancelablePromise<DeleteSamplesJobControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/delete-samples/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteSamplesJobControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteSamplesJobControllerCancelJob(
    data: DeleteSamplesJobControllerCancelJobData,
  ): CancelablePromise<DeleteSamplesJobControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteSamplesJobControllerStopJob(
    data: DeleteSamplesJobControllerStopJobData,
  ): CancelablePromise<DeleteSamplesJobControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static deleteSamplesJobControllerCancelJobsBulk(
    data: DeleteSamplesJobControllerCancelJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static deleteSamplesJobControllerDeleteJobsBulk(
    data: DeleteSamplesJobControllerDeleteJobsBulkData,
  ): CancelablePromise<DeleteSamplesJobControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-samples/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDeleteVideosService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeleteVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerCreateSchedule(
    data: DeleteVideosJobControllerCreateScheduleData,
  ): CancelablePromise<DeleteVideosJobControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteVideosJobControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deleteVideosJobControllerListScheduled(
    data: DeleteVideosJobControllerListScheduledData,
  ): CancelablePromise<DeleteVideosJobControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-videos/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteVideosScheduledJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerGetScheduledJob(
    data: DeleteVideosJobControllerGetScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteVideosJobControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns DeleteVideosScheduledJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerUpdateScheduledJob(
    data: DeleteVideosJobControllerUpdateScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteVideosJobControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteVideosJobControllerDeleteScheduledJob(
    data: DeleteVideosJobControllerDeleteScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static deleteVideosJobControllerCancelScheduledJobsBulk(
    data: DeleteVideosJobControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static deleteVideosJobControllerStopScheduledJobsBulk(
    data: DeleteVideosJobControllerStopScheduledJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static deleteVideosJobControllerResumeScheduledJobsBulk(
    data: DeleteVideosJobControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static deleteVideosJobControllerDeleteScheduledJobsBulk(
    data: DeleteVideosJobControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteVideosJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerStartScheduledJob(
    data: DeleteVideosJobControllerStartScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteVideosJobControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteVideosJobControllerCancelScheduledJob(
    data: DeleteVideosJobControllerCancelScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerStopScheduledJob(
    data: DeleteVideosJobControllerStopScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerResumeScheduledJob(
    data: DeleteVideosJobControllerResumeScheduledJobData,
  ): CancelablePromise<DeleteVideosJobControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeleteVideosJobControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeleteVideosJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerStartJob(
    data: DeleteVideosJobControllerStartJobData,
  ): CancelablePromise<DeleteVideosJobControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DeleteVideosJobControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deleteVideosJobControllerListSummaries(
    data: DeleteVideosJobControllerListSummariesData,
  ): CancelablePromise<DeleteVideosJobControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-videos/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeleteVideosJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerGetJob(
    data: DeleteVideosJobControllerGetJobData,
  ): CancelablePromise<DeleteVideosJobControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/delete-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: DeleteVideosJobControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteVideosJobControllerDeleteJob(
    data: DeleteVideosJobControllerDeleteJobData,
  ): CancelablePromise<DeleteVideosJobControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/delete-videos/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeleteVideosJobDto
   * @throws ApiError
   */
  public static deleteVideosJobControllerUpdateJob(
    data: DeleteVideosJobControllerUpdateJobData,
  ): CancelablePromise<DeleteVideosJobControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/delete-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeleteVideosJobControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteVideosJobControllerCancelJob(
    data: DeleteVideosJobControllerCancelJobData,
  ): CancelablePromise<DeleteVideosJobControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deleteVideosJobControllerStopJob(
    data: DeleteVideosJobControllerStopJobData,
  ): CancelablePromise<DeleteVideosJobControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static deleteVideosJobControllerCancelJobsBulk(
    data: DeleteVideosJobControllerCancelJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static deleteVideosJobControllerDeleteJobsBulk(
    data: DeleteVideosJobControllerDeleteJobsBulkData,
  ): CancelablePromise<DeleteVideosJobControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/delete-videos/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDeployComponentsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeployComponentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deployComponentsControllerCreateSchedule(
    data: DeployComponentsControllerCreateScheduleData,
  ): CancelablePromise<DeployComponentsControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeployComponentsControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deployComponentsControllerListScheduled(
    data: DeployComponentsControllerListScheduledData,
  ): CancelablePromise<DeployComponentsControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/deploy-components/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeployComponentsScheduledJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerGetScheduledJob(
    data: DeployComponentsControllerGetScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeployComponentsControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns DeployComponentsScheduledJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerUpdateScheduledJob(
    data: DeployComponentsControllerUpdateScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeployComponentsControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deployComponentsControllerDeleteScheduledJob(
    data: DeployComponentsControllerDeleteScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static deployComponentsControllerCancelScheduledJobsBulk(
    data: DeployComponentsControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static deployComponentsControllerStopScheduledJobsBulk(
    data: DeployComponentsControllerStopScheduledJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static deployComponentsControllerResumeScheduledJobsBulk(
    data: DeployComponentsControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static deployComponentsControllerDeleteScheduledJobsBulk(
    data: DeployComponentsControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeployComponentsJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerStartScheduledJob(
    data: DeployComponentsControllerStartScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeployComponentsControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deployComponentsControllerCancelScheduledJob(
    data: DeployComponentsControllerCancelScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static deployComponentsControllerStopScheduledJob(
    data: DeployComponentsControllerStopScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeployComponentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deployComponentsControllerResumeScheduledJob(
    data: DeployComponentsControllerResumeScheduledJobData,
  ): CancelablePromise<DeployComponentsControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeployComponentsControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeployComponentsJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerStartJob(
    data: DeployComponentsControllerStartJobData,
  ): CancelablePromise<DeployComponentsControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeployComponentsControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deployComponentsControllerListSummaries(
    data: DeployComponentsControllerListSummariesData,
  ): CancelablePromise<DeployComponentsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/deploy-components/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeployComponentsJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerGetJob(
    data: DeployComponentsControllerGetJobData,
  ): CancelablePromise<DeployComponentsControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/deploy-components/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: DeployComponentsControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deployComponentsControllerDeleteJob(
    data: DeployComponentsControllerDeleteJobData,
  ): CancelablePromise<DeployComponentsControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/deploy-components/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeployComponentsJobDto
   * @throws ApiError
   */
  public static deployComponentsControllerUpdateJob(
    data: DeployComponentsControllerUpdateJobData,
  ): CancelablePromise<DeployComponentsControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/deploy-components/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeployComponentsControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deployComponentsControllerCancelJob(
    data: DeployComponentsControllerCancelJobData,
  ): CancelablePromise<DeployComponentsControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deployComponentsControllerStopJob(
    data: DeployComponentsControllerStopJobData,
  ): CancelablePromise<DeployComponentsControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static deployComponentsControllerCancelJobsBulk(
    data: DeployComponentsControllerCancelJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static deployComponentsControllerDeleteJobsBulk(
    data: DeployComponentsControllerDeleteJobsBulkData,
  ): CancelablePromise<DeployComponentsControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/deploy-components/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDeviceRestartService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeviceRestartScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deviceRestartControllerCreateSchedule(
    data: DeviceRestartControllerCreateScheduleData,
  ): CancelablePromise<DeviceRestartControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeviceRestartControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deviceRestartControllerListScheduled(
    data: DeviceRestartControllerListScheduledData,
  ): CancelablePromise<DeviceRestartControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/device-restart/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceRestartScheduledJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerGetScheduledJob(
    data: DeviceRestartControllerGetScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/device-restart/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeviceRestartControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns DeviceRestartScheduledJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerUpdateScheduledJob(
    data: DeviceRestartControllerUpdateScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/device-restart/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DeviceRestartControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deviceRestartControllerDeleteScheduledJob(
    data: DeviceRestartControllerDeleteScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/device-restart/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static deviceRestartControllerCancelScheduledJobsBulk(
    data: DeviceRestartControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static deviceRestartControllerStopScheduledJobsBulk(
    data: DeviceRestartControllerStopScheduledJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static deviceRestartControllerResumeScheduledJobsBulk(
    data: DeviceRestartControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static deviceRestartControllerDeleteScheduledJobsBulk(
    data: DeviceRestartControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceRestartJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerStartScheduledJob(
    data: DeviceRestartControllerStartScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeviceRestartControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deviceRestartControllerCancelScheduledJob(
    data: DeviceRestartControllerCancelScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static deviceRestartControllerStopScheduledJob(
    data: DeviceRestartControllerStopScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceRestartScheduledJobSummaryDto
   * @throws ApiError
   */
  public static deviceRestartControllerResumeScheduledJob(
    data: DeviceRestartControllerResumeScheduledJobData,
  ): CancelablePromise<DeviceRestartControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        DeviceRestartControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeviceRestartJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerStartJob(
    data: DeviceRestartControllerStartJobData,
  ): CancelablePromise<DeviceRestartControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DeviceRestartControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static deviceRestartControllerListSummaries(
    data: DeviceRestartControllerListSummariesData,
  ): CancelablePromise<DeviceRestartControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/device-restart/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceRestartJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerGetJob(
    data: DeviceRestartControllerGetJobData,
  ): CancelablePromise<DeviceRestartControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/device-restart/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: DeviceRestartControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deviceRestartControllerDeleteJob(
    data: DeviceRestartControllerDeleteJobData,
  ): CancelablePromise<DeviceRestartControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/device-restart/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeviceRestartJobDto
   * @throws ApiError
   */
  public static deviceRestartControllerUpdateJob(
    data: DeviceRestartControllerUpdateJobData,
  ): CancelablePromise<DeviceRestartControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/device-restart/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DeviceRestartControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deviceRestartControllerCancelJob(
    data: DeviceRestartControllerCancelJobData,
  ): CancelablePromise<DeviceRestartControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static deviceRestartControllerStopJob(
    data: DeviceRestartControllerStopJobData,
  ): CancelablePromise<DeviceRestartControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static deviceRestartControllerCancelJobsBulk(
    data: DeviceRestartControllerCancelJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static deviceRestartControllerDeleteJobsBulk(
    data: DeviceRestartControllerDeleteJobsBulkData,
  ): CancelablePromise<DeviceRestartControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/device-restart/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardDevicesService {
  /**
   * @returns DevicesStateCountsDto
   * @throws ApiError
   */
  public static devicesControllerStateCounts(): CancelablePromise<DevicesControllerStateCountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/state-counts",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.state
   * @param data.excludeClusterIds
   * @param data.excludeSiteIds
   * @param data.sortBy Sorting by one or more fields, each with an optional direction.
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.videoState Filter by one or more video states
   * @param data.id
   * @param data.name
   * @param data.agentVersion
   * @param data.os
   * @param data.cpu
   * @param data.modelName
   * @param data.localIp
   * @param data.lastPing
   * @param data.clusterId
   * @param data.siteId
   * @param data.configLocked
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListSummaries(
    data: DevicesControllerListSummariesData,
  ): CancelablePromise<DevicesControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/summaries",
      query: {
        deviceIds: data.deviceIds,
        state: data.state,
        excludeClusterIds: data.excludeClusterIds,
        excludeSiteIds: data.excludeSiteIds,
        sortBy: data.sortBy,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        videoState: data.videoState,
        id: data.id,
        name: data.name,
        agentVersion: data.agentVersion,
        os: data.os,
        cpu: data.cpu,
        modelName: data.modelName,
        localIp: data.localIp,
        lastPing: data.lastPing,
        clusterId: data.clusterId,
        siteId: data.siteId,
        configLocked: data.configLocked,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static devicesControllerDownload(
    data: DevicesControllerDownloadData,
  ): CancelablePromise<DevicesControllerDownloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.name
   * @param data.clusterId
   * @param data.siteId
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListMinimal(
    data: DevicesControllerListMinimalData,
  ): CancelablePromise<DevicesControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/minimal",
      query: {
        state: data.state,
        name: data.name,
        clusterId: data.clusterId,
        siteId: data.siteId,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static devicesControllerCreate(
    data: DevicesControllerCreateData,
  ): CancelablePromise<DevicesControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUpdateActivationTime(
    data: DevicesControllerUpdateActivationTimeData,
  ): CancelablePromise<DevicesControllerUpdateActivationTimeResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/activation-time",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUpdateTags(
    data: DevicesControllerUpdateTagsData,
  ): CancelablePromise<DevicesControllerUpdateTagsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUpdateTagsBulk(
    data: DevicesControllerUpdateTagsBulkData,
  ): CancelablePromise<DevicesControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeployModelBulk(
    data: DevicesControllerDeployModelBulkData,
  ): CancelablePromise<DevicesControllerDeployModelBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/modelBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUpdateConfigLockBulk(
    data: DevicesControllerUpdateConfigLockBulkData,
  ): CancelablePromise<DevicesControllerUpdateConfigLockBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/configLockBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeployServiceVersionBulk(
    data: DevicesControllerDeployServiceVersionBulkData,
  ): CancelablePromise<DevicesControllerDeployServiceVersionBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/deployServiceVersionBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeployConfigBulk(
    data: DevicesControllerDeployConfigBulkData,
  ): CancelablePromise<DevicesControllerDeployConfigBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/deployConfigBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerRestartBulk(
    data: DevicesControllerRestartBulkData,
  ): CancelablePromise<DevicesControllerRestartBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/restartBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns boolean
   * @throws ApiError
   */
  public static devicesControllerCancelConfig(
    data: DevicesControllerCancelConfigData,
  ): CancelablePromise<DevicesControllerCancelConfigResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/cancelConfig",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.componentName The component name
   * @param data.limit
   * @param data.page
   * @param data.version
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListAvailableComponentVersions(
    data: DevicesControllerListAvailableComponentVersionsData,
  ): CancelablePromise<DevicesControllerListAvailableComponentVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/available-component-versions/{componentName}",
      path: {
        componentName: data.componentName,
      },
      query: {
        version: data.version,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns DeviceUploadResponseDto
   * @throws ApiError
   */
  public static devicesControllerUpload(
    data: DevicesControllerUploadData,
  ): CancelablePromise<DevicesControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
      responseTransformer: DevicesControllerUploadResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.withLabelDistribution Whether to include labels distribution in the response
   * @returns DeviceDetailsDto
   * @throws ApiError
   */
  public static devicesControllerGetDetails(
    data: DevicesControllerGetDetailsData,
  ): CancelablePromise<DevicesControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}",
      path: {
        id: data.id,
      },
      query: {
        withLabelDistribution: data.withLabelDistribution,
      },
      responseTransformer: DevicesControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUpdate(
    data: DevicesControllerUpdateData,
  ): CancelablePromise<DevicesControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.logLevel
   * @param data.timeField
   * @param data.sortBy
   * @param data.fromDate
   * @param data.toDate
   * @param data.text
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListDeviceEvents(
    data: DevicesControllerListDeviceEventsData,
  ): CancelablePromise<DevicesControllerListDeviceEventsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/list-events",
      path: {
        id: data.id,
      },
      query: {
        logLevel: data.logLevel,
        timeField: data.timeField,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
        fromDate: data.fromDate,
        toDate: data.toDate,
        text: data.text,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DeviceConfigDto
   * @throws ApiError
   */
  public static devicesControllerGetConfig(
    data: DevicesControllerGetConfigData,
  ): CancelablePromise<DevicesControllerGetConfigResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/config",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeviceConfigDto
   * @throws ApiError
   */
  public static devicesControllerSetConfig(
    data: DevicesControllerSetConfigData,
  ): CancelablePromise<DevicesControllerSetConfigResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/devices/{id}/config",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns boolean
   * @throws ApiError
   */
  public static devicesControllerRevertConfig(
    data: DevicesControllerRevertConfigData,
  ): CancelablePromise<DevicesControllerRevertConfigResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/{id}/revertConfig",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns PasswordDto
   * @throws ApiError
   */
  public static devicesControllerGetPassword(
    data: DevicesControllerGetPasswordData,
  ): CancelablePromise<DevicesControllerGetPasswordResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/password",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerSetPassword(
    data: DevicesControllerSetPasswordData,
  ): CancelablePromise<DevicesControllerSetPasswordResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/password",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static devicesControllerGetConfigLockState(
    data: DevicesControllerGetConfigLockStateData,
  ): CancelablePromise<DevicesControllerGetConfigLockStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/config-lock-state",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerRestart(
    data: DevicesControllerRestartData,
  ): CancelablePromise<DevicesControllerRestartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/restart",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sampleId
   * @param data.groupId
   * @param data.deviceId
   * @param data.label
   * @param data.labelTrigger
   * @param data.captureTrigger
   * @param data.family
   * @param data.category
   * @param data.imgSource
   * @param data.datasetType
   * @param data.dataType
   * @param data.opened
   * @param data.pendingRemoteAction
   * @param data.from
   * @param data.to
   * @param data.timeField
   * @param data.page
   * @param data.limit
   * @param data.orderBy
   * @param data.direction
   * @param data.uploadedBackend
   * @param data.uploadedCluster
   * @param data.headBlurred
   * @param data.headsFound
   * @returns GetSamplesQueryResponseDto
   * @throws ApiError
   */
  public static devicesControllerGetSamples(
    data: DevicesControllerGetSamplesData,
  ): CancelablePromise<DevicesControllerGetSamplesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples",
      path: {
        id: data.id,
      },
      query: {
        sampleId: data.sampleId,
        groupId: data.groupId,
        deviceId: data.deviceId,
        label: data.label,
        labelTrigger: data.labelTrigger,
        captureTrigger: data.captureTrigger,
        family: data.family,
        category: data.category,
        imgSource: data.imgSource,
        datasetType: data.datasetType,
        dataType: data.dataType,
        opened: data.opened,
        pendingRemoteAction: data.pendingRemoteAction,
        from: data.from,
        to: data.to,
        timeField: data.timeField,
        page: data.page,
        limit: data.limit,
        orderBy: data.orderBy,
        direction: data.direction,
        uploadedBackend: data.uploadedBackend,
        uploadedCluster: data.uploadedCluster,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
      },
      responseTransformer: DevicesControllerGetSamplesResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static devicesControllerAddSample(
    data: DevicesControllerAddSampleData,
  ): CancelablePromise<DevicesControllerAddSampleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns SaveSampleResponseDto
   * @throws ApiError
   */
  public static devicesControllerSaveSample(
    data: DevicesControllerSaveSampleData,
  ): CancelablePromise<DevicesControllerSaveSampleResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/devices/{id}/samples",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeleteSamples(
    data: DevicesControllerDeleteSamplesData,
  ): CancelablePromise<DevicesControllerDeleteSamplesResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/devices/{id}/samples",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sampleId
   * @param data.groupId
   * @param data.deviceId
   * @param data.label
   * @param data.labelTrigger
   * @param data.captureTrigger
   * @param data.family
   * @param data.category
   * @param data.imgSource
   * @param data.datasetType
   * @param data.dataType
   * @param data.opened
   * @param data.pendingRemoteAction
   * @param data.from
   * @param data.to
   * @param data.timeField
   * @param data.page
   * @param data.limit
   * @param data.orderBy
   * @param data.direction
   * @param data.uploadedBackend
   * @param data.uploadedCluster
   * @param data.headBlurred
   * @param data.headsFound
   * @returns number
   * @throws ApiError
   */
  public static devicesControllerGetSamplesSize(
    data: DevicesControllerGetSamplesSizeData,
  ): CancelablePromise<DevicesControllerGetSamplesSizeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples/size",
      path: {
        id: data.id,
      },
      query: {
        sampleId: data.sampleId,
        groupId: data.groupId,
        deviceId: data.deviceId,
        label: data.label,
        labelTrigger: data.labelTrigger,
        captureTrigger: data.captureTrigger,
        family: data.family,
        category: data.category,
        imgSource: data.imgSource,
        datasetType: data.datasetType,
        dataType: data.dataType,
        opened: data.opened,
        pendingRemoteAction: data.pendingRemoteAction,
        from: data.from,
        to: data.to,
        timeField: data.timeField,
        page: data.page,
        limit: data.limit,
        orderBy: data.orderBy,
        direction: data.direction,
        uploadedBackend: data.uploadedBackend,
        uploadedCluster: data.uploadedCluster,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DataStreamDto
   * @throws ApiError
   */
  public static devicesControllerGetSamplesStats(
    data: DevicesControllerGetSamplesStatsData,
  ): CancelablePromise<DevicesControllerGetSamplesStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples/stats",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StartRecordingResponseDto
   * @throws ApiError
   */
  public static devicesControllerStartRecording(
    data: DevicesControllerStartRecordingData,
  ): CancelablePromise<DevicesControllerStartRecordingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/recording/start",
      path: {
        id: data.id,
      },
      responseTransformer: DevicesControllerStartRecordingResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns StopRecordingResponseDto
   * @throws ApiError
   */
  public static devicesControllerStopRecording(
    data: DevicesControllerStopRecordingData,
  ): CancelablePromise<DevicesControllerStopRecordingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/recording/stop",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DevicesControllerStopRecordingResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns StartUploadResponseDto
   * @throws ApiError
   */
  public static devicesControllerStartVideoUpload(
    data: DevicesControllerStartVideoUploadData,
  ): CancelablePromise<DevicesControllerStartVideoUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/video-upload/start",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerStopVideoUpload(
    data: DevicesControllerStopVideoUploadData,
  ): CancelablePromise<DevicesControllerStopVideoUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/video-upload/stop",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns VideoUploadProgressDto
   * @throws ApiError
   */
  public static devicesControllerGetVideoUploadState(
    data: DevicesControllerGetVideoUploadStateData,
  ): CancelablePromise<DevicesControllerGetVideoUploadStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/video-upload",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesControllerGetVideoUploadStateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns StartUploadResponseDto
   * @throws ApiError
   */
  public static devicesControllerStartSamplesUpload(
    data: DevicesControllerStartSamplesUploadData,
  ): CancelablePromise<DevicesControllerStartSamplesUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples-upload/start",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerStopSamplesUpload(
    data: DevicesControllerStopSamplesUploadData,
  ): CancelablePromise<DevicesControllerStopSamplesUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples-upload/stop",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SampleUploadProgressDto
   * @throws ApiError
   */
  public static devicesControllerGetSamplesUploadState(
    data: DevicesControllerGetSamplesUploadStateData,
  ): CancelablePromise<DevicesControllerGetSamplesUploadStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples-upload",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesControllerGetSamplesUploadStateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.active true → only running; false → only finished
   * @param data.latest true → only most recent run per name; false → only non-latest
   * @param data.page
   * @param data.limit
   * @returns ListSamplesUploadsResponseDto
   * @throws ApiError
   */
  public static devicesControllerListSamplesUploads(
    data: DevicesControllerListSamplesUploadsData,
  ): CancelablePromise<DevicesControllerListSamplesUploadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples-upload/jobs",
      path: {
        id: data.id,
      },
      query: {
        active: data.active,
        latest: data.latest,
        page: data.page,
        limit: data.limit,
      },
      responseTransformer:
        DevicesControllerListSamplesUploadsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.name
   * @returns SampleUploadProgressDto
   * @throws ApiError
   */
  public static devicesControllerGetSamplesUploadStateByName(
    data: DevicesControllerGetSamplesUploadStateByNameData,
  ): CancelablePromise<DevicesControllerGetSamplesUploadStateByNameResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples-upload/jobs/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      responseTransformer:
        DevicesControllerGetSamplesUploadStateByNameResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.active true → only running; false → only finished
   * @param data.latest true → only most recent run per name; false → only non-latest
   * @param data.page
   * @param data.limit
   * @returns ListVideoUploadsResponseDto
   * @throws ApiError
   */
  public static devicesControllerListVideoUploads(
    data: DevicesControllerListVideoUploadsData,
  ): CancelablePromise<DevicesControllerListVideoUploadsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/video-upload/jobs",
      path: {
        id: data.id,
      },
      query: {
        active: data.active,
        latest: data.latest,
        page: data.page,
        limit: data.limit,
      },
      responseTransformer: DevicesControllerListVideoUploadsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.name
   * @returns VideoUploadProgressDto
   * @throws ApiError
   */
  public static devicesControllerGetVideoUploadStateByName(
    data: DevicesControllerGetVideoUploadStateByNameData,
  ): CancelablePromise<DevicesControllerGetVideoUploadStateByNameResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/video-upload/jobs/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      responseTransformer:
        DevicesControllerGetVideoUploadStateByNameResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns StartUploadResponseDto
   * @throws ApiError
   */
  public static devicesControllerStartHeadBlurVideos(
    data: DevicesControllerStartHeadBlurVideosData,
  ): CancelablePromise<DevicesControllerStartHeadBlurVideosResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos/start",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerStopHeadBlurVideos(
    data: DevicesControllerStopHeadBlurVideosData,
  ): CancelablePromise<DevicesControllerStopHeadBlurVideosResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos/stop",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurVideosStateDto
   * @throws ApiError
   */
  public static devicesControllerGetHeadBlurVideosState(
    data: DevicesControllerGetHeadBlurVideosStateData,
  ): CancelablePromise<DevicesControllerGetHeadBlurVideosStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesControllerGetHeadBlurVideosStateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns BlurProgressDto
   * @throws ApiError
   */
  public static devicesControllerGetHeadBlurVideoState(
    data: DevicesControllerGetHeadBlurVideoStateData,
  ): CancelablePromise<DevicesControllerGetHeadBlurVideoStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos/current",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesControllerGetHeadBlurVideoStateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.active true → only running; false → only finished
   * @param data.latest true → only most recent run per name; false → only non-latest
   * @param data.page
   * @param data.limit
   * @returns ListHeadBlurVideosResponseDto
   * @throws ApiError
   */
  public static devicesControllerListHeadBlurVideos(
    data: DevicesControllerListHeadBlurVideosData,
  ): CancelablePromise<DevicesControllerListHeadBlurVideosResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos/jobs",
      path: {
        id: data.id,
      },
      query: {
        active: data.active,
        latest: data.latest,
        page: data.page,
        limit: data.limit,
      },
      responseTransformer:
        DevicesControllerListHeadBlurVideosResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.name
   * @returns HeadBlurVideosStateDto
   * @throws ApiError
   */
  public static devicesControllerGetHeadBlurVideosStateByName(
    data: DevicesControllerGetHeadBlurVideosStateByNameData,
  ): CancelablePromise<DevicesControllerGetHeadBlurVideosStateByNameResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/videos/jobs/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      responseTransformer:
        DevicesControllerGetHeadBlurVideosStateByNameResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns StartUploadResponseDto
   * @throws ApiError
   */
  public static devicesControllerStartHeadBlurImages(
    data: DevicesControllerStartHeadBlurImagesData,
  ): CancelablePromise<DevicesControllerStartHeadBlurImagesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/head-blur/images/start",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerStopHeadBlurImages(
    data: DevicesControllerStopHeadBlurImagesData,
  ): CancelablePromise<DevicesControllerStopHeadBlurImagesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/head-blur/images/stop",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurImagesStateDto
   * @throws ApiError
   */
  public static devicesControllerGetHeadBlurImagesState(
    data: DevicesControllerGetHeadBlurImagesStateData,
  ): CancelablePromise<DevicesControllerGetHeadBlurImagesStateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/images",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesControllerGetHeadBlurImagesStateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.active true → only running; false → only finished
   * @param data.latest true → only most recent run per name; false → only non-latest
   * @param data.page
   * @param data.limit
   * @returns ListHeadBlurImagesResponseDto
   * @throws ApiError
   */
  public static devicesControllerListHeadBlurImages(
    data: DevicesControllerListHeadBlurImagesData,
  ): CancelablePromise<DevicesControllerListHeadBlurImagesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/images/jobs",
      path: {
        id: data.id,
      },
      query: {
        active: data.active,
        latest: data.latest,
        page: data.page,
        limit: data.limit,
      },
      responseTransformer:
        DevicesControllerListHeadBlurImagesResponseTransformer,
    });
  }

  /**
   * one-shot: blur a single image on the device and get it back, without starting a tracked run
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns HeadBlurImageResponseDto
   * @throws ApiError
   */
  public static devicesControllerHeadBlurImage(
    data: DevicesControllerHeadBlurImageData,
  ): CancelablePromise<DevicesControllerHeadBlurImageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/head-blur/image",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.name
   * @returns HeadBlurImagesStateDto
   * @throws ApiError
   */
  public static devicesControllerGetHeadBlurImagesStateByName(
    data: DevicesControllerGetHeadBlurImagesStateByNameData,
  ): CancelablePromise<DevicesControllerGetHeadBlurImagesStateByNameResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/head-blur/images/jobs/{name}",
      path: {
        id: data.id,
        name: data.name,
      },
      responseTransformer:
        DevicesControllerGetHeadBlurImagesStateByNameResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static devicesControllerCapture(
    data: DevicesControllerCaptureData,
  ): CancelablePromise<DevicesControllerCaptureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/capture",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns CaptureAndPredictResponseTranslatedDto
   * @throws ApiError
   */
  public static devicesControllerCaptureAndPredict(
    data: DevicesControllerCaptureAndPredictData,
  ): CancelablePromise<DevicesControllerCaptureAndPredictResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/capture-and-predict",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        DevicesControllerCaptureAndPredictResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns PredictResponseTranslatedDto
   * @throws ApiError
   */
  public static devicesControllerPredict(
    data: DevicesControllerPredictData,
  ): CancelablePromise<DevicesControllerPredictResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/predict",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DevicesControllerPredictResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sampleId
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetSample(
    data: DevicesControllerGetSampleData,
  ): CancelablePromise<DevicesControllerGetSampleResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples/{sampleId}/image",
      path: {
        id: data.id,
        sampleId: data.sampleId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sampleId
   * @param data.raw
   * @param data.width
   * @param data.height
   * @param data.expand
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetSampleThumbnail(
    data: DevicesControllerGetSampleThumbnailData,
  ): CancelablePromise<DevicesControllerGetSampleThumbnailResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/samples/{sampleId}/thumbnail",
      path: {
        id: data.id,
        sampleId: data.sampleId,
      },
      query: {
        raw: data.raw,
        width: data.width,
        height: data.height,
        expand: data.expand,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerSyncSamples(
    data: DevicesControllerSyncSamplesData,
  ): CancelablePromise<DevicesControllerSyncSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/sync",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUnlockSamples(
    data: DevicesControllerUnlockSamplesData,
  ): CancelablePromise<DevicesControllerUnlockSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/unlock",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUnlockSamplesByUuids(
    data: DevicesControllerUnlockSamplesByUuidsData,
  ): CancelablePromise<DevicesControllerUnlockSamplesByUuidsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/unlock-by-uuids",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUnlockAllSamples(
    data: DevicesControllerUnlockAllSamplesData,
  ): CancelablePromise<DevicesControllerUnlockAllSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/unlock-all",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerLockSamples(
    data: DevicesControllerLockSamplesData,
  ): CancelablePromise<DevicesControllerLockSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/lock",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerLockAllSamples(
    data: DevicesControllerLockAllSamplesData,
  ): CancelablePromise<DevicesControllerLockAllSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/samples/lock-all",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sessionId
   * @param data.deviceId
   * @param data.uploadedBackend
   * @param data.uploadedCluster
   * @param data.shouldUpload
   * @param data.headBlurred
   * @param data.from
   * @param data.to
   * @param data.timeField
   * @param data.page
   * @param data.limit
   * @param data.order
   * @param data.direction
   * @returns GetSessionsResponseDto
   * @throws ApiError
   */
  public static devicesControllerGetSessions(
    data: DevicesControllerGetSessionsData,
  ): CancelablePromise<DevicesControllerGetSessionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/sessions",
      path: {
        id: data.id,
      },
      query: {
        sessionId: data.sessionId,
        deviceId: data.deviceId,
        uploadedBackend: data.uploadedBackend,
        uploadedCluster: data.uploadedCluster,
        shouldUpload: data.shouldUpload,
        headBlurred: data.headBlurred,
        from: data.from,
        to: data.to,
        timeField: data.timeField,
        page: data.page,
        limit: data.limit,
        order: data.order,
        direction: data.direction,
      },
      responseTransformer: DevicesControllerGetSessionsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sessionId
   * @param data.deviceId
   * @param data.uploadedBackend
   * @param data.uploadedCluster
   * @param data.shouldUpload
   * @param data.headBlurred
   * @param data.from
   * @param data.to
   * @param data.timeField
   * @param data.page
   * @param data.limit
   * @param data.order
   * @param data.direction
   * @returns number
   * @throws ApiError
   */
  public static devicesControllerGetSessionsSize(
    data: DevicesControllerGetSessionsSizeData,
  ): CancelablePromise<DevicesControllerGetSessionsSizeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/sessions/size",
      path: {
        id: data.id,
      },
      query: {
        sessionId: data.sessionId,
        deviceId: data.deviceId,
        uploadedBackend: data.uploadedBackend,
        uploadedCluster: data.uploadedCluster,
        shouldUpload: data.shouldUpload,
        headBlurred: data.headBlurred,
        from: data.from,
        to: data.to,
        timeField: data.timeField,
        page: data.page,
        limit: data.limit,
        order: data.order,
        direction: data.direction,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerSyncSessions(
    data: DevicesControllerSyncSessionsData,
  ): CancelablePromise<DevicesControllerSyncSessionsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/sessions/sync",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.sessionId
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeleteSession(
    data: DevicesControllerDeleteSessionData,
  ): CancelablePromise<DevicesControllerDeleteSessionResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/devices/{id}/sessions/{sessionId}",
      path: {
        id: data.id,
        sessionId: data.sessionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUploadLogs(
    data: DevicesControllerUploadLogsData,
  ): CancelablePromise<DevicesControllerUploadLogsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/upload-logs",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerUploadTrainerLogs(
    data: DevicesControllerUploadTrainerLogsData,
  ): CancelablePromise<DevicesControllerUploadTrainerLogsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/upload-trainer-logs",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeployAgentVersion(
    data: DevicesControllerDeployAgentVersionData,
  ): CancelablePromise<DevicesControllerDeployAgentVersionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/deploy-agent-version",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetAgentDeployments(
    data: DevicesControllerGetAgentDeploymentsData,
  ): CancelablePromise<DevicesControllerGetAgentDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/agent-deployments",
      path: {
        id: data.id,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeployService(
    data: DevicesControllerDeployServiceData,
  ): CancelablePromise<DevicesControllerDeployServiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/deploy-service-version",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.serviceName
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetServiceDeployments(
    data: DevicesControllerGetServiceDeploymentsData,
  ): CancelablePromise<DevicesControllerGetServiceDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/service-deployments",
      path: {
        id: data.id,
      },
      query: {
        serviceName: data.serviceName,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.serviceName The service name
   * @param data.limit
   * @param data.page
   * @param data.version
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetAvailableServiceVersions(
    data: DevicesControllerGetAvailableServiceVersionsData,
  ): CancelablePromise<DevicesControllerGetAvailableServiceVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/available-service-versions/{serviceName}",
      path: {
        id: data.id,
        serviceName: data.serviceName,
      },
      query: {
        version: data.version,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerTestAlertNonMatch(
    data: DevicesControllerTestAlertNonMatchData,
  ): CancelablePromise<DevicesControllerTestAlertNonMatchResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/testing/alert-non-match",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerTestAlertNonScan(
    data: DevicesControllerTestAlertNonScanData,
  ): CancelablePromise<DevicesControllerTestAlertNonScanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/testing/alert-non-scan",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerTestAlertLeftInCart(
    data: DevicesControllerTestAlertLeftInCartData,
  ): CancelablePromise<DevicesControllerTestAlertLeftInCartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/testing/alert-left-in-cart",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListCameras(
    data: DevicesControllerListCamerasData,
  ): CancelablePromise<DevicesControllerListCamerasResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/camera",
      path: {
        id: data.id,
      },
      query: {
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListInternalCameras(
    data: DevicesControllerListInternalCamerasData,
  ): CancelablePromise<DevicesControllerListInternalCamerasResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/camera/internal",
      path: {
        id: data.id,
      },
      query: {
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.uri
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListExternalCamera(
    data: DevicesControllerListExternalCameraData,
  ): CancelablePromise<DevicesControllerListExternalCameraResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/camera/external",
      path: {
        id: data.id,
      },
      query: {
        uri: data.uri,
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGetCameraControls(
    data: DevicesControllerGetCameraControlsData,
  ): CancelablePromise<DevicesControllerGetCameraControlsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/camera/controls",
      path: {
        id: data.id,
      },
      query: {
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerSetCameraControls(
    data: DevicesControllerSetCameraControlsData,
  ): CancelablePromise<DevicesControllerSetCameraControlsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/camera/controls",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerListConfigDeployments(
    data: DevicesControllerListConfigDeploymentsData,
  ): CancelablePromise<DevicesControllerListConfigDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/configDeployments",
      path: {
        id: data.id,
      },
      query: {
        sortBy: data.sortBy,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDisableDeviceAlerts(
    data: DevicesControllerDisableDeviceAlertsData,
  ): CancelablePromise<DevicesControllerDisableDeviceAlertsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/disable-device-alerts",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerEnableDeviceAlerts(
    data: DevicesControllerEnableDeviceAlertsData,
  ): CancelablePromise<DevicesControllerEnableDeviceAlertsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/enable-device-alerts",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeviceAlertsStatusDto
   * @throws ApiError
   */
  public static devicesControllerGetDeviceAlertsStatus(
    data: DevicesControllerGetDeviceAlertsStatusData,
  ): CancelablePromise<DevicesControllerGetDeviceAlertsStatusResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/device-alerts-status",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DeviceAlertsStatusDto
   * @throws ApiError
   */
  public static devicesControllerSetDeviceAlerts(
    data: DevicesControllerSetDeviceAlertsData,
  ): CancelablePromise<DevicesControllerSetDeviceAlertsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/set-device-alerts",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerTestConnection(
    data: DevicesControllerTestConnectionData,
  ): CancelablePromise<DevicesControllerTestConnectionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/test-connection",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.field
   * @returns GetConfigFileResponseDto
   * @throws ApiError
   */
  public static devicesControllerGetConfigFile(
    data: DevicesControllerGetConfigFileData,
  ): CancelablePromise<DevicesControllerGetConfigFileResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/config-file",
      path: {
        id: data.id,
      },
      query: {
        field: data.field,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerSetConfigFile(
    data: DevicesControllerSetConfigFileData,
  ): CancelablePromise<DevicesControllerSetConfigFileResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/config-file",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.field
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerDeleteConfigFile(
    data: DevicesControllerDeleteConfigFileData,
  ): CancelablePromise<DevicesControllerDeleteConfigFileResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/devices/{id}/config-file",
      path: {
        id: data.id,
      },
      query: {
        field: data.field,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesControllerGenerateCertificate(
    data: DevicesControllerGenerateCertificateData,
  ): CancelablePromise<DevicesControllerGenerateCertificateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/{id}/generate-certificate",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.field
   * @returns GetCertValidityResponseDto
   * @throws ApiError
   */
  public static devicesControllerGetCertValidity(
    data: DevicesControllerGetCertValidityData,
  ): CancelablePromise<DevicesControllerGetCertValidityResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/{id}/cert-validity",
      path: {
        id: data.id,
      },
      query: {
        field: data.field,
      },
    });
  }
}

export class DashboardDevicesTaggingService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static devicesTaggingControllerListTags(
    data: DevicesTaggingControllerListTagsData,
  ): CancelablePromise<DevicesTaggingControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/devices-tagging/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static devicesTaggingControllerCreateTags(
    data: DevicesTaggingControllerCreateTagsData,
  ): CancelablePromise<DevicesTaggingControllerCreateTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/devices-tagging/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignTagsResponseDto
   * @throws ApiError
   */
  public static devicesTaggingControllerAssignTags(
    data: DevicesTaggingControllerAssignTagsData,
  ): CancelablePromise<DevicesTaggingControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/devices/devices-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignTagsResponseDto
   * @throws ApiError
   */
  public static devicesTaggingControllerUnassignTags(
    data: DevicesTaggingControllerUnassignTagsData,
  ): CancelablePromise<DevicesTaggingControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/devices/devices-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static devicesTaggingControllerGetDetails(
    data: DevicesTaggingControllerGetDetailsData,
  ): CancelablePromise<DevicesTaggingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/devices-tagging/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        DevicesTaggingControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static devicesTaggingControllerUpdateTag(
    data: DevicesTaggingControllerUpdateTagData,
  ): CancelablePromise<DevicesTaggingControllerUpdateTagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/devices-tagging/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: DevicesTaggingControllerUpdateTagResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static devicesTaggingControllerDeleteTag(
    data: DevicesTaggingControllerDeleteTagData,
  ): CancelablePromise<DevicesTaggingControllerDeleteTagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/devices/devices-tagging/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static devicesTaggingControllerMergeTagTo(
    data: DevicesTaggingControllerMergeTagToData,
  ): CancelablePromise<DevicesTaggingControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/devices/devices-tagging/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static devicesTaggingControllerListSummaries(
    data: DevicesTaggingControllerListSummariesData,
  ): CancelablePromise<DevicesTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/devices/devices-tagging/summaries",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class DashboardDomainAuthSettingsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns DomainAuthSettingResponseDto
   * @throws ApiError
   */
  public static domainAuthSettingsControllerCreate(
    data: DomainAuthSettingsControllerCreateData,
  ): CancelablePromise<DomainAuthSettingsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/domain-auth-settings",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns DomainAuthSettingResponseDto
   * @throws ApiError
   */
  public static domainAuthSettingsControllerList(): CancelablePromise<DomainAuthSettingsControllerListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/domain-auth-settings",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.domain
   * @returns DomainAuthSettingResponseDto
   * @throws ApiError
   */
  public static domainAuthSettingsControllerFindOne(
    data: DomainAuthSettingsControllerFindOneData,
  ): CancelablePromise<DomainAuthSettingsControllerFindOneResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/domain-auth-settings/{domain}",
      path: {
        domain: data.domain,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.domain
   * @param data.requestBody
   * @returns DomainAuthSettingResponseDto
   * @throws ApiError
   */
  public static domainAuthSettingsControllerUpdate(
    data: DomainAuthSettingsControllerUpdateData,
  ): CancelablePromise<DomainAuthSettingsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/domain-auth-settings/{domain}",
      path: {
        domain: data.domain,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.domain
   * @returns unknown
   * @throws ApiError
   */
  public static domainAuthSettingsControllerRemove(
    data: DomainAuthSettingsControllerRemoveData,
  ): CancelablePromise<DomainAuthSettingsControllerRemoveResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/domain-auth-settings/{domain}",
      path: {
        domain: data.domain,
      },
    });
  }
}

export class DashboardEmailReportsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailReportsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static emailReportsControllerCreateSchedule(
    data: EmailReportsControllerCreateScheduleData,
  ): CancelablePromise<EmailReportsControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        EmailReportsControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerListScheduled(
    data: EmailReportsControllerListScheduledData,
  ): CancelablePromise<EmailReportsControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.reportId
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerListSubscriptionsByReport(
    data: EmailReportsControllerListSubscriptionsByReportData,
  ): CancelablePromise<EmailReportsControllerListSubscriptionsByReportResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/report/{reportId}/subscriptions",
      path: {
        reportId: data.reportId,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns ReportSubscriptionDetailDto
   * @throws ApiError
   */
  public static emailReportsControllerGetSubscriptionDetail(
    data: EmailReportsControllerGetSubscriptionDetailData,
  ): CancelablePromise<EmailReportsControllerGetSubscriptionDetailResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/subscription/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
      responseTransformer:
        EmailReportsControllerGetSubscriptionDetailResponseTransformer,
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static emailReportsControllerListApproverCandidateEmails(): CancelablePromise<EmailReportsControllerListApproverCandidateEmailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/approver-candidate-emails",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns string
   * @throws ApiError
   */
  public static emailReportsControllerGetLastSentCopy(
    data: EmailReportsControllerGetLastSentCopyData,
  ): CancelablePromise<EmailReportsControllerGetLastSentCopyResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/subscription/{subscriptionId}/last-sent-copy",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerDownloadSubscriptionPdf(
    data: EmailReportsControllerDownloadSubscriptionPdfData,
  ): CancelablePromise<EmailReportsControllerDownloadSubscriptionPdfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/subscription/{subscriptionId}/pdf",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.limit
   * @param data.page
   * @param data.since
   * @param data.until
   * @param data.outcomes
   * @returns SubscriptionSendHistoryResponseDto
   * @throws ApiError
   */
  public static emailReportsControllerGetSubscriptionSendHistory(
    data: EmailReportsControllerGetSubscriptionSendHistoryData,
  ): CancelablePromise<EmailReportsControllerGetSubscriptionSendHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/subscription/{subscriptionId}/history",
      path: {
        subscriptionId: data.subscriptionId,
      },
      query: {
        limit: data.limit,
        page: data.page,
        since: data.since,
        until: data.until,
        outcomes: data.outcomes,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static emailReportsControllerDownloadSubscriptionSendHistory(
    data: EmailReportsControllerDownloadSubscriptionSendHistoryData,
  ): CancelablePromise<EmailReportsControllerDownloadSubscriptionSendHistoryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/subscription-history/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @param data.jobId
   * @returns string
   * @throws ApiError
   */
  public static emailReportsControllerPreviewHistoricalSend(
    data: EmailReportsControllerPreviewHistoricalSendData,
  ): CancelablePromise<EmailReportsControllerPreviewHistoricalSendResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/subscription/{subscriptionId}/history/{jobId}/preview",
      path: {
        subscriptionId: data.subscriptionId,
        jobId: data.jobId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.reportId
   * @returns ReportSendLogResponseDto
   * @throws ApiError
   */
  public static emailReportsControllerGetReportSendLog(
    data: EmailReportsControllerGetReportSendLogData,
  ): CancelablePromise<EmailReportsControllerGetReportSendLogResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/report/{reportId}/send-log",
      path: {
        reportId: data.reportId,
      },
      responseTransformer:
        EmailReportsControllerGetReportSendLogResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns EmailReportsScheduledJobDto
   * @throws ApiError
   */
  public static emailReportsControllerUpdateScheduledJob(
    data: EmailReportsControllerUpdateScheduledJobData,
  ): CancelablePromise<EmailReportsControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/email-reports/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        EmailReportsControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static emailReportsControllerDeleteScheduledJob(
    data: EmailReportsControllerDeleteScheduledJobData,
  ): CancelablePromise<EmailReportsControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/email-reports/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EmailReportsScheduledJobDto
   * @throws ApiError
   */
  public static emailReportsControllerGetScheduledJob(
    data: EmailReportsControllerGetScheduledJobData,
  ): CancelablePromise<EmailReportsControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        EmailReportsControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerStartScheduledJob(
    data: EmailReportsControllerStartScheduledJobData,
  ): CancelablePromise<EmailReportsControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/{id}/start",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static emailReportsControllerCancelScheduledJob(
    data: EmailReportsControllerCancelScheduledJobData,
  ): CancelablePromise<EmailReportsControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static emailReportsControllerStopScheduledJob(
    data: EmailReportsControllerStopScheduledJobData,
  ): CancelablePromise<EmailReportsControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EmailReportsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static emailReportsControllerResumeScheduledJob(
    data: EmailReportsControllerResumeScheduledJobData,
  ): CancelablePromise<EmailReportsControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        EmailReportsControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static emailReportsControllerCancelScheduledJobsBulk(
    data: EmailReportsControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<EmailReportsControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static emailReportsControllerStopScheduledJobsBulk(
    data: EmailReportsControllerStopScheduledJobsBulkData,
  ): CancelablePromise<EmailReportsControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static emailReportsControllerResumeScheduledJobsBulk(
    data: EmailReportsControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<EmailReportsControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static emailReportsControllerDeleteScheduledJobsBulk(
    data: EmailReportsControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<EmailReportsControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.email
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerUnsubscribe(
    data: EmailReportsControllerUnsubscribeData,
  ): CancelablePromise<EmailReportsControllerUnsubscribeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/unsubscribe/{id}/{email}",
      path: {
        id: data.id,
        email: data.email,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SendPendingReportResponseDto
   * @throws ApiError
   */
  public static emailReportsControllerSendPendingReport(
    data: EmailReportsControllerSendPendingReportData,
  ): CancelablePromise<EmailReportsControllerSendPendingReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/send-pending-report",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerRejectPendingReport(
    data: EmailReportsControllerRejectPendingReportData,
  ): CancelablePromise<EmailReportsControllerRejectPendingReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/reject-pending-report",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.subscriptionId
   * @returns string
   * @throws ApiError
   */
  public static emailReportsControllerPreviewPendingReport(
    data: EmailReportsControllerPreviewPendingReportData,
  ): CancelablePromise<EmailReportsControllerPreviewPendingReportResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/preview-pending-report/{subscriptionId}",
      path: {
        subscriptionId: data.subscriptionId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static emailReportsControllerPreviewTemplate(
    data: EmailReportsControllerPreviewTemplateData,
  ): CancelablePromise<EmailReportsControllerPreviewTemplateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/preview-template",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerUpdateSummaryText(
    data: EmailReportsControllerUpdateSummaryTextData,
  ): CancelablePromise<EmailReportsControllerUpdateSummaryTextResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/update-summary-text",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailReportsJobDto
   * @throws ApiError
   */
  public static emailReportsControllerStartJob(
    data: EmailReportsControllerStartJobData,
  ): CancelablePromise<EmailReportsControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: EmailReportsControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static emailReportsControllerListSummaries(
    data: EmailReportsControllerListSummariesData,
  ): CancelablePromise<EmailReportsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EmailReportsJobDto
   * @throws ApiError
   */
  public static emailReportsControllerGetJob(
    data: EmailReportsControllerGetJobData,
  ): CancelablePromise<EmailReportsControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/email-reports/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: EmailReportsControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static emailReportsControllerDeleteJob(
    data: EmailReportsControllerDeleteJobData,
  ): CancelablePromise<EmailReportsControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/email-reports/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns EmailReportsJobDto
   * @throws ApiError
   */
  public static emailReportsControllerUpdateJob(
    data: EmailReportsControllerUpdateJobData,
  ): CancelablePromise<EmailReportsControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/email-reports/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: EmailReportsControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static emailReportsControllerCancelJob(
    data: EmailReportsControllerCancelJobData,
  ): CancelablePromise<EmailReportsControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static emailReportsControllerStopJob(
    data: EmailReportsControllerStopJobData,
  ): CancelablePromise<EmailReportsControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static emailReportsControllerCancelJobsBulk(
    data: EmailReportsControllerCancelJobsBulkData,
  ): CancelablePromise<EmailReportsControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static emailReportsControllerDeleteJobsBulk(
    data: EmailReportsControllerDeleteJobsBulkData,
  ): CancelablePromise<EmailReportsControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/email-reports/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardFeedbackService {
  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static feedbackControllerCreateFeedback(
    data: FeedbackControllerCreateFeedbackData,
  ): CancelablePromise<FeedbackControllerCreateFeedbackResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/feedback",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}

export class DashboardHeadBlurImagesService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns HeadBlurImagesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static headBlurImagesControllerCreateSchedule(
    data: HeadBlurImagesControllerCreateScheduleData,
  ): CancelablePromise<HeadBlurImagesControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        HeadBlurImagesControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static headBlurImagesControllerListScheduled(
    data: HeadBlurImagesControllerListScheduledData,
  ): CancelablePromise<HeadBlurImagesControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-images/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurImagesScheduledJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerGetScheduledJob(
    data: HeadBlurImagesControllerGetScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurImagesControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns HeadBlurImagesScheduledJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerUpdateScheduledJob(
    data: HeadBlurImagesControllerUpdateScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        HeadBlurImagesControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurImagesControllerDeleteScheduledJob(
    data: HeadBlurImagesControllerDeleteScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static headBlurImagesControllerCancelScheduledJobsBulk(
    data: HeadBlurImagesControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static headBlurImagesControllerStopScheduledJobsBulk(
    data: HeadBlurImagesControllerStopScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static headBlurImagesControllerResumeScheduledJobsBulk(
    data: HeadBlurImagesControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static headBlurImagesControllerDeleteScheduledJobsBulk(
    data: HeadBlurImagesControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurImagesJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerStartScheduledJob(
    data: HeadBlurImagesControllerStartScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurImagesControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurImagesControllerCancelScheduledJob(
    data: HeadBlurImagesControllerCancelScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static headBlurImagesControllerStopScheduledJob(
    data: HeadBlurImagesControllerStopScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurImagesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static headBlurImagesControllerResumeScheduledJob(
    data: HeadBlurImagesControllerResumeScheduledJobData,
  ): CancelablePromise<HeadBlurImagesControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurImagesControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns HeadBlurImagesJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerStartJob(
    data: HeadBlurImagesControllerStartJobData,
  ): CancelablePromise<HeadBlurImagesControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: HeadBlurImagesControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static headBlurImagesControllerListSummaries(
    data: HeadBlurImagesControllerListSummariesData,
  ): CancelablePromise<HeadBlurImagesControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-images/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurImagesJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerGetJob(
    data: HeadBlurImagesControllerGetJobData,
  ): CancelablePromise<HeadBlurImagesControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-images/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: HeadBlurImagesControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurImagesControllerDeleteJob(
    data: HeadBlurImagesControllerDeleteJobData,
  ): CancelablePromise<HeadBlurImagesControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/head-blur-images/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns HeadBlurImagesJobDto
   * @throws ApiError
   */
  public static headBlurImagesControllerUpdateJob(
    data: HeadBlurImagesControllerUpdateJobData,
  ): CancelablePromise<HeadBlurImagesControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/head-blur-images/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: HeadBlurImagesControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurImagesControllerCancelJob(
    data: HeadBlurImagesControllerCancelJobData,
  ): CancelablePromise<HeadBlurImagesControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurImagesControllerStopJob(
    data: HeadBlurImagesControllerStopJobData,
  ): CancelablePromise<HeadBlurImagesControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static headBlurImagesControllerCancelJobsBulk(
    data: HeadBlurImagesControllerCancelJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static headBlurImagesControllerDeleteJobsBulk(
    data: HeadBlurImagesControllerDeleteJobsBulkData,
  ): CancelablePromise<HeadBlurImagesControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-images/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardHeadBlurVideosService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns HeadBlurVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static headBlurVideosControllerCreateSchedule(
    data: HeadBlurVideosControllerCreateScheduleData,
  ): CancelablePromise<HeadBlurVideosControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        HeadBlurVideosControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static headBlurVideosControllerListScheduled(
    data: HeadBlurVideosControllerListScheduledData,
  ): CancelablePromise<HeadBlurVideosControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-videos/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurVideosScheduledJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerGetScheduledJob(
    data: HeadBlurVideosControllerGetScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurVideosControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns HeadBlurVideosScheduledJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerUpdateScheduledJob(
    data: HeadBlurVideosControllerUpdateScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        HeadBlurVideosControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurVideosControllerDeleteScheduledJob(
    data: HeadBlurVideosControllerDeleteScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static headBlurVideosControllerCancelScheduledJobsBulk(
    data: HeadBlurVideosControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static headBlurVideosControllerStopScheduledJobsBulk(
    data: HeadBlurVideosControllerStopScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static headBlurVideosControllerResumeScheduledJobsBulk(
    data: HeadBlurVideosControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static headBlurVideosControllerDeleteScheduledJobsBulk(
    data: HeadBlurVideosControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurVideosJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerStartScheduledJob(
    data: HeadBlurVideosControllerStartScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurVideosControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurVideosControllerCancelScheduledJob(
    data: HeadBlurVideosControllerCancelScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static headBlurVideosControllerStopScheduledJob(
    data: HeadBlurVideosControllerStopScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static headBlurVideosControllerResumeScheduledJob(
    data: HeadBlurVideosControllerResumeScheduledJobData,
  ): CancelablePromise<HeadBlurVideosControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        HeadBlurVideosControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns HeadBlurVideosJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerStartJob(
    data: HeadBlurVideosControllerStartJobData,
  ): CancelablePromise<HeadBlurVideosControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: HeadBlurVideosControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static headBlurVideosControllerListSummaries(
    data: HeadBlurVideosControllerListSummariesData,
  ): CancelablePromise<HeadBlurVideosControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-videos/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns HeadBlurVideosJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerGetJob(
    data: HeadBlurVideosControllerGetJobData,
  ): CancelablePromise<HeadBlurVideosControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/head-blur-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: HeadBlurVideosControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurVideosControllerDeleteJob(
    data: HeadBlurVideosControllerDeleteJobData,
  ): CancelablePromise<HeadBlurVideosControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/head-blur-videos/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns HeadBlurVideosJobDto
   * @throws ApiError
   */
  public static headBlurVideosControllerUpdateJob(
    data: HeadBlurVideosControllerUpdateJobData,
  ): CancelablePromise<HeadBlurVideosControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/head-blur-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: HeadBlurVideosControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurVideosControllerCancelJob(
    data: HeadBlurVideosControllerCancelJobData,
  ): CancelablePromise<HeadBlurVideosControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static headBlurVideosControllerStopJob(
    data: HeadBlurVideosControllerStopJobData,
  ): CancelablePromise<HeadBlurVideosControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static headBlurVideosControllerCancelJobsBulk(
    data: HeadBlurVideosControllerCancelJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static headBlurVideosControllerDeleteJobsBulk(
    data: HeadBlurVideosControllerDeleteJobsBulkData,
  ): CancelablePromise<HeadBlurVideosControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/head-blur-videos/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardJiraService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jiraControllerGetIssueType(
    data: JiraControllerGetIssueTypeData,
  ): CancelablePromise<JiraControllerGetIssueTypeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/jira/issue-types",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static jiraControllerGetProjectIssueTypes(
    data: JiraControllerGetProjectIssueTypesData,
  ): CancelablePromise<JiraControllerGetProjectIssueTypesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/jira/project-issue-types",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns JiraState
   * @throws ApiError
   */
  public static jiraControllerGetState(
    data: JiraControllerGetStateData,
  ): CancelablePromise<JiraControllerGetStateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/jira/states",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardLabelDistributionService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.sortBy
   * @param data.label
   * @param data.labels
   * @param data.family
   * @param data.families
   * @param data.quantity
   * @returns unknown
   * @throws ApiError
   */
  public static labelDistributionControllerListLabelDistribution(
    data: LabelDistributionControllerListLabelDistributionData,
  ): CancelablePromise<LabelDistributionControllerListLabelDistributionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/label-distribution",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        sortBy: data.sortBy,
        label: data.label,
        labels: data.labels,
        family: data.family,
        families: data.families,
        quantity: data.quantity,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.sortBy
   * @param data.label
   * @param data.labels
   * @param data.family
   * @param data.families
   * @param data.quantity
   * @returns number
   * @throws ApiError
   */
  public static labelDistributionControllerLabelDistributionCount(
    data: LabelDistributionControllerLabelDistributionCountData = {},
  ): CancelablePromise<LabelDistributionControllerLabelDistributionCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/label-distribution/count",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        sortBy: data.sortBy,
        label: data.label,
        labels: data.labels,
        family: data.family,
        families: data.families,
        quantity: data.quantity,
      },
    });
  }
}

export class DashboardLookupTablesService {
  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static lookupTableControllerCreate(
    data: LookupTableControllerCreateData,
  ): CancelablePromise<LookupTableControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/lookup-table",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static lookupTableControllerListSummaries(
    data: LookupTableControllerListSummariesData,
  ): CancelablePromise<LookupTableControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/lookup-table/summaries",
      query: {
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.formData
   * @returns boolean
   * @throws ApiError
   */
  public static lookupTableControllerUpdate(
    data: LookupTableControllerUpdateData,
  ): CancelablePromise<LookupTableControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/lookup-table/{id}",
      path: {
        id: data.id,
      },
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns LookupTableDetailsDto
   * @throws ApiError
   */
  public static lookupTableControllerGetDetails(
    data: LookupTableControllerGetDetailsData,
  ): CancelablePromise<LookupTableControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/lookup-table/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static lookupTableControllerDelete(
    data: LookupTableControllerDeleteData,
  ): CancelablePromise<LookupTableControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/lookup-table/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static lookupTableControllerDownloadCatalog(
    data: LookupTableControllerDownloadCatalogData,
  ): CancelablePromise<LookupTableControllerDownloadCatalogResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/lookup-table/download/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class DashboardMetricAlertsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MetricAlertResponseDto
   * @throws ApiError
   */
  public static metricAlertsControllerCreate(
    data: MetricAlertsControllerCreateData,
  ): CancelablePromise<MetricAlertsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/metric-alerts",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: MetricAlertsControllerCreateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.priority
   * @param data.severity
   * @param data.sortBy
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static metricAlertsControllerList(
    data: MetricAlertsControllerListData,
  ): CancelablePromise<MetricAlertsControllerListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/metric-alerts",
      query: {
        priority: data.priority,
        severity: data.severity,
        sortBy: data.sortBy,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns MetricAlertResponseDto
   * @throws ApiError
   */
  public static metricAlertsControllerGetById(
    data: MetricAlertsControllerGetByIdData,
  ): CancelablePromise<MetricAlertsControllerGetByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/metric-alerts/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: MetricAlertsControllerGetByIdResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns MetricAlertResponseDto
   * @throws ApiError
   */
  public static metricAlertsControllerUpdate(
    data: MetricAlertsControllerUpdateData,
  ): CancelablePromise<MetricAlertsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/metric-alerts/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: MetricAlertsControllerUpdateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static metricAlertsControllerRemove(
    data: MetricAlertsControllerRemoveData,
  ): CancelablePromise<MetricAlertsControllerRemoveResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/metric-alerts/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns PreviewMetricAlertResponseDto
   * @throws ApiError
   */
  public static metricAlertsControllerPreview(
    data: MetricAlertsControllerPreviewData,
  ): CancelablePromise<MetricAlertsControllerPreviewResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/metric-alerts/preview",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TestMetricAlertResponseDto
   * @throws ApiError
   */
  public static metricAlertsControllerTest(
    data: MetricAlertsControllerTestData,
  ): CancelablePromise<MetricAlertsControllerTestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/metric-alerts/{id}/test",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardModelsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.type
   * @param data.sortBy
   * @param data.search
   * @param data.name
   * @param data.role
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerListSummaries(
    data: ModelsControllerListSummariesData,
  ): CancelablePromise<ModelsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/summaries",
      query: {
        type: data.type,
        sortBy: data.sortBy,
        search: data.search,
        name: data.name,
        role: data.role,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.type
   * @param data.orderBy
   * @param data.sortBy
   * @param data.search
   * @param data.name
   * @param data.role
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerListMinimal(
    data: ModelsControllerListMinimalData,
  ): CancelablePromise<ModelsControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/minimal",
      query: {
        type: data.type,
        orderBy: data.orderBy,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
        search: data.search,
        name: data.name,
        role: data.role,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.type
   * @param data.sortBy
   * @param data.search
   * @param data.name
   * @param data.role
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerListModelRoles(
    data: ModelsControllerListModelRolesData,
  ): CancelablePromise<ModelsControllerListModelRolesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/roles",
      query: {
        type: data.type,
        sortBy: data.sortBy,
        search: data.search,
        name: data.name,
        role: data.role,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ModelDetailsDto
   * @throws ApiError
   */
  public static modelsControllerGetDetails(
    data: ModelsControllerGetDetailsData,
  ): CancelablePromise<ModelsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: ModelsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerUpdate(
    data: ModelsControllerUpdateData,
  ): CancelablePromise<ModelsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/models/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static modelsControllerUploadModel(
    data: ModelsControllerUploadModelData,
  ): CancelablePromise<ModelsControllerUploadModelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/models/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerDownloadModel(
    data: ModelsControllerDownloadModelData,
  ): CancelablePromise<ModelsControllerDownloadModelResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/download/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.id
   * @param data.name
   * @param data.state
   * @param data.states
   * @param data.deviceStates
   * @param data.clusterIds
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerListDeployments(
    data: ModelsControllerListDeploymentsData,
  ): CancelablePromise<ModelsControllerListDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/{id}/deployments",
      path: {
        id: data.id,
      },
      query: {
        name: data.name,
        state: data.state,
        states: data.states,
        deviceStates: data.deviceStates,
        clusterIds: data.clusterIds,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.id
   * @param data.name
   * @param data.clusterIds
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static modelsControllerListClusterDeployments(
    data: ModelsControllerListClusterDeploymentsData,
  ): CancelablePromise<ModelsControllerListClusterDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/models/{id}/cluster-deployments",
      path: {
        id: data.id,
      },
      query: {
        name: data.name,
        clusterIds: data.clusterIds,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns DeployModelResponseDto
   * @throws ApiError
   */
  public static modelsControllerDeployModel(
    data: ModelsControllerDeployModelData,
  ): CancelablePromise<ModelsControllerDeployModelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/models/{id}/deploy",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardNotificationsService {
  /**
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public static notificationsControllerGetActive(): CancelablePromise<NotificationsControllerGetActiveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/notifications",
      responseTransformer: NotificationsControllerGetActiveResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public static notificationsControllerCreate(
    data: NotificationsControllerCreateData,
  ): CancelablePromise<NotificationsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/notifications",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: NotificationsControllerCreateResponseTransformer,
    });
  }

  /**
   * @returns PublicNotificationResponseDto
   * @throws ApiError
   */
  public static notificationsControllerGetActivePublic(): CancelablePromise<NotificationsControllerGetActivePublicResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/notifications/public",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.title Filter by title (case-insensitive partial match)
   * @param data.type Filter by notification type
   * @param data.status Filter by status
   * @param data.isActive Filter by active state. Defaults to true (only active records).
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static notificationsControllerListSummaries(
    data: NotificationsControllerListSummariesData,
  ): CancelablePromise<NotificationsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/notifications/summaries",
      query: {
        title: data.title,
        type: data.type,
        status: data.status,
        isActive: data.isActive,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public static notificationsControllerFindOne(
    data: NotificationsControllerFindOneData,
  ): CancelablePromise<NotificationsControllerFindOneResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/notifications/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: NotificationsControllerFindOneResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns NotificationResponseDto
   * @throws ApiError
   */
  public static notificationsControllerUpdate(
    data: NotificationsControllerUpdateData,
  ): CancelablePromise<NotificationsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/notifications/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: NotificationsControllerUpdateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static notificationsControllerRemove(
    data: NotificationsControllerRemoveData,
  ): CancelablePromise<NotificationsControllerRemoveResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/notifications/{id}",
      path: {
        id: data.id,
      },
    });
  }
}

export class DashboardPageViewsService {
  /**
   * @param data The data for the request.
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static pageViewsControllerReport(
    data: PageViewsControllerReportData,
  ): CancelablePromise<PageViewsControllerReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/page-views/{page}",
      path: {
        page: data.page,
      },
    });
  }
}

export class DashboardPendingSampleActionsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.operationIds
   * @param data.actions
   * @param data.sortBy
   * @param data.uuid
   * @param data.from
   * @param data.to
   * @param data.ownedByMe
   * @returns unknown
   * @throws ApiError
   */
  public static pendingControllerListSummaries(
    data: PendingControllerListSummariesData,
  ): CancelablePromise<PendingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/pendingSampleActions/summaries",
      query: {
        deviceIds: data.deviceIds,
        operationIds: data.operationIds,
        actions: data.actions,
        sortBy: data.sortBy,
        uuid: data.uuid,
        from: data.from,
        to: data.to,
        ownedByMe: data.ownedByMe,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.operationIds
   * @param data.deviceIds
   * @param data.sortBy
   * @param data.from
   * @param data.to
   * @param data.ownedByMe
   * @returns unknown
   * @throws ApiError
   */
  public static pendingControllerListUploadOperations(
    data: PendingControllerListUploadOperationsData,
  ): CancelablePromise<PendingControllerListUploadOperationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/pendingSampleActions/upload-operations",
      query: {
        operationIds: data.operationIds,
        deviceIds: data.deviceIds,
        sortBy: data.sortBy,
        from: data.from,
        to: data.to,
        ownedByMe: data.ownedByMe,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadOperationCancellationResultDto
   * @throws ApiError
   */
  public static pendingControllerCancelOperation(
    data: PendingControllerCancelOperationData,
  ): CancelablePromise<PendingControllerCancelOperationResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/pendingSampleActions/upload-operations/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UploadCancellationResultDto
   * @throws ApiError
   */
  public static pendingControllerCancelSelected(
    data: PendingControllerCancelSelectedData,
  ): CancelablePromise<PendingControllerCancelSelectedResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/pendingSampleActions/uploads/cancel",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardPermissionsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.module
   * @param data.search
   * @param data.showBackend
   * @returns unknown
   * @throws ApiError
   */
  public static permissionsControllerListSummaries(
    data: PermissionsControllerListSummariesData,
  ): CancelablePromise<PermissionsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/permissions/summaries",
      query: {
        module: data.module,
        search: data.search,
        showBackend: data.showBackend,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static permissionsControllerGetAll(): CancelablePromise<PermissionsControllerGetAllResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/permissions/all",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static permissionsControllerGetPermissionsEndpoints(): CancelablePromise<PermissionsControllerGetPermissionsEndpointsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/permissions/endpoints",
    });
  }

  /**
   * @returns PermissionsDto
   * @throws ApiError
   */
  public static permissionsControllerGetUserPermissions(): CancelablePromise<PermissionsControllerGetUserPermissionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/permissions",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static permissionsControllerReload(): CancelablePromise<PermissionsControllerReloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/permissions/reload",
    });
  }

  /**
   * @returns PermissionsDto
   * @throws ApiError
   */
  public static permissionsControllerGetPermissionsTemplate(): CancelablePromise<PermissionsControllerGetPermissionsTemplateResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/permissions/template",
    });
  }
}

export class DashboardPredictionsService {
  /**
   * @param data The data for the request.
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.modelIds
   * @param data.timeField
   * @param data.result
   * @param data.from
   * @param data.to
   * @param data.label
   * @param data.prediction
   * @param data.fuzzy
   * @returns number
   * @throws ApiError
   */
  public static predictionsControllerListPredictionsCount(
    data: PredictionsControllerListPredictionsCountData = {},
  ): CancelablePromise<PredictionsControllerListPredictionsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/predictions/count",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        modelIds: data.modelIds,
        timeField: data.timeField,
        result: data.result,
        from: data.from,
        to: data.to,
        label: data.label,
        prediction: data.prediction,
        fuzzy: data.fuzzy,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.modelIds
   * @param data.sortBy
   * @param data.timeField
   * @param data.result
   * @param data.from
   * @param data.to
   * @param data.label
   * @param data.prediction
   * @param data.fuzzy
   * @returns unknown
   * @throws ApiError
   */
  public static predictionsControllerListPredictions(
    data: PredictionsControllerListPredictionsData,
  ): CancelablePromise<PredictionsControllerListPredictionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/predictions",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        modelIds: data.modelIds,
        sortBy: data.sortBy,
        timeField: data.timeField,
        result: data.result,
        limit: data.limit,
        page: data.page,
        from: data.from,
        to: data.to,
        label: data.label,
        prediction: data.prediction,
        fuzzy: data.fuzzy,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.timeField
   * @param data.result
   * @param data.from
   * @param data.to
   * @param data.label
   * @param data.prediction
   * @param data.fuzzy
   * @returns number
   * @throws ApiError
   */
  public static predictionsControllerListModelPredictionsCount(
    data: PredictionsControllerListModelPredictionsCountData,
  ): CancelablePromise<PredictionsControllerListModelPredictionsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/predictions/model/{id}/count",
      path: {
        id: data.id,
      },
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        timeField: data.timeField,
        result: data.result,
        from: data.from,
        to: data.to,
        label: data.label,
        prediction: data.prediction,
        fuzzy: data.fuzzy,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.sortBy
   * @param data.timeField
   * @param data.result
   * @param data.from
   * @param data.to
   * @param data.label
   * @param data.prediction
   * @param data.fuzzy
   * @returns unknown
   * @throws ApiError
   */
  public static predictionsControllerListModelPredictions(
    data: PredictionsControllerListModelPredictionsData,
  ): CancelablePromise<PredictionsControllerListModelPredictionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/predictions/model/{id}",
      path: {
        id: data.id,
      },
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        sortBy: data.sortBy,
        timeField: data.timeField,
        result: data.result,
        limit: data.limit,
        page: data.page,
        from: data.from,
        to: data.to,
        label: data.label,
        prediction: data.prediction,
        fuzzy: data.fuzzy,
      },
    });
  }
}

export class DashboardQueuesService {
  /**
   * @returns QueuesSummaryDto
   * @throws ApiError
   */
  public static queuesControllerGetSummary(): CancelablePromise<QueuesControllerGetSummaryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/queues/summary",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.queue
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerListQueueFailures(
    data: QueuesControllerListQueueFailuresData,
  ): CancelablePromise<QueuesControllerListQueueFailuresResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/queues/{queue}/failures",
      path: {
        queue: data.queue,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.queue
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static queuesControllerResolveQueueFailures(
    data: QueuesControllerResolveQueueFailuresData,
  ): CancelablePromise<QueuesControllerResolveQueueFailuresResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/queues/{queue}/failures",
      path: {
        queue: data.queue,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.queue
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static queuesControllerDeleteQueueFailures(
    data: QueuesControllerDeleteQueueFailuresData,
  ): CancelablePromise<QueuesControllerDeleteQueueFailuresResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/queues/{queue}/failures",
      path: {
        queue: data.queue,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.index
   * @param data.resolve
   * @param data.override
   * @param data.queue
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerPatchQueueFailure(
    data: QueuesControllerPatchQueueFailureData,
  ): CancelablePromise<QueuesControllerPatchQueueFailureResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/queues/{queue}/failures/{index}",
      path: {
        index: data.index,
        queue: data.queue,
      },
      query: {
        resolve: data.resolve,
        override: data.override,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.index
   * @param data.queue
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerDeleteQueueFailure(
    data: QueuesControllerDeleteQueueFailureData,
  ): CancelablePromise<QueuesControllerDeleteQueueFailureResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/queues/{queue}/failures/{index}",
      path: {
        index: data.index,
        queue: data.queue,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.index
   * @param data.queue
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerResolveQueueFailure(
    data: QueuesControllerResolveQueueFailureData,
  ): CancelablePromise<QueuesControllerResolveQueueFailureResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/queues/{queue}/failures/{index}",
      path: {
        index: data.index,
        queue: data.queue,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.queue
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerListQueuePending(
    data: QueuesControllerListQueuePendingData,
  ): CancelablePromise<QueuesControllerListQueuePendingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/queues/{queue}/pending",
      path: {
        queue: data.queue,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.queue
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerPostQueuePending(
    data: QueuesControllerPostQueuePendingData,
  ): CancelablePromise<QueuesControllerPostQueuePendingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/queues/{queue}/pending",
      path: {
        queue: data.queue,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.index
   * @param data.queue
   * @returns unknown
   * @throws ApiError
   */
  public static queuesControllerDeleteQueuePending(
    data: QueuesControllerDeleteQueuePendingData,
  ): CancelablePromise<QueuesControllerDeleteQueuePendingResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/queues/{queue}/pending/{index}",
      path: {
        index: data.index,
        queue: data.queue,
      },
    });
  }
}

export class DashboardRecoveryEstimatesService {
  /**
   * Manual-run pre-check for the wizard: is the requested week-ending really the end of a reporting
   * week (per the component config's calendar.week_start), and what would the reviews CSV carry;
   * for a month, which of its weeks are already folded. Reads the same config and runs the same
   * collection the run itself does, so it cannot say "fine" where the run would then refuse.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RecoveryEstimatesPreCheckResponseDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerPreCheck(
    data: RecoveryEstimatesControllerPreCheckData,
  ): CancelablePromise<RecoveryEstimatesControllerPreCheckResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/pre-check",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RecoveryEstimatesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerCreateSchedule(
    data: RecoveryEstimatesControllerCreateScheduleData,
  ): CancelablePromise<RecoveryEstimatesControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        RecoveryEstimatesControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static recoveryEstimatesControllerListScheduled(
    data: RecoveryEstimatesControllerListScheduledData,
  ): CancelablePromise<RecoveryEstimatesControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/recovery-estimates/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns RecoveryEstimatesScheduledJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerGetScheduledJob(
    data: RecoveryEstimatesControllerGetScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        RecoveryEstimatesControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns RecoveryEstimatesScheduledJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerUpdateScheduledJob(
    data: RecoveryEstimatesControllerUpdateScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        RecoveryEstimatesControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static recoveryEstimatesControllerDeleteScheduledJob(
    data: RecoveryEstimatesControllerDeleteScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static recoveryEstimatesControllerCancelScheduledJobsBulk(
    data: RecoveryEstimatesControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static recoveryEstimatesControllerStopScheduledJobsBulk(
    data: RecoveryEstimatesControllerStopScheduledJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static recoveryEstimatesControllerResumeScheduledJobsBulk(
    data: RecoveryEstimatesControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static recoveryEstimatesControllerDeleteScheduledJobsBulk(
    data: RecoveryEstimatesControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns RecoveryEstimatesJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerStartScheduledJob(
    data: RecoveryEstimatesControllerStartScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        RecoveryEstimatesControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static recoveryEstimatesControllerCancelScheduledJob(
    data: RecoveryEstimatesControllerCancelScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerStopScheduledJob(
    data: RecoveryEstimatesControllerStopScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns RecoveryEstimatesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerResumeScheduledJob(
    data: RecoveryEstimatesControllerResumeScheduledJobData,
  ): CancelablePromise<RecoveryEstimatesControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        RecoveryEstimatesControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns RecoveryEstimatesJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerStartJob(
    data: RecoveryEstimatesControllerStartJobData,
  ): CancelablePromise<RecoveryEstimatesControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        RecoveryEstimatesControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static recoveryEstimatesControllerListSummaries(
    data: RecoveryEstimatesControllerListSummariesData,
  ): CancelablePromise<RecoveryEstimatesControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/recovery-estimates/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns RecoveryEstimatesJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerGetJob(
    data: RecoveryEstimatesControllerGetJobData,
  ): CancelablePromise<RecoveryEstimatesControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/recovery-estimates/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: RecoveryEstimatesControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static recoveryEstimatesControllerDeleteJob(
    data: RecoveryEstimatesControllerDeleteJobData,
  ): CancelablePromise<RecoveryEstimatesControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/recovery-estimates/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns RecoveryEstimatesJobDto
   * @throws ApiError
   */
  public static recoveryEstimatesControllerUpdateJob(
    data: RecoveryEstimatesControllerUpdateJobData,
  ): CancelablePromise<RecoveryEstimatesControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/recovery-estimates/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        RecoveryEstimatesControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static recoveryEstimatesControllerCancelJob(
    data: RecoveryEstimatesControllerCancelJobData,
  ): CancelablePromise<RecoveryEstimatesControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static recoveryEstimatesControllerStopJob(
    data: RecoveryEstimatesControllerStopJobData,
  ): CancelablePromise<RecoveryEstimatesControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static recoveryEstimatesControllerCancelJobsBulk(
    data: RecoveryEstimatesControllerCancelJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static recoveryEstimatesControllerDeleteJobsBulk(
    data: RecoveryEstimatesControllerDeleteJobsBulkData,
  ): CancelablePromise<RecoveryEstimatesControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/recovery-estimates/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardRegionsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.region Case-insensitive substring match on the region name
   * @param data.subRegion Case-insensitive substring match on the sub-region name
   * @param data.regionIds
   * @param data.subRegionIds
   * @param data.showInactive When true, list INACTIVE rows instead of active ones. Omitted or false = active only.
   * @returns unknown
   * @throws ApiError
   */
  public static regionsControllerListSummaries(
    data: RegionsControllerListSummariesData,
  ): CancelablePromise<RegionsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/regions/summaries",
      query: {
        sortBy: data.sortBy,
        region: data.region,
        subRegion: data.subRegion,
        regionIds: data.regionIds,
        subRegionIds: data.subRegionIds,
        showInactive: data.showInactive,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.name Case-insensitive substring match on the name
   * @returns unknown
   * @throws ApiError
   */
  public static regionsControllerListRegionOptions(
    data: RegionsControllerListRegionOptionsData,
  ): CancelablePromise<RegionsControllerListRegionOptionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/regions/regions",
      query: {
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.name Case-insensitive substring match on the name
   * @param data.regionId Limit to sub-regions of this region
   * @returns unknown
   * @throws ApiError
   */
  public static regionsControllerListSubRegionOptions(
    data: RegionsControllerListSubRegionOptionsData,
  ): CancelablePromise<RegionsControllerListSubRegionOptionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/regions/subRegions",
      query: {
        name: data.name,
        regionId: data.regionId,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CreateRegionResponseDto
   * @throws ApiError
   */
  public static regionsControllerCreate(
    data: RegionsControllerCreateData,
  ): CancelablePromise<RegionsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/regions",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MoveSubRegionsResultDto
   * @throws ApiError
   */
  public static regionsControllerMoveSubRegionsBulk(
    data: RegionsControllerMoveSubRegionsBulkData,
  ): CancelablePromise<RegionsControllerMoveSubRegionsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/regions/subRegions/moveBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns MinimalEntityDto
   * @throws ApiError
   */
  public static regionsControllerUpdateSubRegion(
    data: RegionsControllerUpdateSubRegionData,
  ): CancelablePromise<RegionsControllerUpdateSubRegionResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/regions/subRegions/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns InactivateRowsResultDto
   * @throws ApiError
   */
  public static regionsControllerInactivateBulk(
    data: RegionsControllerInactivateBulkData,
  ): CancelablePromise<RegionsControllerInactivateBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/regions/inactivateBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns MinimalEntityDto
   * @throws ApiError
   */
  public static regionsControllerUpdateRegion(
    data: RegionsControllerUpdateRegionData,
  ): CancelablePromise<RegionsControllerUpdateRegionResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/regions/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns RegionsUploadResponseDto
   * @throws ApiError
   */
  public static regionsControllerUpload(
    data: RegionsControllerUploadData,
  ): CancelablePromise<RegionsControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/regions/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static regionsControllerDownload(
    data: RegionsControllerDownloadData,
  ): CancelablePromise<RegionsControllerDownloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/regions/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardReportsService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static metabaseControllerGetMetabaseUrl(): CancelablePromise<MetabaseControllerGetMetabaseUrlResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports/metabase-url",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static metabaseControllerGeneratePdf(
    data: MetabaseControllerGeneratePdfData,
  ): CancelablePromise<MetabaseControllerGeneratePdfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports/generate-pdf",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.description
   * @returns unknown
   * @throws ApiError
   */
  public static metabaseControllerListReports(
    data: MetabaseControllerListReportsData,
  ): CancelablePromise<MetabaseControllerListReportsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        description: data.description,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static metabaseControllerCreateReport(
    data: MetabaseControllerCreateReportData,
  ): CancelablePromise<MetabaseControllerCreateReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns DetailedReportDto
   * @throws ApiError
   */
  public static metabaseControllerGetReportDetails(
    data: MetabaseControllerGetReportDetailsData,
  ): CancelablePromise<MetabaseControllerGetReportDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        MetabaseControllerGetReportDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static metabaseControllerUpdateReport(
    data: MetabaseControllerUpdateReportData,
  ): CancelablePromise<MetabaseControllerUpdateReportResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/reports/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static metabaseControllerDeleteReport(
    data: MetabaseControllerDeleteReportData,
  ): CancelablePromise<MetabaseControllerDeleteReportResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/reports/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static metabaseControllerUpdateReportConfig(
    data: MetabaseControllerUpdateReportConfigData,
  ): CancelablePromise<MetabaseControllerUpdateReportConfigResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/reports/config/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static metabaseControllerUpdateReportUrl(
    data: MetabaseControllerUpdateReportUrlData,
  ): CancelablePromise<MetabaseControllerUpdateReportUrlResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/reports/url/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailSendOutcomeDto
   * @throws ApiError
   */
  public static metabaseControllerSendTestReport(
    data: MetabaseControllerSendTestReportData,
  ): CancelablePromise<MetabaseControllerSendTestReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports/email",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static metabaseControllerContactUs(
    data: MetabaseControllerContactUsData,
  ): CancelablePromise<MetabaseControllerContactUsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports/contact-us",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.questionTypes
   * @returns DashboardMetadataResponseDto
   * @throws ApiError
   */
  public static metabaseControllerFetchReportMetadata(
    data: MetabaseControllerFetchReportMetadataData,
  ): CancelablePromise<MetabaseControllerFetchReportMetadataResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports/fetch-report-metadata/{id}",
      path: {
        id: data.id,
      },
      query: {
        questionTypes: data.questionTypes,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static metabaseControllerPreviewCustomReport(
    data: MetabaseControllerPreviewCustomReportData,
  ): CancelablePromise<MetabaseControllerPreviewCustomReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports/preview/custom-report",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardReportsCompanionService {
  /**
   * Fast, non-streaming eligibility check for the current account -- the dashboard uses this
   * to gate the /dashboard/reports/companion route at load time (and when the user switches
   * accounts) rather than sending them into a chat that will refuse. Returns the same refusal
   * reason + message that a chat request would surface, so the frontend can render one story.
   * @returns EligibilityResponseDto
   * @throws ApiError
   */
  public static reportsCompanionControllerGetEligibility(): CancelablePromise<ReportsCompanionControllerGetEligibilityResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports-companion/eligibility",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static reportsCompanionControllerChat(
    data: ReportsCompanionControllerChatData,
  ): CancelablePromise<ReportsCompanionControllerChatResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/reports-companion/chat",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * The chat log: one row per chat turn, for research into what users ask and what they get back.
   * Across all accounts for SuperAdmin; pinned to the request's account for anyone else -- see
   * ChatLogService.listChatTurns. `mcp.viewChatLog` is false for every role today.
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.accountIds SuperAdmin only: the accounts to list. Ignored for anyone else, who only ever sees their own account.
   * @param data.outcome
   * @param data.question Case-insensitive substring of the question.
   * @param data.sortBy Sort by multiple fields and directions. Defaults to newest first.
   * @returns unknown
   * @throws ApiError
   */
  public static reportsCompanionControllerListChatTurns(
    data: ReportsCompanionControllerListChatTurnsData,
  ): CancelablePromise<ReportsCompanionControllerListChatTurnsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports-companion/chat-turns",
      query: {
        accountIds: data.accountIds,
        outcome: data.outcome,
        question: data.question,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * Every turn of the conversation the given turn belongs to, oldest first. Scoped like the list.
   * @param data The data for the request.
   * @param data.id
   * @returns ChatTurnResponseDto
   * @throws ApiError
   */
  public static reportsCompanionControllerGetChatConversation(
    data: ReportsCompanionControllerGetChatConversationData,
  ): CancelablePromise<ReportsCompanionControllerGetChatConversationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/reports-companion/chat-turns/{id}/conversation",
      path: {
        id: data.id,
      },
      responseTransformer:
        ReportsCompanionControllerGetChatConversationResponseTransformer,
    });
  }
}

export class DashboardSamplesService {
  /**
   * @param data The data for the request.
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns number
   * @throws ApiError
   */
  public static samplesControllerListSamplesCount(
    data: SamplesControllerListSamplesCountData = {},
  ): CancelablePromise<SamplesControllerListSamplesCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/count",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerGetUxSource(
    data: SamplesControllerGetUxSourceData,
  ): CancelablePromise<SamplesControllerGetUxSourceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/uxSource",
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.sortBy
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerListSamples(
    data: SamplesControllerListSamplesData,
  ): CancelablePromise<SamplesControllerListSamplesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        sortBy: data.sortBy,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        limit: data.limit,
        page: data.page,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static samplesControllerGetQuery(
    data: SamplesControllerGetQueryData,
  ): CancelablePromise<SamplesControllerGetQueryResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/get-query",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.reportType
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.sortBy
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns string
   * @throws ApiError
   */
  public static samplesControllerGenerateShareUrl(
    data: SamplesControllerGenerateShareUrlData,
  ): CancelablePromise<SamplesControllerGenerateShareUrlResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/share",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        sortBy: data.sortBy,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        limit: data.limit,
        page: data.page,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
        reportType: data.reportType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.account
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.sortBy
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerSharedListSamples(
    data: SamplesControllerSharedListSamplesData,
  ): CancelablePromise<SamplesControllerSharedListSamplesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/shared",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        sortBy: data.sortBy,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        limit: data.limit,
        page: data.page,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
        account: data.account,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.groupId
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateGroupLoss(
    data: SamplesControllerUpdateGroupLossData,
  ): CancelablePromise<SamplesControllerUpdateGroupLossResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/group/{groupId}/loss",
      path: {
        groupId: data.groupId,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerRefreshLossBulk(
    data: SamplesControllerRefreshLossBulkData = {},
  ): CancelablePromise<SamplesControllerRefreshLossBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/refresh-loss-bulk",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerRefreshLoss(
    data: SamplesControllerRefreshLossData,
  ): CancelablePromise<SamplesControllerRefreshLossResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/refresh-loss",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerSetRepresentativeImageBulk(
    data: SamplesControllerSetRepresentativeImageBulkData = {},
  ): CancelablePromise<SamplesControllerSetRepresentativeImageBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/setRepresentativeImageBulk",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns SampleWithImageDto
   * @throws ApiError
   */
  public static samplesControllerGetSampleDetailsAndImage(
    data: SamplesControllerGetSampleDetailsAndImageData,
  ): CancelablePromise<SamplesControllerGetSampleDetailsAndImageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/{uuid}",
      path: {
        uuid: data.uuid,
      },
      responseTransformer:
        SamplesControllerGetSampleDetailsAndImageResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateSample(
    data: SamplesControllerUpdateSampleData,
  ): CancelablePromise<SamplesControllerUpdateSampleResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/{uuid}",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerDeleteSample(
    data: SamplesControllerDeleteSampleData,
  ): CancelablePromise<SamplesControllerDeleteSampleResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/samples/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns SampleDto
   * @throws ApiError
   */
  public static samplesControllerGetSampleDetails(
    data: SamplesControllerGetSampleDetailsData,
  ): CancelablePromise<SamplesControllerGetSampleDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/{uuid}/details",
      path: {
        uuid: data.uuid,
      },
      responseTransformer: SamplesControllerGetSampleDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateBulk(
    data: SamplesControllerUpdateBulkData,
  ): CancelablePromise<SamplesControllerUpdateBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerDeleteBulk(
    data: SamplesControllerDeleteBulkData = {},
  ): CancelablePromise<SamplesControllerDeleteBulkResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/samples/bulk",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateSamplesMetadataBulk(
    data: SamplesControllerUpdateSamplesMetadataBulkData,
  ): CancelablePromise<SamplesControllerUpdateSamplesMetadataBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/updateMetaBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateTagsBulk(
    data: SamplesControllerUpdateTagsBulkData,
  ): CancelablePromise<SamplesControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateSampleMetadata(
    data: SamplesControllerUpdateSampleMetadataData,
  ): CancelablePromise<SamplesControllerUpdateSampleMetadataResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/{uuid}/meta",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUpdateLoss(
    data: SamplesControllerUpdateLossData,
  ): CancelablePromise<SamplesControllerUpdateLossResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/samples/{uuid}/loss",
      path: {
        uuid: data.uuid,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.sampleId
   * @param data.sampleIds
   * @param data.deviceIds
   * @param data.storageDeviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.siteGroupIds
   * @param data.region Legacy: a region NAME, resolved through the regions table (case-insensitive). Use regionId. Kept so shared links minted before ID-6524 keep working; ID-7059 removes it.
   * @param data.regionId Filter samples to sites assigned to this region (active regions only).
   * @param data.subRegionId Filter samples to sites assigned to this sub-region (active, under an active region).
   * @param data.uxSource UX source filter (case-insensitive exact match)
   * @param data.deviceIp Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   * @param data.timeField
   * @param data.state
   * @param data.modelIds
   * @param data.result
   * @param data.labels
   * @param data.predictions
   * @param data.families
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.taggedByIds
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.dataType
   * @param data.datasetId
   * @param data.deleteAfterUpload delete the sample off the device once uploaded to storage
   * @param data.fromDate
   * @param data.toDate
   * @param data.onlyWithPrediction
   * @param data.showNonScans
   * @param data.headBlurred
   * @param data.headsFound
   * @param data.family
   * @param data.fuzzy
   * @param data.matchStrength
   * @param data.sessionId
   * @param data.showOnlyWithImages
   * @returns UploadOperationCreatedDto
   * @throws ApiError
   */
  public static samplesControllerUploadBulk(
    data: SamplesControllerUploadBulkData = {},
  ): CancelablePromise<SamplesControllerUploadBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/uploadBulk",
      query: {
        sampleId: data.sampleId,
        sampleIds: data.sampleIds,
        deviceIds: data.deviceIds,
        storageDeviceIds: data.storageDeviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        siteGroupIds: data.siteGroupIds,
        region: data.region,
        regionId: data.regionId,
        subRegionId: data.subRegionId,
        uxSource: data.uxSource,
        deviceIp: data.deviceIp,
        timeField: data.timeField,
        state: data.state,
        modelIds: data.modelIds,
        result: data.result,
        labels: data.labels,
        predictions: data.predictions,
        families: data.families,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        taggedByIds: data.taggedByIds,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        dataType: data.dataType,
        datasetId: data.datasetId,
        deleteAfterUpload: data.deleteAfterUpload,
        fromDate: data.fromDate,
        toDate: data.toDate,
        onlyWithPrediction: data.onlyWithPrediction,
        showNonScans: data.showNonScans,
        headBlurred: data.headBlurred,
        headsFound: data.headsFound,
        family: data.family,
        fuzzy: data.fuzzy,
        matchStrength: data.matchStrength,
        sessionId: data.sessionId,
        showOnlyWithImages: data.showOnlyWithImages,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.deleteAfterUpload
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerUploadSample(
    data: SamplesControllerUploadSampleData,
  ): CancelablePromise<SamplesControllerUploadSampleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/samples/{uuid}/upload",
      path: {
        uuid: data.uuid,
      },
      query: {
        deleteAfterUpload: data.deleteAfterUpload,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.redirect Answer a cloud-stored sample with a 302 to storage instead of its bytes. Omitted falls back to the SAMPLE_IMAGE_REDIRECT config default.
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerGetSampleImage(
    data: SamplesControllerGetSampleImageData,
  ): CancelablePromise<SamplesControllerGetSampleImageResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/{uuid}/image",
      path: {
        uuid: data.uuid,
      },
      query: {
        redirect: data.redirect,
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.width
   * @param data.height
   * @param data.expand
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerGetSampleThumbnail(
    data: SamplesControllerGetSampleThumbnailData,
  ): CancelablePromise<SamplesControllerGetSampleThumbnailResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/{uuid}/thumbnail",
      path: {
        uuid: data.uuid,
      },
      query: {
        width: data.width,
        height: data.height,
        expand: data.expand,
        raw: data.raw,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.deviceId
   * @param data.raw
   * @returns unknown
   * @throws ApiError
   */
  public static samplesControllerGetSampleImageInDevice(
    data: SamplesControllerGetSampleImageInDeviceData,
  ): CancelablePromise<SamplesControllerGetSampleImageInDeviceResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/samples/{uuid}/image-in-device",
      path: {
        uuid: data.uuid,
      },
      query: {
        deviceId: data.deviceId,
        raw: data.raw,
      },
    });
  }
}

export class DashboardScheduleConfigDeploymentsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ScheduleConfigDeploymentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerCreateSchedule(
    data: ScheduleConfigDeploymentsControllerCreateScheduleData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleConfigDeploymentsControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerListScheduled(
    data: ScheduleConfigDeploymentsControllerListScheduledData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleConfigDeploymentsScheduledJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerGetScheduledJob(
    data: ScheduleConfigDeploymentsControllerGetScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleConfigDeploymentsControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns ScheduleConfigDeploymentsScheduledJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerUpdateScheduledJob(
    data: ScheduleConfigDeploymentsControllerUpdateScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleConfigDeploymentsControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerDeleteScheduledJob(
    data: ScheduleConfigDeploymentsControllerDeleteScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerCancelScheduledJobsBulk(
    data: ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerStopScheduledJobsBulk(
    data: ScheduleConfigDeploymentsControllerStopScheduledJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerResumeScheduledJobsBulk(
    data: ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerDeleteScheduledJobsBulk(
    data: ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleConfigDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerStartScheduledJob(
    data: ScheduleConfigDeploymentsControllerStartScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleConfigDeploymentsControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerCancelScheduledJob(
    data: ScheduleConfigDeploymentsControllerCancelScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerStopScheduledJob(
    data: ScheduleConfigDeploymentsControllerStopScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleConfigDeploymentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerResumeScheduledJob(
    data: ScheduleConfigDeploymentsControllerResumeScheduledJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleConfigDeploymentsControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ScheduleConfigDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerStartJob(
    data: ScheduleConfigDeploymentsControllerStartJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleConfigDeploymentsControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerListSummaries(
    data: ScheduleConfigDeploymentsControllerListSummariesData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleConfigDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerGetJob(
    data: ScheduleConfigDeploymentsControllerGetJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleConfigDeploymentsControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerDeleteJob(
    data: ScheduleConfigDeploymentsControllerDeleteJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns ScheduleConfigDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerUpdateJob(
    data: ScheduleConfigDeploymentsControllerUpdateJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleConfigDeploymentsControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerCancelJob(
    data: ScheduleConfigDeploymentsControllerCancelJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerStopJob(
    data: ScheduleConfigDeploymentsControllerStopJobData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerCancelJobsBulk(
    data: ScheduleConfigDeploymentsControllerCancelJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static scheduleConfigDeploymentsControllerDeleteJobsBulk(
    data: ScheduleConfigDeploymentsControllerDeleteJobsBulkData,
  ): CancelablePromise<ScheduleConfigDeploymentsControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-config-deployments/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardScheduledTrainingsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static scheduledTrainingsControllerListSummaries(
    data: ScheduledTrainingsControllerListSummariesData,
  ): CancelablePromise<ScheduledTrainingsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/summaries",
      query: {
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduledTrainingDetailsDto
   * @throws ApiError
   */
  public static scheduledTrainingsControllerGetDetails(
    data: ScheduledTrainingsControllerGetDetailsData,
  ): CancelablePromise<ScheduledTrainingsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduledTrainingsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static scheduledTrainingsControllerUpdate(
    data: ScheduledTrainingsControllerUpdateData,
  ): CancelablePromise<ScheduledTrainingsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static scheduledTrainingsControllerDelete(
    data: ScheduledTrainingsControllerDeleteData,
  ): CancelablePromise<ScheduledTrainingsControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static scheduledTrainingsControllerCreateScheduledTraining(
    data: ScheduledTrainingsControllerCreateScheduledTrainingData,
  ): CancelablePromise<ScheduledTrainingsControllerCreateScheduledTrainingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled trainings deleted
   * @throws ApiError
   */
  public static scheduledTrainingsControllerDeleteBulk(
    data: ScheduledTrainingsControllerDeleteBulkData,
  ): CancelablePromise<ScheduledTrainingsControllerDeleteBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static scheduledTrainingsControllerStart(
    data: ScheduledTrainingsControllerStartData,
  ): CancelablePromise<ScheduledTrainingsControllerStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/scheduled-trainings/scheduled-trainings/{id}/start",
      path: {
        id: data.id,
      },
    });
  }
}

export class DashboardScheduleModelDeploymentsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ScheduleModelDeploymentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerCreateSchedule(
    data: ScheduleModelDeploymentsControllerCreateScheduleData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleModelDeploymentsControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerListScheduled(
    data: ScheduleModelDeploymentsControllerListScheduledData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleModelDeploymentsScheduledJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerGetScheduledJob(
    data: ScheduleModelDeploymentsControllerGetScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleModelDeploymentsControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns ScheduleModelDeploymentsScheduledJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerUpdateScheduledJob(
    data: ScheduleModelDeploymentsControllerUpdateScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleModelDeploymentsControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerDeleteScheduledJob(
    data: ScheduleModelDeploymentsControllerDeleteScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerCancelScheduledJobsBulk(
    data: ScheduleModelDeploymentsControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerStopScheduledJobsBulk(
    data: ScheduleModelDeploymentsControllerStopScheduledJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerResumeScheduledJobsBulk(
    data: ScheduleModelDeploymentsControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerDeleteScheduledJobsBulk(
    data: ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleModelDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerStartScheduledJob(
    data: ScheduleModelDeploymentsControllerStartScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleModelDeploymentsControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerCancelScheduledJob(
    data: ScheduleModelDeploymentsControllerCancelScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerStopScheduledJob(
    data: ScheduleModelDeploymentsControllerStopScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleModelDeploymentsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerResumeScheduledJob(
    data: ScheduleModelDeploymentsControllerResumeScheduledJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleModelDeploymentsControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ScheduleModelDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerStartJob(
    data: ScheduleModelDeploymentsControllerStartJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleModelDeploymentsControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerListSummaries(
    data: ScheduleModelDeploymentsControllerListSummariesData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ScheduleModelDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerGetJob(
    data: ScheduleModelDeploymentsControllerGetJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ScheduleModelDeploymentsControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerDeleteJob(
    data: ScheduleModelDeploymentsControllerDeleteJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns ScheduleModelDeploymentsJobDto
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerUpdateJob(
    data: ScheduleModelDeploymentsControllerUpdateJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ScheduleModelDeploymentsControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerCancelJob(
    data: ScheduleModelDeploymentsControllerCancelJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerStopJob(
    data: ScheduleModelDeploymentsControllerStopJobData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerCancelJobsBulk(
    data: ScheduleModelDeploymentsControllerCancelJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static scheduleModelDeploymentsControllerDeleteJobsBulk(
    data: ScheduleModelDeploymentsControllerDeleteJobsBulkData,
  ): CancelablePromise<ScheduleModelDeploymentsControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/schedule-model-deployments/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardServiceHealthChecksService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ServiceHealthCheckTestResultDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerTest(
    data: ServiceHealthChecksControllerTestData,
  ): CancelablePromise<ServiceHealthChecksControllerTestResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/test",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ServiceHealthChecksScheduledJobSummaryDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerCreateSchedule(
    data: ServiceHealthChecksControllerCreateScheduleData,
  ): CancelablePromise<ServiceHealthChecksControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ServiceHealthChecksControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static serviceHealthChecksControllerListScheduled(
    data: ServiceHealthChecksControllerListScheduledData,
  ): CancelablePromise<ServiceHealthChecksControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/service-health-checks/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ServiceHealthChecksScheduledJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerGetScheduledJob(
    data: ServiceHealthChecksControllerGetScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ServiceHealthChecksControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns ServiceHealthChecksScheduledJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerUpdateScheduledJob(
    data: ServiceHealthChecksControllerUpdateScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ServiceHealthChecksControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static serviceHealthChecksControllerDeleteScheduledJob(
    data: ServiceHealthChecksControllerDeleteScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static serviceHealthChecksControllerCancelScheduledJobsBulk(
    data: ServiceHealthChecksControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static serviceHealthChecksControllerStopScheduledJobsBulk(
    data: ServiceHealthChecksControllerStopScheduledJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static serviceHealthChecksControllerResumeScheduledJobsBulk(
    data: ServiceHealthChecksControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static serviceHealthChecksControllerDeleteScheduledJobsBulk(
    data: ServiceHealthChecksControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ServiceHealthChecksJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerStartScheduledJob(
    data: ServiceHealthChecksControllerStartScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        ServiceHealthChecksControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static serviceHealthChecksControllerCancelScheduledJob(
    data: ServiceHealthChecksControllerCancelScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerStopScheduledJob(
    data: ServiceHealthChecksControllerStopScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ServiceHealthChecksScheduledJobSummaryDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerResumeScheduledJob(
    data: ServiceHealthChecksControllerResumeScheduledJobData,
  ): CancelablePromise<ServiceHealthChecksControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        ServiceHealthChecksControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ServiceHealthChecksJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerStartJob(
    data: ServiceHealthChecksControllerStartJobData,
  ): CancelablePromise<ServiceHealthChecksControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ServiceHealthChecksControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static serviceHealthChecksControllerListSummaries(
    data: ServiceHealthChecksControllerListSummariesData,
  ): CancelablePromise<ServiceHealthChecksControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/service-health-checks/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns ServiceHealthChecksJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerGetJob(
    data: ServiceHealthChecksControllerGetJobData,
  ): CancelablePromise<ServiceHealthChecksControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/service-health-checks/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        ServiceHealthChecksControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static serviceHealthChecksControllerDeleteJob(
    data: ServiceHealthChecksControllerDeleteJobData,
  ): CancelablePromise<ServiceHealthChecksControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/service-health-checks/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns ServiceHealthChecksJobDto
   * @throws ApiError
   */
  public static serviceHealthChecksControllerUpdateJob(
    data: ServiceHealthChecksControllerUpdateJobData,
  ): CancelablePromise<ServiceHealthChecksControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/service-health-checks/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        ServiceHealthChecksControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static serviceHealthChecksControllerCancelJob(
    data: ServiceHealthChecksControllerCancelJobData,
  ): CancelablePromise<ServiceHealthChecksControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static serviceHealthChecksControllerStopJob(
    data: ServiceHealthChecksControllerStopJobData,
  ): CancelablePromise<ServiceHealthChecksControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static serviceHealthChecksControllerCancelJobsBulk(
    data: ServiceHealthChecksControllerCancelJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static serviceHealthChecksControllerDeleteJobsBulk(
    data: ServiceHealthChecksControllerDeleteJobsBulkData,
  ): CancelablePromise<ServiceHealthChecksControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/service-health-checks/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardSessionsService {
  /**
   * @param data The data for the request.
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.storageDeviceIds
   * @param data.storage
   * @param data.timeField
   * @param data.sessionIds
   * @param data.tagsMatch
   * @param data.tagIds
   * @param data.sessionTagIds
   * @param data.sessionsTagsMatch
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.assigneeIds
   * @param data.assigneeMatch
   * @param data.alertType
   * @param data.labels
   * @param data.datasetId
   * @param data.from
   * @param data.to
   * @param data.sessionId
   * @param data.onlyNonScans
   * @param data.onlyStored
   * @param data.headBlurred
   * @param data.assistantId
   * @param data.shopperId
   * @returns number
   * @throws ApiError
   */
  public static sessionsControllerListSessionsCount(
    data: SessionsControllerListSessionsCountData = {},
  ): CancelablePromise<SessionsControllerListSessionsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/count",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        storageDeviceIds: data.storageDeviceIds,
        storage: data.storage,
        timeField: data.timeField,
        sessionIds: data.sessionIds,
        tagsMatch: data.tagsMatch,
        tagIds: data.tagIds,
        sessionTagIds: data.sessionTagIds,
        sessionsTagsMatch: data.sessionsTagsMatch,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        assigneeIds: data.assigneeIds,
        assigneeMatch: data.assigneeMatch,
        alertType: data.alertType,
        labels: data.labels,
        datasetId: data.datasetId,
        from: data.from,
        to: data.to,
        sessionId: data.sessionId,
        onlyNonScans: data.onlyNonScans,
        onlyStored: data.onlyStored,
        headBlurred: data.headBlurred,
        assistantId: data.assistantId,
        shopperId: data.shopperId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.siteIds
   * @param data.storageDeviceIds
   * @param data.storage
   * @param data.sortBy
   * @param data.timeField
   * @param data.sessionIds
   * @param data.tagsMatch
   * @param data.tagIds
   * @param data.sessionTagIds
   * @param data.sessionsTagsMatch
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.from
   * @param data.to
   * @param data.sessionId
   * @param data.onlyNonScans
   * @param data.onlyStored
   * @param data.headBlurred
   * @param data.assistantId
   * @param data.shopperId
   * @returns ListSessionsAlertsResponseDto
   * @throws ApiError
   */
  public static sessionsControllerListSessionsAlerts(
    data: SessionsControllerListSessionsAlertsData,
  ): CancelablePromise<SessionsControllerListSessionsAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/sessions-alerts",
      query: {
        deviceIds: data.deviceIds,
        siteIds: data.siteIds,
        storageDeviceIds: data.storageDeviceIds,
        storage: data.storage,
        sortBy: data.sortBy,
        timeField: data.timeField,
        sessionIds: data.sessionIds,
        tagsMatch: data.tagsMatch,
        tagIds: data.tagIds,
        sessionTagIds: data.sessionTagIds,
        sessionsTagsMatch: data.sessionsTagsMatch,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        limit: data.limit,
        page: data.page,
        from: data.from,
        to: data.to,
        sessionId: data.sessionId,
        onlyNonScans: data.onlyNonScans,
        onlyStored: data.onlyStored,
        headBlurred: data.headBlurred,
        assistantId: data.assistantId,
        shopperId: data.shopperId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.storageDeviceIds
   * @param data.storage
   * @param data.timeField
   * @param data.sessionIds
   * @param data.tagsMatch
   * @param data.tagIds
   * @param data.sessionTagIds
   * @param data.sessionsTagsMatch
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.assigneeIds
   * @param data.assigneeMatch
   * @param data.alertType
   * @param data.labels
   * @param data.datasetId
   * @param data.from
   * @param data.to
   * @param data.sessionId
   * @param data.onlyNonScans
   * @param data.onlyStored
   * @param data.headBlurred
   * @param data.assistantId
   * @param data.shopperId
   * @returns SessionDto
   * @throws ApiError
   */
  public static sessionsControllerGetSession(
    data: SessionsControllerGetSessionData,
  ): CancelablePromise<SessionsControllerGetSessionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/{uuid}",
      path: {
        uuid: data.uuid,
      },
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        storageDeviceIds: data.storageDeviceIds,
        storage: data.storage,
        timeField: data.timeField,
        sessionIds: data.sessionIds,
        tagsMatch: data.tagsMatch,
        tagIds: data.tagIds,
        sessionTagIds: data.sessionTagIds,
        sessionsTagsMatch: data.sessionsTagsMatch,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        assigneeIds: data.assigneeIds,
        assigneeMatch: data.assigneeMatch,
        alertType: data.alertType,
        labels: data.labels,
        datasetId: data.datasetId,
        from: data.from,
        to: data.to,
        sessionId: data.sessionId,
        onlyNonScans: data.onlyNonScans,
        onlyStored: data.onlyStored,
        headBlurred: data.headBlurred,
        assistantId: data.assistantId,
        shopperId: data.shopperId,
      },
      responseTransformer: SessionsControllerGetSessionResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.storageDeviceIds
   * @param data.storage
   * @param data.sortBy
   * @param data.timeField
   * @param data.sessionIds
   * @param data.tagsMatch
   * @param data.tagIds
   * @param data.sessionTagIds
   * @param data.sessionsTagsMatch
   * @param data.devicesTagIds
   * @param data.devicesTagsMatch
   * @param data.assigneeIds
   * @param data.assigneeMatch
   * @param data.alertType
   * @param data.labels
   * @param data.datasetId
   * @param data.from
   * @param data.to
   * @param data.sessionId
   * @param data.onlyNonScans
   * @param data.onlyStored
   * @param data.headBlurred
   * @param data.assistantId
   * @param data.shopperId
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsControllerListSessions(
    data: SessionsControllerListSessionsData,
  ): CancelablePromise<SessionsControllerListSessionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        storageDeviceIds: data.storageDeviceIds,
        storage: data.storage,
        sortBy: data.sortBy,
        timeField: data.timeField,
        sessionIds: data.sessionIds,
        tagsMatch: data.tagsMatch,
        tagIds: data.tagIds,
        sessionTagIds: data.sessionTagIds,
        sessionsTagsMatch: data.sessionsTagsMatch,
        devicesTagIds: data.devicesTagIds,
        devicesTagsMatch: data.devicesTagsMatch,
        assigneeIds: data.assigneeIds,
        assigneeMatch: data.assigneeMatch,
        alertType: data.alertType,
        labels: data.labels,
        datasetId: data.datasetId,
        limit: data.limit,
        page: data.page,
        from: data.from,
        to: data.to,
        sessionId: data.sessionId,
        onlyNonScans: data.onlyNonScans,
        onlyStored: data.onlyStored,
        headBlurred: data.headBlurred,
        assistantId: data.assistantId,
        shopperId: data.shopperId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static sessionsControllerDownloadSessionVideo(
    data: SessionsControllerDownloadSessionVideoData,
  ): CancelablePromise<SessionsControllerDownloadSessionVideoResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/{uuid}/video",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static sessionsControllerDownloadSessionVisualization(
    data: SessionsControllerDownloadSessionVisualizationData,
  ): CancelablePromise<SessionsControllerDownloadSessionVisualizationResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/{uuid}/visualization",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @param data.range
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static sessionsControllerStreamSession(
    data: SessionsControllerStreamSessionData,
  ): CancelablePromise<SessionsControllerStreamSessionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/{uuid}/stream",
      path: {
        uuid: data.uuid,
      },
      headers: {
        Range: data.range,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsControllerUpdateTagsBulk(
    data: SessionsControllerUpdateTagsBulkData,
  ): CancelablePromise<SessionsControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sessions/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsControllerUpdateAssigneeBulk(
    data: SessionsControllerUpdateAssigneeBulkData,
  ): CancelablePromise<SessionsControllerUpdateAssigneeBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sessions/assigneeBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardSessionsTaggingService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsTaggingControllerListTags(
    data: SessionsTaggingControllerListTagsData,
  ): CancelablePromise<SessionsTaggingControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/sessions-tagging/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsTaggingControllerCreateTags(
    data: SessionsTaggingControllerCreateTagsData,
  ): CancelablePromise<SessionsTaggingControllerCreateTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sessions/sessions-tagging/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignTagsResponseDto
   * @throws ApiError
   */
  public static sessionsTaggingControllerAssignTags(
    data: SessionsTaggingControllerAssignTagsData,
  ): CancelablePromise<SessionsTaggingControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sessions/sessions-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignTagsResponseDto
   * @throws ApiError
   */
  public static sessionsTaggingControllerUnassignTags(
    data: SessionsTaggingControllerUnassignTagsData,
  ): CancelablePromise<SessionsTaggingControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sessions/sessions-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static sessionsTaggingControllerGetDetails(
    data: SessionsTaggingControllerGetDetailsData,
  ): CancelablePromise<SessionsTaggingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/sessions-tagging/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        SessionsTaggingControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static sessionsTaggingControllerUpdateTag(
    data: SessionsTaggingControllerUpdateTagData,
  ): CancelablePromise<SessionsTaggingControllerUpdateTagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sessions/sessions-tagging/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        SessionsTaggingControllerUpdateTagResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsTaggingControllerDeleteTag(
    data: SessionsTaggingControllerDeleteTagData,
  ): CancelablePromise<SessionsTaggingControllerDeleteTagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sessions/sessions-tagging/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsTaggingControllerMergeTagTo(
    data: SessionsTaggingControllerMergeTagToData,
  ): CancelablePromise<SessionsTaggingControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sessions/sessions-tagging/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static sessionsTaggingControllerListSummaries(
    data: SessionsTaggingControllerListSummariesData,
  ): CancelablePromise<SessionsTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sessions/sessions-tagging/summaries",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class DashboardSiteGroupsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerUpsertOperationalHoursBulk(
    data: SiteGroupsControllerUpsertOperationalHoursBulkData,
  ): CancelablePromise<SiteGroupsControllerUpsertOperationalHoursBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/site-groups/operational-hoursBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.siteGroupIds
   * @param data.name
   * @param data.sortBy
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerListSummaries(
    data: SiteGroupsControllerListSummariesData,
  ): CancelablePromise<SiteGroupsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/site-groups/summaries",
      query: {
        siteGroupIds: data.siteGroupIds,
        name: data.name,
        sortBy: data.sortBy,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SiteGroupDetailsDto
   * @throws ApiError
   */
  public static siteGroupsControllerDetails(
    data: SiteGroupsControllerDetailsData,
  ): CancelablePromise<SiteGroupsControllerDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/site-groups/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: SiteGroupsControllerDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerUpdate(
    data: SiteGroupsControllerUpdateData,
  ): CancelablePromise<SiteGroupsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/site-groups/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerDelete(
    data: SiteGroupsControllerDeleteData,
  ): CancelablePromise<SiteGroupsControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/site-groups/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerCreate(
    data: SiteGroupsControllerCreateData,
  ): CancelablePromise<SiteGroupsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/site-groups",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns OperationalHoursResponseDto
   * @throws ApiError
   */
  public static siteGroupsControllerUpsertOperationalHours(
    data: SiteGroupsControllerUpsertOperationalHoursData,
  ): CancelablePromise<SiteGroupsControllerUpsertOperationalHoursResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/site-groups/{id}/operational-hours",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static siteGroupsControllerAddSites(
    data: SiteGroupsControllerAddSitesData,
  ): CancelablePromise<SiteGroupsControllerAddSitesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/site-groups/{id}/sites/add",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static siteGroupsControllerRemoveSites(
    data: SiteGroupsControllerRemoveSitesData,
  ): CancelablePromise<SiteGroupsControllerRemoveSitesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/site-groups/{id}/sites/remove",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.page
   * @param data.limit
   * @param data.search
   * @returns SiteGroupLabelsResponseDto
   * @throws ApiError
   */
  public static siteGroupsControllerGetLabels(
    data: SiteGroupsControllerGetLabelsData,
  ): CancelablePromise<SiteGroupsControllerGetLabelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/site-groups/{id}/labels",
      path: {
        id: data.id,
      },
      query: {
        page: data.page,
        limit: data.limit,
        search: data.search,
      },
      responseTransformer: SiteGroupsControllerGetLabelsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerDownloadLabels(
    data: SiteGroupsControllerDownloadLabelsData,
  ): CancelablePromise<SiteGroupsControllerDownloadLabelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/site-groups/{id}/labels/download",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static siteGroupsControllerBulkUpdateLabels(
    data: SiteGroupsControllerBulkUpdateLabelsData,
  ): CancelablePromise<SiteGroupsControllerBulkUpdateLabelsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/site-groups/{id}/labels/bulk",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.labelInGroup
   * @param data.excludeCatalogItemId
   * @returns CheckDuplicateLabelResponseDto
   * @throws ApiError
   */
  public static siteGroupsControllerCheckDuplicateLabel(
    data: SiteGroupsControllerCheckDuplicateLabelData,
  ): CancelablePromise<SiteGroupsControllerCheckDuplicateLabelResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/site-groups/{id}/labels/check-duplicate",
      path: {
        id: data.id,
      },
      query: {
        labelInGroup: data.labelInGroup,
        excludeCatalogItemId: data.excludeCatalogItemId,
      },
    });
  }
}

export class DashboardSitesService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static sitesControllerDownload(
    data: SitesControllerDownloadData,
  ): CancelablePromise<SitesControllerDownloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static sitesControllerCreate(
    data: SitesControllerCreateData,
  ): CancelablePromise<SitesControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.siteIds
   * @param data.sortBy Sorting by one or more fields, each with an optional direction.
   * @param data.groupId
   * @param data.excludeGroupIds
   * @param data.tagIds
   * @param data.tagsMatch
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerListSummaries(
    data: SitesControllerListSummariesData,
  ): CancelablePromise<SitesControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/summaries",
      query: {
        siteIds: data.siteIds,
        sortBy: data.sortBy,
        groupId: data.groupId,
        excludeGroupIds: data.excludeGroupIds,
        tagIds: data.tagIds,
        tagsMatch: data.tagsMatch,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.groupId
   * @param data.accountId
   * @param data.name
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerListMinimal(
    data: SitesControllerListMinimalData,
  ): CancelablePromise<SitesControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/minimal",
      query: {
        groupId: data.groupId,
        accountId: data.accountId,
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.name Case-insensitive substring match on the name
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerGetRegions(
    data: SitesControllerGetRegionsData,
  ): CancelablePromise<SitesControllerGetRegionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/regions",
      query: {
        name: data.name,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static sitesControllerUpdateRegions(
    data: SitesControllerUpdateRegionsData,
  ): CancelablePromise<SitesControllerUpdateRegionsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/regions",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.name Case-insensitive substring match on the name
   * @param data.regionId Limit to sub-regions of this region
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerGetSubRegions(
    data: SitesControllerGetSubRegionsData,
  ): CancelablePromise<SitesControllerGetSubRegionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/subRegions",
      query: {
        name: data.name,
        regionId: data.regionId,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerUpdateTagsBulk(
    data: SitesControllerUpdateTagsBulkData,
  ): CancelablePromise<SitesControllerUpdateTagsBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/tagsBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerDeployModelBulk(
    data: SitesControllerDeployModelBulkData,
  ): CancelablePromise<SitesControllerDeployModelBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/modelBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static sitesControllerUpdateActivationTime(
    data: SitesControllerUpdateActivationTimeData,
  ): CancelablePromise<SitesControllerUpdateActivationTimeResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/activation-time",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static sitesControllerUpdateSiteGroupBulk(
    data: SitesControllerUpdateSiteGroupBulkData,
  ): CancelablePromise<SitesControllerUpdateSiteGroupBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/site-groupBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerDeployServiceVersionBulk(
    data: SitesControllerDeployServiceVersionBulkData,
  ): CancelablePromise<SitesControllerDeployServiceVersionBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/deployServiceVersionBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerDeployConfigBulk(
    data: SitesControllerDeployConfigBulkData,
  ): CancelablePromise<SitesControllerDeployConfigBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/deployConfigBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerUpsertOperationalHoursBulk(
    data: SitesControllerUpsertOperationalHoursBulkData,
  ): CancelablePromise<SitesControllerUpsertOperationalHoursBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/operational-hoursBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.componentName The component name
   * @param data.limit
   * @param data.page
   * @param data.version
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerListAvailableComponentVersions(
    data: SitesControllerListAvailableComponentVersionsData,
  ): CancelablePromise<SitesControllerListAvailableComponentVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/available-component-versions/{componentName}",
      path: {
        componentName: data.componentName,
      },
      query: {
        version: data.version,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns SiteUploadResponseDto
   * @throws ApiError
   */
  public static sitesControllerUpload(
    data: SitesControllerUploadData,
  ): CancelablePromise<SitesControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
      responseTransformer: SitesControllerUploadResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SiteDetailsDto
   * @throws ApiError
   */
  public static sitesControllerGetDetails(
    data: SitesControllerGetDetailsData,
  ): CancelablePromise<SitesControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: SitesControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerUpdate(
    data: SitesControllerUpdateData,
  ): CancelablePromise<SitesControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerDeployVersion(
    data: SitesControllerDeployVersionData,
  ): CancelablePromise<SitesControllerDeployVersionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/{id}/deploy-agent-version",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerGetVersionHistory(
    data: SitesControllerGetVersionHistoryData,
  ): CancelablePromise<SitesControllerGetVersionHistoryResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/{id}/agent-deployments",
      path: {
        id: data.id,
      },
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerDeployService(
    data: SitesControllerDeployServiceData,
  ): CancelablePromise<SitesControllerDeployServiceResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/{id}/deploy-service-version",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.limit
   * @param data.page
   * @param data.serviceName
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerGetServiceDeployments(
    data: SitesControllerGetServiceDeploymentsData,
  ): CancelablePromise<SitesControllerGetServiceDeploymentsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/{id}/service-deployments",
      path: {
        id: data.id,
      },
      query: {
        serviceName: data.serviceName,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.serviceName The service name
   * @param data.limit
   * @param data.page
   * @param data.version
   * @returns unknown
   * @throws ApiError
   */
  public static sitesControllerGetAvailableServiceVersions(
    data: SitesControllerGetAvailableServiceVersionsData,
  ): CancelablePromise<SitesControllerGetAvailableServiceVersionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/{id}/available-service-versions/{serviceName}",
      path: {
        id: data.id,
        serviceName: data.serviceName,
      },
      query: {
        version: data.version,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns string
   * @throws ApiError
   */
  public static sitesControllerGetLatestSiteDeviceDeployment(
    data: SitesControllerGetLatestSiteDeviceDeploymentData,
  ): CancelablePromise<SitesControllerGetLatestSiteDeviceDeploymentResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/{id}/latest-site-device-deployment",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static sitesControllerAddDevices(
    data: SitesControllerAddDevicesData,
  ): CancelablePromise<SitesControllerAddDevicesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/{id}/devices/add",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static sitesControllerRemoveDevices(
    data: SitesControllerRemoveDevicesData,
  ): CancelablePromise<SitesControllerRemoveDevicesResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/{id}/devices/remove",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns PartialDevice
   * @throws ApiError
   */
  public static sitesControllerDelete(
    data: SitesControllerDeleteData,
  ): CancelablePromise<SitesControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sites/{id}/deviceID",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns OperationalHoursResponseDto
   * @throws ApiError
   */
  public static sitesControllerUpsertOperationalHours(
    data: SitesControllerUpsertOperationalHoursData,
  ): CancelablePromise<SitesControllerUpsertOperationalHoursResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/sites/{id}/operational-hours",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardSitesTaggingService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static sitesTaggingControllerListTags(
    data: SitesTaggingControllerListTagsData,
  ): CancelablePromise<SitesTaggingControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/sites-tagging/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static sitesTaggingControllerCreateTags(
    data: SitesTaggingControllerCreateTagsData,
  ): CancelablePromise<SitesTaggingControllerCreateTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/sites-tagging/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignTagsResponseDto
   * @throws ApiError
   */
  public static sitesTaggingControllerAssignTags(
    data: SitesTaggingControllerAssignTagsData,
  ): CancelablePromise<SitesTaggingControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sites/sites-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignTagsResponseDto
   * @throws ApiError
   */
  public static sitesTaggingControllerUnassignTags(
    data: SitesTaggingControllerUnassignTagsData,
  ): CancelablePromise<SitesTaggingControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sites/sites-tagging/tagging",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static sitesTaggingControllerGetDetails(
    data: SitesTaggingControllerGetDetailsData,
  ): CancelablePromise<SitesTaggingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/sites-tagging/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: SitesTaggingControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static sitesTaggingControllerUpdateTag(
    data: SitesTaggingControllerUpdateTagData,
  ): CancelablePromise<SitesTaggingControllerUpdateTagResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/sites-tagging/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: SitesTaggingControllerUpdateTagResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static sitesTaggingControllerDeleteTag(
    data: SitesTaggingControllerDeleteTagData,
  ): CancelablePromise<SitesTaggingControllerDeleteTagResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sites/sites-tagging/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static sitesTaggingControllerMergeTagTo(
    data: SitesTaggingControllerMergeTagToData,
  ): CancelablePromise<SitesTaggingControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sites/sites-tagging/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static sitesTaggingControllerListSummaries(
    data: SitesTaggingControllerListSummariesData,
  ): CancelablePromise<SitesTaggingControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sites/sites-tagging/summaries",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class DashboardSlackService {
  /**
   * @param data The data for the request.
   * @param data.code
   * @param data.state
   * @returns unknown
   * @throws ApiError
   */
  public static slackControllerCallback(
    data: SlackControllerCallbackData,
  ): CancelablePromise<SlackControllerCallbackResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/slack/callback",
      query: {
        code: data.code,
        state: data.state,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static slackControllerGetSlackAuthUrl(
    data: SlackControllerGetSlackAuthUrlData,
  ): CancelablePromise<SlackControllerGetSlackAuthUrlResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/slack/auth-url",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static slackControllerGetGlobalSlackAuthUrl(
    data: SlackControllerGetGlobalSlackAuthUrlData,
  ): CancelablePromise<SlackControllerGetGlobalSlackAuthUrlResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/slack/global-auth-url",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static slackControllerTestRecurrenceNotification(
    data: SlackControllerTestRecurrenceNotificationData,
  ): CancelablePromise<SlackControllerTestRecurrenceNotificationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/slack/test/recurrence",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static slackControllerTestPartialResolveNotification(
    data: SlackControllerTestPartialResolveNotificationData,
  ): CancelablePromise<SlackControllerTestPartialResolveNotificationResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/slack/test/partial-resolve",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static slackControllerTestCreateAlert(
    data: SlackControllerTestCreateAlertData,
  ): CancelablePromise<SlackControllerTestCreateAlertResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/slack/test/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static slackControllerTestResolveAlert(
    data: SlackControllerTestResolveAlertData,
  ): CancelablePromise<SlackControllerTestResolveAlertResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/slack/test/resolve",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardStaticDatasetsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.fromDate
   * @param data.toDate
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerList(
    data: StaticDatasetsControllerListData,
  ): CancelablePromise<StaticDatasetsControllerListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/static-datasets",
      query: {
        fromDate: data.fromDate,
        toDate: data.toDate,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @returns DatasetMinimalDto
   * @throws ApiError
   */
  public static staticDatasetsControllerListMinimal(): CancelablePromise<StaticDatasetsControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/static-datasets/minimal",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StaticDatasetDetailsDto
   * @throws ApiError
   */
  public static staticDatasetsControllerGetDetails(
    data: StaticDatasetsControllerGetDetailsData,
  ): CancelablePromise<StaticDatasetsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/static-datasets/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        StaticDatasetsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerDelete(
    data: StaticDatasetsControllerDeleteData,
  ): CancelablePromise<StaticDatasetsControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/static-datasets/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerCountSamples(
    data: StaticDatasetsControllerCountSamplesData,
  ): CancelablePromise<StaticDatasetsControllerCountSamplesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/static-datasets/{id}/count-samples",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerAnalyze(
    data: StaticDatasetsControllerAnalyzeData,
  ): CancelablePromise<StaticDatasetsControllerAnalyzeResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/analyze",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerCreate(
    data: StaticDatasetsControllerCreateData,
  ): CancelablePromise<StaticDatasetsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/create",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerUpload(
    data: StaticDatasetsControllerUploadData,
  ): CancelablePromise<StaticDatasetsControllerUploadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerStart(
    data: StaticDatasetsControllerStartData,
  ): CancelablePromise<StaticDatasetsControllerStartResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/start",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerCreateEmpty(
    data: StaticDatasetsControllerCreateEmptyData,
  ): CancelablePromise<StaticDatasetsControllerCreateEmptyResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/create-empty",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerAddSamplesFromFilter(
    data: StaticDatasetsControllerAddSamplesFromFilterData,
  ): CancelablePromise<StaticDatasetsControllerAddSamplesFromFilterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/from-samples",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerRetryMissingSamples(
    data: StaticDatasetsControllerRetryMissingSamplesData,
  ): CancelablePromise<StaticDatasetsControllerRetryMissingSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/retry-missing",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerRecalculateAnalytics(
    data: StaticDatasetsControllerRecalculateAnalyticsData,
  ): CancelablePromise<StaticDatasetsControllerRecalculateAnalyticsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/recalculate-analytics",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerResumeFromSamples(
    data: StaticDatasetsControllerResumeFromSamplesData,
  ): CancelablePromise<StaticDatasetsControllerResumeFromSamplesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/resume-from-samples",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerAddSessionsFromFilter(
    data: StaticDatasetsControllerAddSessionsFromFilterData,
  ): CancelablePromise<StaticDatasetsControllerAddSessionsFromFilterResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/from-sessions",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerRetryMissingSessions(
    data: StaticDatasetsControllerRetryMissingSessionsData,
  ): CancelablePromise<StaticDatasetsControllerRetryMissingSessionsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/retry-missing-sessions",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static staticDatasetsControllerResumeFromSessions(
    data: StaticDatasetsControllerResumeFromSessionsData,
  ): CancelablePromise<StaticDatasetsControllerResumeFromSessionsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/static-datasets/{id}/resume-from-sessions",
      path: {
        id: data.id,
      },
    });
  }
}

export class DashboardSyncGroundTruthsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SyncGroundTruthsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerCreateSchedule(
    data: SyncGroundTruthsControllerCreateScheduleData,
  ): CancelablePromise<SyncGroundTruthsControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        SyncGroundTruthsControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static syncGroundTruthsControllerListScheduled(
    data: SyncGroundTruthsControllerListScheduledData,
  ): CancelablePromise<SyncGroundTruthsControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sync-ground-truths/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SyncGroundTruthsScheduledJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerGetScheduledJob(
    data: SyncGroundTruthsControllerGetScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        SyncGroundTruthsControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns SyncGroundTruthsScheduledJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerUpdateScheduledJob(
    data: SyncGroundTruthsControllerUpdateScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        SyncGroundTruthsControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static syncGroundTruthsControllerDeleteScheduledJob(
    data: SyncGroundTruthsControllerDeleteScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static syncGroundTruthsControllerCancelScheduledJobsBulk(
    data: SyncGroundTruthsControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static syncGroundTruthsControllerStopScheduledJobsBulk(
    data: SyncGroundTruthsControllerStopScheduledJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static syncGroundTruthsControllerResumeScheduledJobsBulk(
    data: SyncGroundTruthsControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static syncGroundTruthsControllerDeleteScheduledJobsBulk(
    data: SyncGroundTruthsControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SyncGroundTruthsJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerStartScheduledJob(
    data: SyncGroundTruthsControllerStartScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        SyncGroundTruthsControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static syncGroundTruthsControllerCancelScheduledJob(
    data: SyncGroundTruthsControllerCancelScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerStopScheduledJob(
    data: SyncGroundTruthsControllerStopScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SyncGroundTruthsScheduledJobSummaryDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerResumeScheduledJob(
    data: SyncGroundTruthsControllerResumeScheduledJobData,
  ): CancelablePromise<SyncGroundTruthsControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        SyncGroundTruthsControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SyncGroundTruthsJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerStartJob(
    data: SyncGroundTruthsControllerStartJobData,
  ): CancelablePromise<SyncGroundTruthsControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        SyncGroundTruthsControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static syncGroundTruthsControllerListSummaries(
    data: SyncGroundTruthsControllerListSummariesData,
  ): CancelablePromise<SyncGroundTruthsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sync-ground-truths/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns SyncGroundTruthsJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerGetJob(
    data: SyncGroundTruthsControllerGetJobData,
  ): CancelablePromise<SyncGroundTruthsControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: SyncGroundTruthsControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static syncGroundTruthsControllerDeleteJob(
    data: SyncGroundTruthsControllerDeleteJobData,
  ): CancelablePromise<SyncGroundTruthsControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns SyncGroundTruthsJobDto
   * @throws ApiError
   */
  public static syncGroundTruthsControllerUpdateJob(
    data: SyncGroundTruthsControllerUpdateJobData,
  ): CancelablePromise<SyncGroundTruthsControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        SyncGroundTruthsControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static syncGroundTruthsControllerCancelJob(
    data: SyncGroundTruthsControllerCancelJobData,
  ): CancelablePromise<SyncGroundTruthsControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static syncGroundTruthsControllerStopJob(
    data: SyncGroundTruthsControllerStopJobData,
  ): CancelablePromise<SyncGroundTruthsControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static syncGroundTruthsControllerCancelJobsBulk(
    data: SyncGroundTruthsControllerCancelJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static syncGroundTruthsControllerDeleteJobsBulk(
    data: SyncGroundTruthsControllerDeleteJobsBulkData,
  ): CancelablePromise<SyncGroundTruthsControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/sync-ground-truths/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardTagsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static tagsControllerListTags(
    data: TagsControllerListTagsData,
  ): CancelablePromise<TagsControllerListTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/tags",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static tagsControllerCreate(
    data: TagsControllerCreateData,
  ): CancelablePromise<TagsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static tagsControllerSetTags(
    data: TagsControllerSetTagsData,
  ): CancelablePromise<TagsControllerSetTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/set",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static tagsControllerDelete(
    data: TagsControllerDeleteData,
  ): CancelablePromise<TagsControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/tags/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static tagsControllerUpdate(
    data: TagsControllerUpdateData,
  ): CancelablePromise<TagsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/tags/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: TagsControllerUpdateResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TagDetailsDto
   * @throws ApiError
   */
  public static tagsControllerGetDetails(
    data: TagsControllerGetDetailsData,
  ): CancelablePromise<TagsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/tags/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: TagsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.mergedToId
   * @returns unknown
   * @throws ApiError
   */
  public static tagsControllerMergeTagTo(
    data: TagsControllerMergeTagToData,
  ): CancelablePromise<TagsControllerMergeTagToResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/tags/{id}/merge-to/{mergedToId}",
      path: {
        id: data.id,
        mergedToId: data.mergedToId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerAssignTags(
    data: TagsControllerAssignTagsData,
  ): CancelablePromise<TagsControllerAssignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/assign",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SetGroupSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerSetGroupTags(
    data: TagsControllerSetGroupTagsData,
  ): CancelablePromise<TagsControllerSetGroupTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/group/set",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns SetGroupSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerUpdateGroupTags(
    data: TagsControllerUpdateGroupTagsData,
  ): CancelablePromise<TagsControllerUpdateGroupTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/group/update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AssignGroupSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerAssignGroupTags(
    data: TagsControllerAssignGroupTagsData,
  ): CancelablePromise<TagsControllerAssignGroupTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/group/assign",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignGroupSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerUnassignGroupTags(
    data: TagsControllerUnassignGroupTagsData,
  ): CancelablePromise<TagsControllerUnassignGroupTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/group/unassign",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UnassignSampleTagsResponseDto
   * @throws ApiError
   */
  public static tagsControllerUnassignTags(
    data: TagsControllerUnassignTagsData,
  ): CancelablePromise<TagsControllerUnassignTagsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/tags/unassign",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardTrainingsService {
  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.sortBy
   * @param data.name
   * @param data.createdSince
   * @param data.from
   * @param data.to
   * @param data.isVisible
   * @returns unknown
   * @throws ApiError
   */
  public static trainingsControllerListSummaries(
    data: TrainingsControllerListSummariesData,
  ): CancelablePromise<TrainingsControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/summaries",
      query: {
        state: data.state,
        sortBy: data.sortBy,
        name: data.name,
        createdSince: data.createdSince,
        from: data.from,
        to: data.to,
        isVisible: data.isVisible,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * Declared before `:id` -- Nest matches routes in declaration order, so a literal path registered
   * after the param route would be swallowed by it (as `/summaries` above already relies on).
   * @returns TrainingDefaultsDto
   * @throws ApiError
   */
  public static trainingsControllerGetDefaults(): CancelablePromise<TrainingsControllerGetDefaultsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/defaults",
      responseTransformer: TrainingsControllerGetDefaultsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns TrainingDefaultsDto
   * @throws ApiError
   */
  public static trainingsControllerUpdateDefaults(
    data: TrainingsControllerUpdateDefaultsData,
  ): CancelablePromise<TrainingsControllerUpdateDefaultsResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/dashboard/trainings/defaults",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: TrainingsControllerUpdateDefaultsResponseTransformer,
    });
  }

  /**
   * @returns TrainingDefaultsDto
   * @throws ApiError
   */
  public static trainingsControllerClearDefaults(): CancelablePromise<TrainingsControllerClearDefaultsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/trainings/defaults",
      responseTransformer: TrainingsControllerClearDefaultsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TrainingDetailsDto
   * @throws ApiError
   */
  public static trainingsControllerGetDetails(
    data: TrainingsControllerGetDetailsData,
  ): CancelablePromise<TrainingsControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: TrainingsControllerGetDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static trainingsControllerUpdate(
    data: TrainingsControllerUpdateData,
  ): CancelablePromise<TrainingsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/trainings/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TrainingExecutionDetailsDto
   * @throws ApiError
   */
  public static trainingsControllerGetTrainingExecutionDetails(
    data: TrainingsControllerGetTrainingExecutionDetailsData,
  ): CancelablePromise<TrainingsControllerGetTrainingExecutionDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/{id}/execution-details",
      path: {
        id: data.id,
      },
      responseTransformer:
        TrainingsControllerGetTrainingExecutionDetailsResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TrainingParticipationsDto
   * @throws ApiError
   */
  public static trainingsControllerGetParticipations(
    data: TrainingsControllerGetParticipationsData,
  ): CancelablePromise<TrainingsControllerGetParticipationsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/{id}/participations",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns TrainingSampleStatsDto
   * @throws ApiError
   */
  public static trainingsControllerGetSampleStats(
    data: TrainingsControllerGetSampleStatsData,
  ): CancelablePromise<TrainingsControllerGetSampleStatsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/trainings/{id}/sample-stats",
      path: {
        id: data.id,
      },
      responseTransformer: TrainingsControllerGetSampleStatsResponseTransformer,
    });
  }

  /**
   * Bulk equivalent of `PATCH :id { isVisible: false }` - hides the selected trainings and cancels
   * the ones that are still running, exactly like the single-row delete does.
   *
   * Cancellation runs *before* hiding: a training we failed to cancel has to stay visible, or it
   * would keep running with no row in the table to stop it. Returns how many rows were hidden.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static trainingsControllerDeleteTrainingsBulk(
    data: TrainingsControllerDeleteTrainingsBulkData,
  ): CancelablePromise<TrainingsControllerDeleteTrainingsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/trainings/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Cancels every selected training that is still active. Returns how many were cancelled.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static trainingsControllerCancelTrainingsBulk(
    data: TrainingsControllerCancelTrainingsBulkData,
  ): CancelablePromise<TrainingsControllerCancelTrainingsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/trainings/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EntityIdDto
   * @throws ApiError
   */
  public static trainingsControllerCreateTraining(
    data: TrainingsControllerCreateTrainingData,
  ): CancelablePromise<TrainingsControllerCreateTrainingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/trainings",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static trainingsControllerCancelTraining(
    data: TrainingsControllerCancelTrainingData,
  ): CancelablePromise<TrainingsControllerCancelTrainingResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/trainings/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static trainingsControllerCreateModel(
    data: TrainingsControllerCreateModelData,
  ): CancelablePromise<TrainingsControllerCreateModelResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/trainings/{id}/create-model",
      path: {
        id: data.id,
      },
    });
  }
}

export class DashboardUploadSamplesService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UploadSamplesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static uploadSamplesControllerCreateSchedule(
    data: UploadSamplesControllerCreateScheduleData,
  ): CancelablePromise<UploadSamplesControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        UploadSamplesControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static uploadSamplesControllerListScheduled(
    data: UploadSamplesControllerListScheduledData,
  ): CancelablePromise<UploadSamplesControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-samples/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadSamplesScheduledJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerGetScheduledJob(
    data: UploadSamplesControllerGetScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadSamplesControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns UploadSamplesScheduledJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerUpdateScheduledJob(
    data: UploadSamplesControllerUpdateScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        UploadSamplesControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadSamplesControllerDeleteScheduledJob(
    data: UploadSamplesControllerDeleteScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static uploadSamplesControllerCancelScheduledJobsBulk(
    data: UploadSamplesControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static uploadSamplesControllerStopScheduledJobsBulk(
    data: UploadSamplesControllerStopScheduledJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static uploadSamplesControllerResumeScheduledJobsBulk(
    data: UploadSamplesControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static uploadSamplesControllerDeleteScheduledJobsBulk(
    data: UploadSamplesControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadSamplesJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerStartScheduledJob(
    data: UploadSamplesControllerStartScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadSamplesControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadSamplesControllerCancelScheduledJob(
    data: UploadSamplesControllerCancelScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static uploadSamplesControllerStopScheduledJob(
    data: UploadSamplesControllerStopScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadSamplesScheduledJobSummaryDto
   * @throws ApiError
   */
  public static uploadSamplesControllerResumeScheduledJob(
    data: UploadSamplesControllerResumeScheduledJobData,
  ): CancelablePromise<UploadSamplesControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadSamplesControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UploadSamplesJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerStartJob(
    data: UploadSamplesControllerStartJobData,
  ): CancelablePromise<UploadSamplesControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: UploadSamplesControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static uploadSamplesControllerListSummaries(
    data: UploadSamplesControllerListSummariesData,
  ): CancelablePromise<UploadSamplesControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-samples/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadSamplesJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerGetJob(
    data: UploadSamplesControllerGetJobData,
  ): CancelablePromise<UploadSamplesControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-samples/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: UploadSamplesControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadSamplesControllerDeleteJob(
    data: UploadSamplesControllerDeleteJobData,
  ): CancelablePromise<UploadSamplesControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/upload-samples/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns UploadSamplesJobDto
   * @throws ApiError
   */
  public static uploadSamplesControllerUpdateJob(
    data: UploadSamplesControllerUpdateJobData,
  ): CancelablePromise<UploadSamplesControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/upload-samples/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: UploadSamplesControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadSamplesControllerCancelJob(
    data: UploadSamplesControllerCancelJobData,
  ): CancelablePromise<UploadSamplesControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadSamplesControllerStopJob(
    data: UploadSamplesControllerStopJobData,
  ): CancelablePromise<UploadSamplesControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static uploadSamplesControllerCancelJobsBulk(
    data: UploadSamplesControllerCancelJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static uploadSamplesControllerDeleteJobsBulk(
    data: UploadSamplesControllerDeleteJobsBulkData,
  ): CancelablePromise<UploadSamplesControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-samples/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardUploadVideosService {
  /**
   * @returns StorageUriDto
   * @throws ApiError
   */
  public static uploadVideosControllerGetStorageUri(): CancelablePromise<UploadVideosControllerGetStorageUriResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-videos/uri",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UploadVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static uploadVideosControllerCreateSchedule(
    data: UploadVideosControllerCreateScheduleData,
  ): CancelablePromise<UploadVideosControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        UploadVideosControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static uploadVideosControllerListScheduled(
    data: UploadVideosControllerListScheduledData,
  ): CancelablePromise<UploadVideosControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-videos/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadVideosScheduledJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerGetScheduledJob(
    data: UploadVideosControllerGetScheduledJobData,
  ): CancelablePromise<UploadVideosControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadVideosControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns UploadVideosScheduledJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerUpdateScheduledJob(
    data: UploadVideosControllerUpdateScheduledJobData,
  ): CancelablePromise<UploadVideosControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        UploadVideosControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadVideosControllerDeleteScheduledJob(
    data: UploadVideosControllerDeleteScheduledJobData,
  ): CancelablePromise<UploadVideosControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static uploadVideosControllerCancelScheduledJobsBulk(
    data: UploadVideosControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<UploadVideosControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static uploadVideosControllerStopScheduledJobsBulk(
    data: UploadVideosControllerStopScheduledJobsBulkData,
  ): CancelablePromise<UploadVideosControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static uploadVideosControllerResumeScheduledJobsBulk(
    data: UploadVideosControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<UploadVideosControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static uploadVideosControllerDeleteScheduledJobsBulk(
    data: UploadVideosControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<UploadVideosControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadVideosJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerStartScheduledJob(
    data: UploadVideosControllerStartScheduledJobData,
  ): CancelablePromise<UploadVideosControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadVideosControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadVideosControllerCancelScheduledJob(
    data: UploadVideosControllerCancelScheduledJobData,
  ): CancelablePromise<UploadVideosControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static uploadVideosControllerStopScheduledJob(
    data: UploadVideosControllerStopScheduledJobData,
  ): CancelablePromise<UploadVideosControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadVideosScheduledJobSummaryDto
   * @throws ApiError
   */
  public static uploadVideosControllerResumeScheduledJob(
    data: UploadVideosControllerResumeScheduledJobData,
  ): CancelablePromise<UploadVideosControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        UploadVideosControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UploadVideosJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerStartJob(
    data: UploadVideosControllerStartJobData,
  ): CancelablePromise<UploadVideosControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: UploadVideosControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static uploadVideosControllerListSummaries(
    data: UploadVideosControllerListSummariesData,
  ): CancelablePromise<UploadVideosControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-videos/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns UploadVideosJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerGetJob(
    data: UploadVideosControllerGetJobData,
  ): CancelablePromise<UploadVideosControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/upload-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: UploadVideosControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadVideosControllerDeleteJob(
    data: UploadVideosControllerDeleteJobData,
  ): CancelablePromise<UploadVideosControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/upload-videos/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns UploadVideosJobDto
   * @throws ApiError
   */
  public static uploadVideosControllerUpdateJob(
    data: UploadVideosControllerUpdateJobData,
  ): CancelablePromise<UploadVideosControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/upload-videos/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: UploadVideosControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadVideosControllerCancelJob(
    data: UploadVideosControllerCancelJobData,
  ): CancelablePromise<UploadVideosControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static uploadVideosControllerStopJob(
    data: UploadVideosControllerStopJobData,
  ): CancelablePromise<UploadVideosControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static uploadVideosControllerCancelJobsBulk(
    data: UploadVideosControllerCancelJobsBulkData,
  ): CancelablePromise<UploadVideosControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static uploadVideosControllerDeleteJobsBulk(
    data: UploadVideosControllerDeleteJobsBulkData,
  ): CancelablePromise<UploadVideosControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/upload-videos/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardUsersService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerAssignSites(
    data: UsersControllerAssignSitesData,
  ): CancelablePromise<UsersControllerAssignSitesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users/assign-sites",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns UserDetailsDto
   * @throws ApiError
   */
  public static usersControllerMe(): CancelablePromise<UsersControllerMeResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/me",
      responseTransformer: UsersControllerMeResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerListEmails(
    data: UsersControllerListEmailsData,
  ): CancelablePromise<UsersControllerListEmailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/emails",
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @returns RelatedAccountDto
   * @throws ApiError
   */
  public static usersControllerRelatedAccounts(): CancelablePromise<UsersControllerRelatedAccountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/related-accounts",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerCheckUser(
    data: UsersControllerCheckUserData,
  ): CancelablePromise<UsersControllerCheckUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users/check-user",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerInviteUserToAccount(
    data: UsersControllerInviteUserToAccountData,
  ): CancelablePromise<UsersControllerInviteUserToAccountResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users/invite-user",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns CreateUserResponseDto
   * @throws ApiError
   */
  public static usersControllerCreate(
    data: UsersControllerCreateData,
  ): CancelablePromise<UsersControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.userIds
   * @param data.roles
   * @param data.excludeRoles
   * @param data.sortBy
   * @param data.id
   * @param data.firstName
   * @param data.lastName
   * @param data.company
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerFindAll(
    data: UsersControllerFindAllData,
  ): CancelablePromise<UsersControllerFindAllResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users",
      query: {
        userIds: data.userIds,
        roles: data.roles,
        excludeRoles: data.excludeRoles,
        sortBy: data.sortBy,
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        company: data.company,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.userIds
   * @param data.roles
   * @param data.excludeRoles
   * @param data.sortBy
   * @param data.id
   * @param data.firstName
   * @param data.lastName
   * @param data.company
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerListMinimal(
    data: UsersControllerListMinimalData,
  ): CancelablePromise<UsersControllerListMinimalResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/minimal",
      query: {
        userIds: data.userIds,
        roles: data.roles,
        excludeRoles: data.excludeRoles,
        sortBy: data.sortBy,
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        company: data.company,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static usersControllerDownload(
    data: UsersControllerDownloadData,
  ): CancelablePromise<UsersControllerDownloadResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users/download",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns RoleCreatePermissionDto
   * @throws ApiError
   */
  public static usersControllerGetRoleCreatePermission(): CancelablePromise<UsersControllerGetRoleCreatePermissionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/role-create-permission",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerFindOne(
    data: UsersControllerFindOneData,
  ): CancelablePromise<UsersControllerFindOneResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/users/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown
   * @throws ApiError
   */
  public static usersControllerRemove(
    data: UsersControllerRemoveData,
  ): CancelablePromise<UsersControllerRemoveResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/users/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns number
   * @throws ApiError
   */
  public static usersControllerUpdate(
    data: UsersControllerUpdateData,
  ): CancelablePromise<UsersControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/users/update",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.tableKey
   * @param data.requestBody
   * @returns UserSettingsDto
   * @throws ApiError
   */
  public static usersControllerUpdateTableSettings(
    data: UsersControllerUpdateTableSettingsData,
  ): CancelablePromise<UsersControllerUpdateTableSettingsResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/users/table-settings/{tableKey}",
      path: {
        tableKey: data.tableKey,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.tableKey
   * @returns UserSettingsDto
   * @throws ApiError
   */
  public static usersControllerDeleteTableSettings(
    data: UsersControllerDeleteTableSettingsData,
  ): CancelablePromise<UsersControllerDeleteTableSettingsResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/users/table-settings/{tableKey}",
      path: {
        tableKey: data.tableKey,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns number
   * @throws ApiError
   */
  public static usersControllerAdminUpdate(
    data: UsersControllerAdminUpdateData,
  ): CancelablePromise<UsersControllerAdminUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/users/admin-update",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number
   * @throws ApiError
   */
  public static usersControllerDeleteUsersBulk(
    data: UsersControllerDeleteUsersBulkData,
  ): CancelablePromise<UsersControllerDeleteUsersBulkResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/users/deleteUsersBulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns EmailSendOutcomeDto
   * @throws ApiError
   */
  public static usersControllerInviteUsersToReport(
    data: UsersControllerInviteUsersToReportData,
  ): CancelablePromise<UsersControllerInviteUsersToReportResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/users/invite-users",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class DashboardWorkerJobService {
  /**
   * @param data The data for the request.
   * @param data.jobType
   * @returns unknown
   * @throws ApiError
   */
  public static workerJobControllerGetJobInput(
    data: WorkerJobControllerGetJobInputData,
  ): CancelablePromise<WorkerJobControllerGetJobInputResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/job-input/{jobType}",
      path: {
        jobType: data.jobType,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.jobId
   * @param data.deviceId
   * @returns string
   * @throws ApiError
   */
  public static workerJobControllerGetToken(
    data: WorkerJobControllerGetTokenData,
  ): CancelablePromise<WorkerJobControllerGetTokenResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/{jobId}/token/{deviceId}",
      path: {
        jobId: data.jobId,
        deviceId: data.deviceId,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns WorkerJobScheduledJobSummaryDto
   * @throws ApiError
   */
  public static workerJobControllerCreateSchedule(
    data: WorkerJobControllerCreateScheduleData,
  ): CancelablePromise<WorkerJobControllerCreateScheduleResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: WorkerJobControllerCreateScheduleResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static workerJobControllerListScheduled(
    data: WorkerJobControllerListScheduledData,
  ): CancelablePromise<WorkerJobControllerListScheduledResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/schedule",
      query: {
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns WorkerJobScheduledJobDto
   * @throws ApiError
   */
  public static workerJobControllerGetScheduledJob(
    data: WorkerJobControllerGetScheduledJobData,
  ): CancelablePromise<WorkerJobControllerGetScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/schedule/{id}",
      path: {
        id: data.id,
      },
      responseTransformer:
        WorkerJobControllerGetScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @param data.partial allow partial update for data
   * @returns WorkerJobScheduledJobDto
   * @throws ApiError
   */
  public static workerJobControllerUpdateScheduledJob(
    data: WorkerJobControllerUpdateScheduledJobData,
  ): CancelablePromise<WorkerJobControllerUpdateScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/worker-job/schedule/{id}",
      path: {
        id: data.id,
      },
      query: {
        partial: data.partial,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer:
        WorkerJobControllerUpdateScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static workerJobControllerDeleteScheduledJob(
    data: WorkerJobControllerDeleteScheduledJobData,
  ): CancelablePromise<WorkerJobControllerDeleteScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/worker-job/schedule/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs cancelled
   * @throws ApiError
   */
  public static workerJobControllerCancelScheduledJobsBulk(
    data: WorkerJobControllerCancelScheduledJobsBulkData,
  ): CancelablePromise<WorkerJobControllerCancelScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs unscheduled
   * @throws ApiError
   */
  public static workerJobControllerStopScheduledJobsBulk(
    data: WorkerJobControllerStopScheduledJobsBulkData,
  ): CancelablePromise<WorkerJobControllerStopScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/stop-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs re-scheduled
   * @throws ApiError
   */
  public static workerJobControllerResumeScheduledJobsBulk(
    data: WorkerJobControllerResumeScheduledJobsBulkData,
  ): CancelablePromise<WorkerJobControllerResumeScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/resume-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of scheduled jobs deleted
   * @throws ApiError
   */
  public static workerJobControllerDeleteScheduledJobsBulk(
    data: WorkerJobControllerDeleteScheduledJobsBulkData,
  ): CancelablePromise<WorkerJobControllerDeleteScheduledJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns WorkerJobJobDto
   * @throws ApiError
   */
  public static workerJobControllerStartScheduledJob(
    data: WorkerJobControllerStartScheduledJobData,
  ): CancelablePromise<WorkerJobControllerStartScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/{id}/start",
      path: {
        id: data.id,
      },
      responseTransformer:
        WorkerJobControllerStartScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static workerJobControllerCancelScheduledJob(
    data: WorkerJobControllerCancelScheduledJobData,
  ): CancelablePromise<WorkerJobControllerCancelScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns StoppedScheduledDto
   * @throws ApiError
   */
  public static workerJobControllerStopScheduledJob(
    data: WorkerJobControllerStopScheduledJobData,
  ): CancelablePromise<WorkerJobControllerStopScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns WorkerJobScheduledJobSummaryDto
   * @throws ApiError
   */
  public static workerJobControllerResumeScheduledJob(
    data: WorkerJobControllerResumeScheduledJobData,
  ): CancelablePromise<WorkerJobControllerResumeScheduledJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/schedule/{id}/resume",
      path: {
        id: data.id,
      },
      responseTransformer:
        WorkerJobControllerResumeScheduledJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns WorkerJobJobDto
   * @throws ApiError
   */
  public static workerJobControllerStartJob(
    data: WorkerJobControllerStartJobData,
  ): CancelablePromise<WorkerJobControllerStartJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/start",
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: WorkerJobControllerStartJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.state
   * @param data.total Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   * @param data.done Filters on how many items the job actually completed.
   * @param data.sortBy
   * @param data.name
   * @param data.from
   * @param data.to
   * @returns unknown
   * @throws ApiError
   */
  public static workerJobControllerListSummaries(
    data: WorkerJobControllerListSummariesData,
  ): CancelablePromise<WorkerJobControllerListSummariesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/jobs",
      query: {
        state: data.state,
        total: data.total,
        done: data.done,
        sortBy: data.sortBy,
        name: data.name,
        from: data.from,
        to: data.to,
        limit: data.limit,
        page: data.page,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns WorkerJobJobDto
   * @throws ApiError
   */
  public static workerJobControllerGetJob(
    data: WorkerJobControllerGetJobData,
  ): CancelablePromise<WorkerJobControllerGetJobResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/worker-job/jobs/{id}",
      path: {
        id: data.id,
      },
      responseTransformer: WorkerJobControllerGetJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static workerJobControllerDeleteJob(
    data: WorkerJobControllerDeleteJobData,
  ): CancelablePromise<WorkerJobControllerDeleteJobResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v2/dashboard/worker-job/jobs/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @param data.requestBody
   * @returns WorkerJobJobDto
   * @throws ApiError
   */
  public static workerJobControllerUpdateJob(
    data: WorkerJobControllerUpdateJobData,
  ): CancelablePromise<WorkerJobControllerUpdateJobResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v2/dashboard/worker-job/jobs/{id}",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
      responseTransformer: WorkerJobControllerUpdateJobResponseTransformer,
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static workerJobControllerCancelJob(
    data: WorkerJobControllerCancelJobData,
  ): CancelablePromise<WorkerJobControllerCancelJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/jobs/{id}/cancel",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns boolean
   * @throws ApiError
   */
  public static workerJobControllerStopJob(
    data: WorkerJobControllerStopJobData,
  ): CancelablePromise<WorkerJobControllerStopJobResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/jobs/{id}/stop",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs cancelled
   * @throws ApiError
   */
  public static workerJobControllerCancelJobsBulk(
    data: WorkerJobControllerCancelJobsBulkData,
  ): CancelablePromise<WorkerJobControllerCancelJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/jobs/cancel-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns number Number of jobs deleted
   * @throws ApiError
   */
  public static workerJobControllerDeleteJobsBulk(
    data: WorkerJobControllerDeleteJobsBulkData,
  ): CancelablePromise<WorkerJobControllerDeleteJobsBulkResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/worker-job/jobs/delete-bulk",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EdgeDeviceFacingEndpointsAuthDeviceTokenService {
  /**
   * @param data The data for the request.
   * @param data.type
   * @param data.id
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static deviceControllerDownloadModel0(
    data: DeviceControllerDownloadModel0Data,
  ): CancelablePromise<DeviceControllerDownloadModel0Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/models/{id}/download/{type}",
      path: {
        type: data.type,
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.type
   * @param data.id
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static deviceControllerDownloadModel1(
    data: DeviceControllerDownloadModel1Data,
  ): CancelablePromise<DeviceControllerDownloadModel1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/edge/models/{id}/download/{type}",
      path: {
        type: data.type,
        id: data.id,
      },
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static deviceControllerGetCurrentTime0(): CancelablePromise<DeviceControllerGetCurrentTime0Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/clock",
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static deviceControllerGetCurrentTime1(): CancelablePromise<DeviceControllerGetCurrentTime1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/edge/clock",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSavePredictions0(): CancelablePromise<DeviceControllerSavePredictions0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/predictions",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSavePredictions1(): CancelablePromise<DeviceControllerSavePredictions1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/predictions",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveGroundTruths0(): CancelablePromise<DeviceControllerSaveGroundTruths0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/ground_truths",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveGroundTruths1(): CancelablePromise<DeviceControllerSaveGroundTruths1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/ground_truths",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveEvents0(): CancelablePromise<DeviceControllerSaveEvents0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/events",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveEvents1(): CancelablePromise<DeviceControllerSaveEvents1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/events",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveDataStream0(): CancelablePromise<DeviceControllerSaveDataStream0Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v2/edge/device_data_stream",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveDataStream1(): CancelablePromise<DeviceControllerSaveDataStream1Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/edge/device_data_stream",
    });
  }

  /**
   * @returns ClusterInfoDto
   * @throws ApiError
   */
  public static deviceControllerGetClusterInfo0(): CancelablePromise<DeviceControllerGetClusterInfo0Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/cluster",
    });
  }

  /**
   * @returns ClusterInfoDto
   * @throws ApiError
   */
  public static deviceControllerGetClusterInfo1(): CancelablePromise<DeviceControllerGetClusterInfo1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/edge/cluster",
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static deviceControllerGetLookupTable0(): CancelablePromise<DeviceControllerGetLookupTable0Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/lookupTable",
    });
  }

  /**
   * @returns string
   * @throws ApiError
   */
  public static deviceControllerGetLookupTable1(): CancelablePromise<DeviceControllerGetLookupTable1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/edge/lookupTable",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveVideo0(
    data: DeviceControllerSaveVideo0Data,
  ): CancelablePromise<DeviceControllerSaveVideo0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/video",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveVideo1(
    data: DeviceControllerSaveVideo1Data,
  ): CancelablePromise<DeviceControllerSaveVideo1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/video",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveImage0(
    data: DeviceControllerSaveImage0Data,
  ): CancelablePromise<DeviceControllerSaveImage0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/sample",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveImage1(
    data: DeviceControllerSaveImage1Data,
  ): CancelablePromise<DeviceControllerSaveImage1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/sample",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveLog0(): CancelablePromise<DeviceControllerSaveLog0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/logs",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static deviceControllerSaveLog1(): CancelablePromise<DeviceControllerSaveLog1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/logs",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.filename
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static deviceControllerDownloadAgent0(
    data: DeviceControllerDownloadAgent0Data,
  ): CancelablePromise<DeviceControllerDownloadAgent0Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/download-agent/{filename}",
      path: {
        filename: data.filename,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.filename
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static deviceControllerDownloadAgent1(
    data: DeviceControllerDownloadAgent1Data,
  ): CancelablePromise<DeviceControllerDownloadAgent1Response> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/edge/download-agent/{filename}",
      path: {
        filename: data.filename,
      },
    });
  }
}

export class EdgeDeviceJobDeviceJobFacingEndpointsAuthDeviceJobTokenService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static deviceJobsControllerUpdateStatus(
    data: DeviceJobsControllerUpdateStatusData,
  ): CancelablePromise<DeviceJobsControllerUpdateStatusResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/device-job/status",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EdgeDevicesDeviceRegistrationAuthAccountTokenService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static deviceRegistrationControllerRegisterDevice0(
    data: DeviceRegistrationControllerRegisterDevice0Data,
  ): CancelablePromise<DeviceRegistrationControllerRegisterDevice0Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/devices",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns string
   * @throws ApiError
   */
  public static deviceRegistrationControllerRegisterDevice1(
    data: DeviceRegistrationControllerRegisterDevice1Data,
  ): CancelablePromise<DeviceRegistrationControllerRegisterDevice1Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/edge/devices",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class EdgeTrainingTrainerFacingEndpointsAuthTrainingParticipationTokenService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerGetDetails(): CancelablePromise<TrainingControllerGetDetailsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/training",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerUpdateTrainingDeviceState(
    data: TrainingControllerUpdateTrainingDeviceStateData,
  ): CancelablePromise<TrainingControllerUpdateTrainingDeviceStateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/training/device_state",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerCreateMetric(): CancelablePromise<TrainingControllerCreateMetricResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/training/metrics",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.type
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerGetMetric(
    data: TrainingControllerGetMetricData,
  ): CancelablePromise<TrainingControllerGetMetricResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/training/metrics/{type}",
      path: {
        type: data.type,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.type
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerGetPreTrainedModelMetric(
    data: TrainingControllerGetPreTrainedModelMetricData,
  ): CancelablePromise<TrainingControllerGetPreTrainedModelMetricResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/training/pre_trained_model_metrics/{type}",
      path: {
        type: data.type,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static trainingControllerCreateCheckpoint(
    data: TrainingControllerCreateCheckpointData,
  ): CancelablePromise<TrainingControllerCreateCheckpointResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/edge/training/checkpoint",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static trainingControllerDownloadCheckpoint(): CancelablePromise<TrainingControllerDownloadCheckpointResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/training/checkpoint",
    });
  }

  /**
   * @returns LoggedStreamableFile
   * @throws ApiError
   */
  public static trainingControllerDownloadPreTrainedModel(): CancelablePromise<TrainingControllerDownloadPreTrainedModelResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/edge/training/pre_trained_model",
    });
  }
}

export class EventsService {
  /**
   * @param data The data for the request.
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.name
   * @param data.logLevel
   * @param data.timeField
   * @param data.fromDate
   * @param data.toDate
   * @param data.text
   * @returns number
   * @throws ApiError
   */
  public static eventsControllerListEventsCount(
    data: EventsControllerListEventsCountData = {},
  ): CancelablePromise<EventsControllerListEventsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/events/count",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        name: data.name,
        logLevel: data.logLevel,
        timeField: data.timeField,
        fromDate: data.fromDate,
        toDate: data.toDate,
        text: data.text,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @param data.deviceIds
   * @param data.clusterIds
   * @param data.siteIds
   * @param data.name
   * @param data.logLevel
   * @param data.timeField
   * @param data.fromDate
   * @param data.toDate
   * @param data.text
   * @returns unknown
   * @throws ApiError
   */
  public static eventsControllerListEvents(
    data: EventsControllerListEventsData,
  ): CancelablePromise<EventsControllerListEventsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/events",
      query: {
        deviceIds: data.deviceIds,
        clusterIds: data.clusterIds,
        siteIds: data.siteIds,
        name: data.name,
        logLevel: data.logLevel,
        timeField: data.timeField,
        limit: data.limit,
        page: data.page,
        fromDate: data.fromDate,
        toDate: data.toDate,
        text: data.text,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static eventsControllerCreate(
    data: EventsControllerCreateData,
  ): CancelablePromise<EventsControllerCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/dashboard/events",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.limit
   * @param data.page
   * @returns unknown
   * @throws ApiError
   */
  public static eventsControllerListEventNames(
    data: EventsControllerListEventNamesData,
  ): CancelablePromise<EventsControllerListEventNamesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/events/names",
      query: {
        limit: data.limit,
        page: data.page,
      },
    });
  }
}

export class HealthService {
  /**
   * @returns unknown The Health Check is successful
   * @throws ApiError
   */
  public static healthControllerDetailedCheck(): CancelablePromise<HealthControllerDetailedCheckResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/health/detailed",
      errors: {
        503: "The Health Check is not successful",
      },
    });
  }

  /**
   * @returns unknown The Health Check is successful
   * @throws ApiError
   */
  public static healthControllerCheck(): CancelablePromise<HealthControllerCheckResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/health",
      errors: {
        503: "The Health Check is not successful",
      },
    });
  }
}

export class McpToolsService {
  /**
   * @returns unknown Platform aggregate counts for the account within the default 30-day window
   * @throws ApiError
   */
  public static mcpToolsControllerGetOverview(): CancelablePromise<McpToolsControllerGetOverviewResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/overview",
    });
  }

  /**
   * @returns unknown Model summaries with accuracy and deployment info
   * @throws ApiError
   */
  public static mcpToolsControllerGetModels(): CancelablePromise<McpToolsControllerGetModelsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/models",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Model details including confusion matrix and epoch metrics
   * @throws ApiError
   */
  public static mcpToolsControllerGetModelById(
    data: McpToolsControllerGetModelByIdData,
  ): CancelablePromise<McpToolsControllerGetModelByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/models/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @returns unknown Device summaries with state and last ping
   * @throws ApiError
   */
  public static mcpToolsControllerGetDevices(): CancelablePromise<McpToolsControllerGetDevicesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/devices",
    });
  }

  /**
   * @returns unknown Count of devices grouped by state (ready, offline, etc.)
   * @throws ApiError
   */
  public static mcpToolsControllerGetDeviceStateCounts(): CancelablePromise<McpToolsControllerGetDeviceStateCountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/devices/state-counts",
    });
  }

  /**
   * @returns unknown Cluster summaries with device counts
   * @throws ApiError
   */
  public static mcpToolsControllerGetClusters(): CancelablePromise<McpToolsControllerGetClustersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/clusters",
    });
  }

  /**
   * @returns unknown Dataset summaries with sample counts
   * @throws ApiError
   */
  public static mcpToolsControllerGetDatasets(): CancelablePromise<McpToolsControllerGetDatasetsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/datasets",
    });
  }

  /**
   * @returns unknown Training summaries within the default 30-day window
   * @throws ApiError
   */
  public static mcpToolsControllerGetTrainings(): CancelablePromise<McpToolsControllerGetTrainingsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/trainings",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Training details with epoch metrics and confusion matrix
   * @throws ApiError
   */
  public static mcpToolsControllerGetTrainingById(
    data: McpToolsControllerGetTrainingByIdData,
  ): CancelablePromise<McpToolsControllerGetTrainingByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/trainings/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @returns unknown Label distribution counts within the default 30-day window
   * @throws ApiError
   */
  public static mcpToolsControllerGetLabelDistribution(): CancelablePromise<McpToolsControllerGetLabelDistributionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/label-distribution",
    });
  }

  /**
   * @returns unknown Paginated sample list within the default 30-day window, with device and tag info.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSamples(): CancelablePromise<McpToolsControllerGetSamplesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/samples",
    });
  }

  /**
   * @returns unknown Sample count within the default 30-day window. Use ?includeLatest=true for real-time data.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSamplesCount(): CancelablePromise<McpToolsControllerGetSamplesCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/samples/count",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.uuid
   * @returns unknown Full details of a single sample by UUID.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSampleByUuid(
    data: McpToolsControllerGetSampleByUuidData,
  ): CancelablePromise<McpToolsControllerGetSampleByUuidResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/samples/by-uuid/{uuid}",
      path: {
        uuid: data.uuid,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.epc
   * @returns unknown Find JSON-type samples whose EPC field matches the given value. Searches within the default 30-day window.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSamplesByEpc(
    data: McpToolsControllerGetSamplesByEpcData,
  ): CancelablePromise<McpToolsControllerGetSamplesByEpcResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/samples/by-epc/{epc}",
      path: {
        epc: data.epc,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Full details of a single sample by numeric ID.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSampleById(
    data: McpToolsControllerGetSampleByIdData,
  ): CancelablePromise<McpToolsControllerGetSampleByIdResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/samples/{id}",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @returns unknown Prediction count within the default 30-day window. Use ?includeLatest=true for real-time data.
   * @throws ApiError
   */
  public static mcpToolsControllerGetPredictionsCount(): CancelablePromise<McpToolsControllerGetPredictionsCountResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/predictions/count",
    });
  }

  /**
   * @returns unknown Managed alerts within the default 30-day window
   * @throws ApiError
   */
  public static mcpToolsControllerGetAlerts(): CancelablePromise<McpToolsControllerGetAlertsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/alerts",
    });
  }

  /**
   * @returns unknown Sample tag names for the account (checkpoint/station labels applied to individual scans).
   * @throws ApiError
   */
  public static mcpToolsControllerGetSampleTags(): CancelablePromise<McpToolsControllerGetSampleTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/sample-tags",
    });
  }

  /**
   * @returns unknown Session tag names for the account (labels applied to item journey sessions).
   * @throws ApiError
   */
  public static mcpToolsControllerGetSessionTags(): CancelablePromise<McpToolsControllerGetSessionTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/session-tags",
    });
  }

  /**
   * @returns unknown Device tag names for the account (labels applied to devices).
   * @throws ApiError
   */
  public static mcpToolsControllerGetDeviceTags(): CancelablePromise<McpToolsControllerGetDeviceTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/device-tags",
    });
  }

  /**
   * @returns unknown Site tag names for the account (labels applied to sites/locations).
   * @throws ApiError
   */
  public static mcpToolsControllerGetSiteTags(): CancelablePromise<McpToolsControllerGetSiteTagsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/site-tags",
    });
  }

  /**
   * @returns unknown Item journey sessions within the default 30-day window, with session tags and sample count.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSessions(): CancelablePromise<McpToolsControllerGetSessionsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/sessions",
    });
  }

  /**
   * @returns unknown Account list with id and name, scoped by MCP account policy. Use ?name= for partial-match filtering.
   * @throws ApiError
   */
  public static mcpToolsControllerGetAccounts(): CancelablePromise<McpToolsControllerGetAccountsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/accounts",
    });
  }

  /**
   * @returns unknown Account context with resolved timezone and working-hours source metadata.
   * @throws ApiError
   */
  public static mcpToolsControllerGetAccountContext(): CancelablePromise<McpToolsControllerGetAccountContextResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/accounts/context",
    });
  }

  /**
   * @returns unknown Site-group list with pagination and optional name filter.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSiteGroups(): CancelablePromise<McpToolsControllerGetSiteGroupsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/site-groups",
    });
  }

  /**
   * @returns unknown Site list with pagination, optional name filter, and coordinates.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSites(): CancelablePromise<McpToolsControllerGetSitesResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/sites",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Site-group context with resolved timezone and working-hours source metadata.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSiteGroupContext(
    data: McpToolsControllerGetSiteGroupContextData,
  ): CancelablePromise<McpToolsControllerGetSiteGroupContextResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/site-groups/{id}/context",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Site context with resolved timezone and working-hours source metadata and coordinates.
   * @throws ApiError
   */
  public static mcpToolsControllerGetSiteContext(
    data: McpToolsControllerGetSiteContextData,
  ): CancelablePromise<McpToolsControllerGetSiteContextResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/sites/{id}/context",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id
   * @returns unknown Device context with resolved timezone and working-hours source metadata.
   * @throws ApiError
   */
  public static mcpToolsControllerGetDeviceContext(
    data: McpToolsControllerGetDeviceContextData,
  ): CancelablePromise<McpToolsControllerGetDeviceContextResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/devices/{id}/context",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.xApiKey
   * @returns unknown Returns reachability status. Validates the API key when x-api-key is present.
   * @throws ApiError
   */
  public static mcpPingControllerPing(
    data: McpPingControllerPingData,
  ): CancelablePromise<McpPingControllerPingResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/mcp/ping",
      headers: {
        "x-api-key": data.xApiKey,
      },
    });
  }
}

export class PublicDgTrimTransactionDollarGeneralTransactionTrimmingAuthAccountTokenService {
  /**
   * @param data The data for the request.
   * @param data.formData XML file containing transaction details
   * @returns unknown
   * @throws ApiError
   */
  public static dgTransactionControllerTrimTransaction(
    data: DgTransactionControllerTrimTransactionData,
  ): CancelablePromise<DgTransactionControllerTrimTransactionResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v2/public/dg-trim-transaction",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }
}

export class VersionService {
  /**
   * @returns string
   * @throws ApiError
   */
  public static versionControllerVersion(): CancelablePromise<VersionControllerVersionResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v2/dashboard/version",
    });
  }
}
